import React from "react";

type IconProps = React.SVGProps<SVGSVGElement> & {
  pathFill?: string;
  className?: string;
  isOpen?: boolean;
};

const headerLogoIcon = (props: IconProps) => (
  <svg
    width="201"
    height="34"
    viewBox="0 0 201 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.07956 18.3135C6.07956 18.3135 1.35197 24.3841 3.82833 26.4078C3.82833 26.4078 4.72882 26.8576 6.75494 26.6326C13.2835 25.7334 29.4926 13.8166 35.1208 8.87011L34.2202 6.39685L43 7.74589L40.0735 16.5148L38.2724 14.0415C38.2724 14.0415 21.6131 27.5321 8.33081 30.6797C8.33081 30.6797 -7.42789 33.8277 5.85445 18.3135H6.07956Z"
      fill="currenColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.44122 13.0463H14.3488V22.4425C12.3434 23.7848 9.89228 24.6797 7.44122 25.5745V13.0463Z"
      fill="currenColor"
      fillOpacity="0.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.663 6.39685H23.5705V16.5077L16.663 21.2262V6.39685Z"
      fill="currenColor"
      fillOpacity="0.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.8595 -0.000366211H32.7671V9.68111L25.8595 15.0847V-0.000366211Z"
      fill="currenColor"
      fillOpacity="0.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.5149 33.2467H25.6073V24.2128L32.5149 19.6957V33.2467Z"
      fill="currenColor"
      fillOpacity="0.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.5705 33.2287H16.663V28.9259L23.5705 25.3027V33.2287Z"
      fill="currenColor"
      fillOpacity="0.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3488 33.2416H7.44122V31.9121C9.001 31.9121 12.3434 30.8042 14.3488 29.9178V33.2416Z"
      fill="currenColor"
      fillOpacity="0.5"
    />
    <path
      d="M71.5195 25.1232H67.043V13.4396L63.8086 21.0216H60.7031L57.4688 13.4396V25.1232H53.2266V7.67395H58.4531L62.3789 16.4279L66.293 7.67395H71.5195V25.1232ZM79.6914 20.4708L82.6914 11.963H87.0273L79.7148 29.9513H75.1445L77.2305 25.0294L72.1094 11.963H76.5391L79.6914 20.4708ZM101.586 19.6388C101.586 21.3575 100.855 22.756 99.3945 23.8341C97.9414 24.9044 95.9648 25.4396 93.4648 25.4396C92.0195 25.4396 90.7578 25.3146 89.6797 25.0646C88.6094 24.8068 87.6055 24.4825 86.668 24.0919V19.9083H87.1602C88.0898 20.6505 89.1289 21.2208 90.2773 21.6193C91.4336 22.0177 92.543 22.2169 93.6055 22.2169C93.8789 22.2169 94.2383 22.1935 94.6836 22.1466C95.1289 22.0997 95.4922 22.0216 95.7734 21.9122C96.1172 21.7716 96.3984 21.5958 96.6172 21.3849C96.8438 21.174 96.957 20.8615 96.957 20.4474C96.957 20.0646 96.793 19.7365 96.4648 19.463C96.1445 19.1818 95.6719 18.9669 95.0469 18.8185C94.3906 18.6622 93.6953 18.5177 92.9609 18.3849C92.2344 18.2443 91.5508 18.0685 90.9102 17.8575C89.4414 17.381 88.3828 16.7365 87.7344 15.924C87.0938 15.1036 86.7734 14.088 86.7734 12.8771C86.7734 11.2521 87.5 9.92786 88.9531 8.90442C90.4141 7.87317 92.2891 7.35754 94.5781 7.35754C95.7266 7.35754 96.8594 7.47083 97.9766 7.69739C99.1016 7.91614 100.074 8.19348 100.895 8.52942V12.549H100.414C99.7109 11.9865 98.8477 11.5177 97.8242 11.1427C96.8086 10.7599 95.7695 10.5685 94.707 10.5685C94.332 10.5685 93.957 10.5958 93.582 10.6505C93.2148 10.6974 92.8594 10.7911 92.5156 10.9318C92.2109 11.049 91.9492 11.2286 91.7305 11.4708C91.5117 11.7052 91.4023 11.9747 91.4023 12.2794C91.4023 12.7404 91.5781 13.0958 91.9297 13.3458C92.2812 13.588 92.9453 13.8107 93.9219 14.0138C94.5625 14.1466 95.1758 14.2755 95.7617 14.4005C96.3555 14.5255 96.9922 14.6974 97.6719 14.9161C99.0078 15.3536 99.9922 15.9513 100.625 16.7091C101.266 17.4591 101.586 18.4357 101.586 19.6388ZM112.113 25.1232H101.895V22.0294H104.754V10.7677H101.895V7.67395H112.113V10.7677H109.254V22.0294H112.113V25.1232ZM128.184 13.1818C128.184 13.963 128.047 14.7286 127.773 15.4786C127.5 16.2208 127.109 16.8458 126.602 17.3536C125.906 18.0411 125.129 18.5607 124.27 18.9122C123.418 19.2638 122.355 19.4396 121.082 19.4396H118.281V25.1232H113.781V7.67395H121.188C122.297 7.67395 123.23 7.77161 123.988 7.96692C124.754 8.15442 125.43 8.43958 126.016 8.82239C126.719 9.28333 127.254 9.87317 127.621 10.5919C127.996 11.3107 128.184 12.174 128.184 13.1818ZM123.531 13.2872C123.531 12.795 123.398 12.3732 123.133 12.0216C122.867 11.6622 122.559 11.4122 122.207 11.2716C121.738 11.0841 121.281 10.9825 120.836 10.9669C120.391 10.9435 119.797 10.9318 119.055 10.9318H118.281V16.1583H119.57C120.336 16.1583 120.965 16.1115 121.457 16.0177C121.957 15.924 122.375 15.7365 122.711 15.4552C123 15.2052 123.207 14.9083 123.332 14.5646C123.465 14.213 123.531 13.7872 123.531 13.2872ZM142.602 18.549C142.602 20.713 141.969 22.42 140.703 23.67C139.445 24.9122 137.676 25.5333 135.395 25.5333C133.113 25.5333 131.34 24.9122 130.074 23.67C128.816 22.42 128.188 20.713 128.188 18.549C128.188 16.3693 128.82 14.6583 130.086 13.4161C131.359 12.174 133.129 11.5529 135.395 11.5529C137.691 11.5529 139.465 12.1779 140.715 13.4279C141.973 14.6779 142.602 16.3849 142.602 18.549ZM137.41 21.7482C137.684 21.4122 137.887 21.0099 138.02 20.5411C138.16 20.0646 138.23 19.4083 138.23 18.5724C138.23 17.799 138.16 17.1505 138.02 16.6271C137.879 16.1036 137.684 15.6857 137.434 15.3732C137.184 15.0529 136.883 14.8263 136.531 14.6935C136.18 14.5607 135.801 14.4943 135.395 14.4943C134.988 14.4943 134.625 14.549 134.305 14.6583C133.992 14.7677 133.691 14.9865 133.402 15.3146C133.145 15.6193 132.938 16.0372 132.781 16.5685C132.633 17.0997 132.559 17.7677 132.559 18.5724C132.559 19.2911 132.625 19.9161 132.758 20.4474C132.891 20.9708 133.086 21.3927 133.344 21.713C133.594 22.0177 133.891 22.2404 134.234 22.381C134.586 22.5216 134.984 22.5919 135.43 22.5919C135.812 22.5919 136.176 22.5294 136.52 22.4044C136.871 22.2716 137.168 22.0529 137.41 21.7482ZM156.844 25.1232H152.602V18.5958C152.602 18.0646 152.574 17.5372 152.52 17.0138C152.465 16.4825 152.371 16.0919 152.238 15.8419C152.082 15.5529 151.852 15.3419 151.547 15.2091C151.25 15.0763 150.832 15.0099 150.293 15.0099C149.91 15.0099 149.52 15.0724 149.121 15.1974C148.73 15.3224 148.305 15.5216 147.844 15.795V25.1232H143.625V11.963H147.844V13.4161C148.594 12.8302 149.312 12.381 150 12.0685C150.695 11.756 151.465 11.5997 152.309 11.5997C153.73 11.5997 154.84 12.0138 155.637 12.8419C156.441 13.67 156.844 14.9083 156.844 16.5568V25.1232ZM162.953 25.1232H158.734V6.88879H162.953V25.1232ZM169.156 25.1232H164.938V11.963H169.156V25.1232ZM169.273 10.088H164.82V6.88879H169.273V10.088ZM184.359 25.1232H180.117V18.5958C180.117 18.0646 180.09 17.5372 180.035 17.0138C179.98 16.4825 179.887 16.0919 179.754 15.8419C179.598 15.5529 179.367 15.3419 179.062 15.2091C178.766 15.0763 178.348 15.0099 177.809 15.0099C177.426 15.0099 177.035 15.0724 176.637 15.1974C176.246 15.3224 175.82 15.5216 175.359 15.795V25.1232H171.141V11.963H175.359V13.4161C176.109 12.8302 176.828 12.381 177.516 12.0685C178.211 11.756 178.98 11.5997 179.824 11.5997C181.246 11.5997 182.355 12.0138 183.152 12.8419C183.957 13.67 184.359 14.9083 184.359 16.5568V25.1232ZM199.211 19.3224H189.555C189.617 20.3536 190.008 21.1427 190.727 21.6896C191.453 22.2365 192.52 22.5099 193.926 22.5099C194.816 22.5099 195.68 22.3497 196.516 22.0294C197.352 21.7091 198.012 21.3654 198.496 20.9982H198.965V24.3849C198.012 24.7677 197.113 25.045 196.27 25.2169C195.426 25.3888 194.492 25.4747 193.469 25.4747C190.828 25.4747 188.805 24.881 187.398 23.6935C185.992 22.506 185.289 20.8146 185.289 18.6193C185.289 16.4474 185.953 14.7286 187.281 13.463C188.617 12.1896 190.445 11.5529 192.766 11.5529C194.906 11.5529 196.516 12.0958 197.594 13.1818C198.672 14.2599 199.211 15.8146 199.211 17.8458V19.3224ZM195.016 16.8497C194.992 15.9669 194.773 15.3029 194.359 14.8575C193.945 14.4122 193.301 14.1896 192.426 14.1896C191.613 14.1896 190.945 14.4005 190.422 14.8224C189.898 15.2443 189.605 15.92 189.543 16.8497H195.016Z"
      fill="currenColor"
    />
  </svg>
);

const headerNewLogoIcon = (props: IconProps) => (
  <svg
    width="201"
    height="34"
    viewBox="0 0 201 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.07956 18.3159C6.07956 18.3159 1.35197 24.3865 3.82833 26.4102C3.82833 26.4102 4.72882 26.86 6.75494 26.635C13.2835 25.7357 29.4926 13.819 35.1208 8.87249L34.2202 6.39923L43 7.74827L40.0735 16.5172L38.2724 14.0439C38.2724 14.0439 21.6131 27.5344 8.33081 30.6821C8.33081 30.6821 -7.42789 33.83 5.85445 18.3159H6.07956Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.44128 13.0486H14.3489V22.4449C12.3434 23.7872 9.89235 24.6821 7.44128 25.5769V13.0486Z"
      fill="#1EC400"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.663 6.39923H23.5705V16.5101L16.663 21.2286V6.39923Z"
      fill="#1EC400"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.8595 0.00201416H32.7671V9.68349L25.8595 15.0871V0.00201416Z"
      fill="#1EC400"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.5149 33.2491H25.6073V24.2151L32.5149 19.6981V33.2491Z"
      fill="#B5B5B5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.5705 33.2311H16.663V28.9283L23.5705 25.3051V33.2311Z"
      fill="#B5B5B5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.3489 33.244H7.44128V31.9145C9.00106 31.9145 12.3434 30.8066 14.3489 29.9202V33.244Z"
      fill="#B5B5B5"
    />
    <path
      d="M71.5195 25.1255H67.043V13.442L63.8086 21.024H60.7031L57.4688 13.442V25.1255H53.2266V7.67633H58.4531L62.3789 16.4302L66.293 7.67633H71.5195V25.1255ZM79.6914 20.4732L82.6914 11.9654H87.0273L79.7148 29.9537H75.1445L77.2305 25.0318L72.1094 11.9654H76.5391L79.6914 20.4732ZM101.586 19.6412C101.586 21.3599 100.855 22.7584 99.3945 23.8365C97.9414 24.9068 95.9648 25.442 93.4648 25.442C92.0195 25.442 90.7578 25.317 89.6797 25.067C88.6094 24.8091 87.6055 24.4849 86.668 24.0943V19.9107H87.1602C88.0898 20.6529 89.1289 21.2232 90.2773 21.6216C91.4336 22.0201 92.543 22.2193 93.6055 22.2193C93.8789 22.2193 94.2383 22.1959 94.6836 22.149C95.1289 22.1021 95.4922 22.024 95.7734 21.9146C96.1172 21.774 96.3984 21.5982 96.6172 21.3873C96.8438 21.1763 96.957 20.8638 96.957 20.4498C96.957 20.067 96.793 19.7388 96.4648 19.4654C96.1445 19.1841 95.6719 18.9693 95.0469 18.8209C94.3906 18.6646 93.6953 18.5201 92.9609 18.3873C92.2344 18.2466 91.5508 18.0709 90.9102 17.8599C89.4414 17.3834 88.3828 16.7388 87.7344 15.9263C87.0938 15.106 86.7734 14.0904 86.7734 12.8795C86.7734 11.2545 87.5 9.93024 88.9531 8.9068C90.4141 7.87555 92.2891 7.35992 94.5781 7.35992C95.7266 7.35992 96.8594 7.47321 97.9766 7.69977C99.1016 7.91852 100.074 8.19586 100.895 8.5318V12.5513H100.414C99.7109 11.9888 98.8477 11.5201 97.8242 11.1451C96.8086 10.7623 95.7695 10.5709 94.707 10.5709C94.332 10.5709 93.957 10.5982 93.582 10.6529C93.2148 10.6998 92.8594 10.7935 92.5156 10.9341C92.2109 11.0513 91.9492 11.231 91.7305 11.4732C91.5117 11.7076 91.4023 11.9771 91.4023 12.2818C91.4023 12.7427 91.5781 13.0982 91.9297 13.3482C92.2812 13.5904 92.9453 13.813 93.9219 14.0162C94.5625 14.149 95.1758 14.2779 95.7617 14.4029C96.3555 14.5279 96.9922 14.6998 97.6719 14.9185C99.0078 15.356 99.9922 15.9537 100.625 16.7115C101.266 17.4615 101.586 18.438 101.586 19.6412ZM112.113 25.1255H101.895V22.0318H104.754V10.7701H101.895V7.67633H112.113V10.7701H109.254V22.0318H112.113V25.1255ZM128.184 13.1841C128.184 13.9654 128.047 14.731 127.773 15.481C127.5 16.2232 127.109 16.8482 126.602 17.356C125.906 18.0435 125.129 18.563 124.27 18.9146C123.418 19.2662 122.355 19.442 121.082 19.442H118.281V25.1255H113.781V7.67633H121.188C122.297 7.67633 123.23 7.77399 123.988 7.9693C124.754 8.1568 125.43 8.44196 126.016 8.82477C126.719 9.28571 127.254 9.87555 127.621 10.5943C127.996 11.313 128.184 12.1763 128.184 13.1841ZM123.531 13.2896C123.531 12.7974 123.398 12.3755 123.133 12.024C122.867 11.6646 122.559 11.4146 122.207 11.274C121.738 11.0865 121.281 10.9849 120.836 10.9693C120.391 10.9459 119.797 10.9341 119.055 10.9341H118.281V16.1607H119.57C120.336 16.1607 120.965 16.1138 121.457 16.0201C121.957 15.9263 122.375 15.7388 122.711 15.4576C123 15.2076 123.207 14.9107 123.332 14.567C123.465 14.2154 123.531 13.7896 123.531 13.2896ZM142.602 18.5513C142.602 20.7154 141.969 22.4224 140.703 23.6724C139.445 24.9146 137.676 25.5357 135.395 25.5357C133.113 25.5357 131.34 24.9146 130.074 23.6724C128.816 22.4224 128.188 20.7154 128.188 18.5513C128.188 16.3716 128.82 14.6607 130.086 13.4185C131.359 12.1763 133.129 11.5552 135.395 11.5552C137.691 11.5552 139.465 12.1802 140.715 13.4302C141.973 14.6802 142.602 16.3873 142.602 18.5513ZM137.41 21.7505C137.684 21.4146 137.887 21.0123 138.02 20.5435C138.16 20.067 138.23 19.4107 138.23 18.5748C138.23 17.8013 138.16 17.1529 138.02 16.6295C137.879 16.106 137.684 15.688 137.434 15.3755C137.184 15.0552 136.883 14.8287 136.531 14.6959C136.18 14.563 135.801 14.4966 135.395 14.4966C134.988 14.4966 134.625 14.5513 134.305 14.6607C133.992 14.7701 133.691 14.9888 133.402 15.317C133.145 15.6216 132.938 16.0396 132.781 16.5709C132.633 17.1021 132.559 17.7701 132.559 18.5748C132.559 19.2935 132.625 19.9185 132.758 20.4498C132.891 20.9732 133.086 21.3951 133.344 21.7154C133.594 22.0201 133.891 22.2427 134.234 22.3834C134.586 22.524 134.984 22.5943 135.43 22.5943C135.812 22.5943 136.176 22.5318 136.52 22.4068C136.871 22.274 137.168 22.0552 137.41 21.7505ZM156.844 25.1255H152.602V18.5982C152.602 18.067 152.574 17.5396 152.52 17.0162C152.465 16.4849 152.371 16.0943 152.238 15.8443C152.082 15.5552 151.852 15.3443 151.547 15.2115C151.25 15.0787 150.832 15.0123 150.293 15.0123C149.91 15.0123 149.52 15.0748 149.121 15.1998C148.73 15.3248 148.305 15.524 147.844 15.7974V25.1255H143.625V11.9654H147.844V13.4185C148.594 12.8326 149.312 12.3834 150 12.0709C150.695 11.7584 151.465 11.6021 152.309 11.6021C153.73 11.6021 154.84 12.0162 155.637 12.8443C156.441 13.6724 156.844 14.9107 156.844 16.5591V25.1255ZM162.953 25.1255H158.734V6.89117H162.953V25.1255ZM169.156 25.1255H164.938V11.9654H169.156V25.1255ZM169.273 10.0904H164.82V6.89117H169.273V10.0904ZM184.359 25.1255H180.117V18.5982C180.117 18.067 180.09 17.5396 180.035 17.0162C179.98 16.4849 179.887 16.0943 179.754 15.8443C179.598 15.5552 179.367 15.3443 179.062 15.2115C178.766 15.0787 178.348 15.0123 177.809 15.0123C177.426 15.0123 177.035 15.0748 176.637 15.1998C176.246 15.3248 175.82 15.524 175.359 15.7974V25.1255H171.141V11.9654H175.359V13.4185C176.109 12.8326 176.828 12.3834 177.516 12.0709C178.211 11.7584 178.98 11.6021 179.824 11.6021C181.246 11.6021 182.355 12.0162 183.152 12.8443C183.957 13.6724 184.359 14.9107 184.359 16.5591V25.1255ZM199.211 19.3248H189.555C189.617 20.356 190.008 21.1451 190.727 21.692C191.453 22.2388 192.52 22.5123 193.926 22.5123C194.816 22.5123 195.68 22.3521 196.516 22.0318C197.352 21.7115 198.012 21.3677 198.496 21.0005H198.965V24.3873C198.012 24.7701 197.113 25.0474 196.27 25.2193C195.426 25.3912 194.492 25.4771 193.469 25.4771C190.828 25.4771 188.805 24.8834 187.398 23.6959C185.992 22.5084 185.289 20.817 185.289 18.6216C185.289 16.4498 185.953 14.731 187.281 13.4654C188.617 12.192 190.445 11.5552 192.766 11.5552C194.906 11.5552 196.516 12.0982 197.594 13.1841C198.672 14.2623 199.211 15.817 199.211 17.8482V19.3248ZM195.016 16.8521C194.992 15.9693 194.773 15.3052 194.359 14.8599C193.945 14.4146 193.301 14.192 192.426 14.192C191.613 14.192 190.945 14.4029 190.422 14.8248C189.898 15.2466 189.605 15.9224 189.543 16.8521H195.016Z"
      fill="currentColor"
    />
  </svg>
);

const headerDiwaliLogoIcon = (props: IconProps) => (
  <svg
    width="204"
    height="38"
    viewBox="0 0 204 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.54831 18.6862C5.54831 18.6862 0.820716 24.7568 3.29708 26.7805C3.29708 26.7805 4.19757 27.2303 6.22369 27.0053C12.7523 26.106 28.9614 14.1893 34.5895 9.24279L33.689 6.76953L42.4688 8.11857L39.5422 16.8875L37.7412 14.4142C37.7412 14.4142 21.0819 27.9047 7.79956 31.0524C7.79956 31.0524 -7.95914 34.2003 5.3232 18.6862H5.54831Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.91016 13.4189H13.8177V22.8152C11.8123 24.1575 9.36122 25.0524 6.91016 25.9472V13.4189Z"
      fill="#1EC400"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.1309 6.76953H23.0384V16.8804L16.1309 21.5989V6.76953Z"
      fill="#1EC400"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.3281 0.373047H32.2357V10.0545L25.3281 15.4581V0.373047Z"
      fill="#1EC400"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M31.9837 33.6194H25.0762V24.5854L31.9837 20.0684V33.6194Z"
      fill="#B5B5B5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M23.0384 33.6018H16.1309V29.299L23.0384 25.6758V33.6018Z"
      fill="#B5B5B5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8177 33.6148H6.91016V32.2853C8.46994 32.2853 11.8123 31.1775 13.8177 30.291V33.6148Z"
      fill="#B5B5B5"
    />
    <g filter="url(#filter0_d_10177_68005)">
      <path
        d="M70.9883 28H66.5117V16.3164L63.2773 23.8984H60.1719L56.9375 16.3164V28H52.6953V10.5508H57.9219L61.8477 19.3047L65.7617 10.5508H70.9883V28ZM79.1602 23.3477L82.1602 14.8398H86.4961L79.1836 32.8281H74.6133L76.6992 27.9062L71.5781 14.8398H76.0078L79.1602 23.3477ZM101.055 22.5156C101.055 24.2344 100.324 25.6328 98.8633 26.7109C97.4102 27.7812 95.4336 28.3164 92.9336 28.3164C91.4883 28.3164 90.2266 28.1914 89.1484 27.9414C88.0781 27.6836 87.0742 27.3594 86.1367 26.9688V22.7852H86.6289C87.5586 23.5273 88.5977 24.0977 89.7461 24.4961C90.9023 24.8945 92.0117 25.0938 93.0742 25.0938C93.3477 25.0938 93.707 25.0703 94.1523 25.0234C94.5977 24.9766 94.9609 24.8984 95.2422 24.7891C95.5859 24.6484 95.8672 24.4727 96.0859 24.2617C96.3125 24.0508 96.4258 23.7383 96.4258 23.3242C96.4258 22.9414 96.2617 22.6133 95.9336 22.3398C95.6133 22.0586 95.1406 21.8438 94.5156 21.6953C93.8594 21.5391 93.1641 21.3945 92.4297 21.2617C91.7031 21.1211 91.0195 20.9453 90.3789 20.7344C88.9102 20.2578 87.8516 19.6133 87.2031 18.8008C86.5625 17.9805 86.2422 16.9648 86.2422 15.7539C86.2422 14.1289 86.9688 12.8047 88.4219 11.7812C89.8828 10.75 91.7578 10.2344 94.0469 10.2344C95.1953 10.2344 96.3281 10.3477 97.4453 10.5742C98.5703 10.793 99.543 11.0703 100.363 11.4062V15.4258H99.8828C99.1797 14.8633 98.3164 14.3945 97.293 14.0195C96.2773 13.6367 95.2383 13.4453 94.1758 13.4453C93.8008 13.4453 93.4258 13.4727 93.0508 13.5273C92.6836 13.5742 92.3281 13.668 91.9844 13.8086C91.6797 13.9258 91.418 14.1055 91.1992 14.3477C90.9805 14.582 90.8711 14.8516 90.8711 15.1562C90.8711 15.6172 91.0469 15.9727 91.3984 16.2227C91.75 16.4648 92.4141 16.6875 93.3906 16.8906C94.0312 17.0234 94.6445 17.1523 95.2305 17.2773C95.8242 17.4023 96.4609 17.5742 97.1406 17.793C98.4766 18.2305 99.4609 18.8281 100.094 19.5859C100.734 20.3359 101.055 21.3125 101.055 22.5156ZM111.582 28H101.363V24.9062H104.223V13.6445H101.363V10.5508H111.582V13.6445H108.723V24.9062H111.582V28ZM127.652 16.0586C127.652 16.8398 127.516 17.6055 127.242 18.3555C126.969 19.0977 126.578 19.7227 126.07 20.2305C125.375 20.918 124.598 21.4375 123.738 21.7891C122.887 22.1406 121.824 22.3164 120.551 22.3164H117.75V28H113.25V10.5508H120.656C121.766 10.5508 122.699 10.6484 123.457 10.8438C124.223 11.0312 124.898 11.3164 125.484 11.6992C126.188 12.1602 126.723 12.75 127.09 13.4688C127.465 14.1875 127.652 15.0508 127.652 16.0586ZM123 16.1641C123 15.6719 122.867 15.25 122.602 14.8984C122.336 14.5391 122.027 14.2891 121.676 14.1484C121.207 13.9609 120.75 13.8594 120.305 13.8438C119.859 13.8203 119.266 13.8086 118.523 13.8086H117.75V19.0352H119.039C119.805 19.0352 120.434 18.9883 120.926 18.8945C121.426 18.8008 121.844 18.6133 122.18 18.332C122.469 18.082 122.676 17.7852 122.801 17.4414C122.934 17.0898 123 16.6641 123 16.1641ZM142.07 21.4258C142.07 23.5898 141.438 25.2969 140.172 26.5469C138.914 27.7891 137.145 28.4102 134.863 28.4102C132.582 28.4102 130.809 27.7891 129.543 26.5469C128.285 25.2969 127.656 23.5898 127.656 21.4258C127.656 19.2461 128.289 17.5352 129.555 16.293C130.828 15.0508 132.598 14.4297 134.863 14.4297C137.16 14.4297 138.934 15.0547 140.184 16.3047C141.441 17.5547 142.07 19.2617 142.07 21.4258ZM136.879 24.625C137.152 24.2891 137.355 23.8867 137.488 23.418C137.629 22.9414 137.699 22.2852 137.699 21.4492C137.699 20.6758 137.629 20.0273 137.488 19.5039C137.348 18.9805 137.152 18.5625 136.902 18.25C136.652 17.9297 136.352 17.7031 136 17.5703C135.648 17.4375 135.27 17.3711 134.863 17.3711C134.457 17.3711 134.094 17.4258 133.773 17.5352C133.461 17.6445 133.16 17.8633 132.871 18.1914C132.613 18.4961 132.406 18.9141 132.25 19.4453C132.102 19.9766 132.027 20.6445 132.027 21.4492C132.027 22.168 132.094 22.793 132.227 23.3242C132.359 23.8477 132.555 24.2695 132.812 24.5898C133.062 24.8945 133.359 25.1172 133.703 25.2578C134.055 25.3984 134.453 25.4688 134.898 25.4688C135.281 25.4688 135.645 25.4062 135.988 25.2812C136.34 25.1484 136.637 24.9297 136.879 24.625ZM156.312 28H152.07V21.4727C152.07 20.9414 152.043 20.4141 151.988 19.8906C151.934 19.3594 151.84 18.9688 151.707 18.7188C151.551 18.4297 151.32 18.2188 151.016 18.0859C150.719 17.9531 150.301 17.8867 149.762 17.8867C149.379 17.8867 148.988 17.9492 148.59 18.0742C148.199 18.1992 147.773 18.3984 147.312 18.6719V28H143.094V14.8398H147.312V16.293C148.062 15.707 148.781 15.2578 149.469 14.9453C150.164 14.6328 150.934 14.4766 151.777 14.4766C153.199 14.4766 154.309 14.8906 155.105 15.7188C155.91 16.5469 156.312 17.7852 156.312 19.4336V28ZM162.422 28H158.203V9.76562H162.422V28ZM168.625 28H164.406V14.8398H168.625V28ZM168.742 12.9648H164.289V9.76562H168.742V12.9648ZM183.828 28H179.586V21.4727C179.586 20.9414 179.559 20.4141 179.504 19.8906C179.449 19.3594 179.355 18.9688 179.223 18.7188C179.066 18.4297 178.836 18.2188 178.531 18.0859C178.234 17.9531 177.816 17.8867 177.277 17.8867C176.895 17.8867 176.504 17.9492 176.105 18.0742C175.715 18.1992 175.289 18.3984 174.828 18.6719V28H170.609V14.8398H174.828V16.293C175.578 15.707 176.297 15.2578 176.984 14.9453C177.68 14.6328 178.449 14.4766 179.293 14.4766C180.715 14.4766 181.824 14.8906 182.621 15.7188C183.426 16.5469 183.828 17.7852 183.828 19.4336V28ZM198.68 22.1992H189.023C189.086 23.2305 189.477 24.0195 190.195 24.5664C190.922 25.1133 191.988 25.3867 193.395 25.3867C194.285 25.3867 195.148 25.2266 195.984 24.9062C196.82 24.5859 197.48 24.2422 197.965 23.875H198.434V27.2617C197.48 27.6445 196.582 27.9219 195.738 28.0938C194.895 28.2656 193.961 28.3516 192.938 28.3516C190.297 28.3516 188.273 27.7578 186.867 26.5703C185.461 25.3828 184.758 23.6914 184.758 21.4961C184.758 19.3242 185.422 17.6055 186.75 16.3398C188.086 15.0664 189.914 14.4297 192.234 14.4297C194.375 14.4297 195.984 14.9727 197.062 16.0586C198.141 17.1367 198.68 18.6914 198.68 20.7227V22.1992ZM194.484 19.7266C194.461 18.8438 194.242 18.1797 193.828 17.7344C193.414 17.2891 192.77 17.0664 191.895 17.0664C191.082 17.0664 190.414 17.2773 189.891 17.6992C189.367 18.1211 189.074 18.7969 189.012 19.7266H194.484Z"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_10177_68005"
        x="47.8953"
        y="4.96562"
        width="155.584"
        height="32.6625"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2.4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.54 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_10177_68005"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10177_68005"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

const mutualFundIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    fill="none"
    viewBox="0 0 20 21"
    {...props}
  >
    <path
      d="M7.5013 18.8332H12.5013C16.668 18.8332 18.3346 17.1665 18.3346 12.9998V7.99984C18.3346 3.83317 16.668 2.1665 12.5013 2.1665H7.5013C3.33464 2.1665 1.66797 3.83317 1.66797 7.99984V12.9998C1.66797 17.1665 3.33464 18.8332 7.5013 18.8332Z"
      stroke="black"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.10938 12.5748L8.09271 9.9998C8.37604 9.63314 8.90104 9.56647 9.26771 9.8498L10.7927 11.0498C11.1594 11.3331 11.6844 11.2665 11.9677 10.9081L13.8927 8.4248"
      stroke="black"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const blogIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    {...props}
  >
    <g clipPath="url(#clip0_1493_19148)">
      <path
        d="M5.83203 8.8335H12.4987"
        stroke="#09090B"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.83203 12.1665H9.9987"
        stroke="#09090B"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.5 18.0002H7.5C3.33333 18.0002 2.5 16.2835 2.5 12.8502V7.7085C2.5 3.79183 3.89167 2.74183 6.66667 2.5835H13.3333C16.1083 2.7335 17.5 3.79183 17.5 7.7085V13.0002"
        stroke="#09090B"
        strokeWidth="1.2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.5 13L12.5 18V15.5C12.5 13.8333 13.3333 13 15 13H17.5Z"
        stroke="#09090B"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1493_19148">
        <rect
          width="20"
          height="20"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

const videoIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    {...props}
  >
    <path
      d="M7.58203 10.5002V9.2669C7.58203 7.67524 8.70703 7.03357 10.082 7.82524L11.1487 8.4419L12.2154 9.05857C13.5904 9.85024 13.5904 11.1502 12.2154 11.9419L11.1487 12.5586L10.082 13.1752C8.70703 13.9669 7.58203 13.3169 7.58203 11.7336V10.5002Z"
      stroke="#09090B"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0013 18.8332C14.6037 18.8332 18.3346 15.1022 18.3346 10.4998C18.3346 5.89746 14.6037 2.1665 10.0013 2.1665C5.39893 2.1665 1.66797 5.89746 1.66797 10.4998C1.66797 15.1022 5.39893 18.8332 10.0013 18.8332Z"
      stroke="#09090B"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ytVideoIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="13"
    height="15"
    fill="none"
    viewBox="0 0 13 15"
    {...props}
  >
    <path
      d="M0.738281 7.5007V5.02905C0.738281 1.83928 2.99283 0.553345 5.7484 2.13988L7.88604 3.37571L10.0237 4.61154C12.7793 6.19807 12.7793 8.80333 10.0237 10.3899L7.88604 11.6257L5.7484 12.8615C2.99283 14.4481 0.738281 13.1454 0.738281 9.97236V7.5007Z"
      stroke="#09090B"
      strokeWidth="1.2"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ytVideoFilledIcon = (props: IconProps) => (
  <svg
    width="17"
    height="18"
    viewBox="0 0 17 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.0371 6.71289C15.5654 7.57024 15.5653 9.77043 14.0371 10.6279L4.30469 16.0879C2.80863 16.9271 0.961914 15.8452 0.961914 14.1299V3.21094C0.962113 1.4957 2.8087 0.414694 4.30469 1.25391L14.0371 6.71289Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1"
    />
  </svg>
);

const closeSearchIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.9201 15.0898L13.4001 8.56984C12.6301 7.79984 11.3701 7.79984 10.6001 8.56984L4.08008 15.0898"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const dropdownDownArrow = (props: IconProps) => (
  <svg
    width="12"
    height="7"
    viewBox="0 0 12 7"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.69145 5.06256L10.4344 0.319572L11.3829 1.26803L6.16568 6.48525C6.03989 6.611 5.86931 6.68164 5.69145 6.68164C5.51358 6.68164 5.343 6.611 5.21721 6.48525L0 1.26803L0.948462 0.319572L5.69145 5.06256Z"
      fill="currentColor"
    />
  </svg>
);

const leftRightArrowIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={2}
    stroke="currentColor"
    {...props}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
  </svg>
);

const boxLeftSlidIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.99805 22H14.998C19.998 22 21.998 20 21.998 15V9C21.998 4 19.998 2 14.998 2H8.99805C3.99805 2 1.99805 4 1.99805 9V15C1.99805 20 3.99805 22 8.99805 22Z"
      stroke="#202020"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.2583 15.5287L9.73828 11.9987L13.2583 8.46875"
      stroke="#202020"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const rightArrow = (props: IconProps) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.61984 4.1176L13.6665 8.16427L9.61984 12.2109"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.33029 8.16406H13.5503"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const upRightArrowIcon = (props: IconProps) => (
  <svg
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.30176 4.78906L14.5206 6.45539L12.8543 12.6742"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.479 12.8359L14.4104 6.52469"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const googleIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    {...props}
    fill="none"
  >
    <g clipPath="url(#clip0_834_5902)">
      <path
        d="M23.7682 12.7763C23.7682 11.9605 23.7021 11.1404 23.561 10.3379H12.2422V14.9589H18.7239C18.455 16.4492 17.5907 17.7676 16.3252 18.6054V21.6037H20.1922C22.463 19.5137 23.7682 16.4272 23.7682 12.7763Z"
        fill="#4285F4"
      />
      <path
        d="M12.2391 24.5008C15.4756 24.5008 18.205 23.4382 20.1936 21.6039L16.3266 18.6055C15.2507 19.3375 13.8618 19.752 12.2435 19.752C9.11291 19.752 6.45849 17.6399 5.50607 14.8003H1.51562V17.8912C3.55274 21.9434 7.70192 24.5008 12.2391 24.5008Z"
        fill="#34A853"
      />
      <path
        d="M5.50473 14.8002C5.00206 13.3099 5.00206 11.696 5.50473 10.2057V7.11475H1.51869C-0.183313 10.5055 -0.183313 14.5004 1.51869 17.8912L5.50473 14.8002Z"
        fill="#FBBC04"
      />
      <path
        d="M12.2391 5.24966C13.9499 5.2232 15.6034 5.86697 16.8425 7.04867L20.2685 3.62262C18.0991 1.5855 15.2198 0.465534 12.2391 0.500809C7.70192 0.500809 3.55274 3.05822 1.51562 7.11481L5.50166 10.2058C6.44967 7.36173 9.1085 5.24966 12.2391 5.24966Z"
        fill="#EA4335"
      />
    </g>
    <defs>
      <clipPath id="clip0_834_5902">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0 0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);

const facebook = (props: IconProps) => (
  <svg
    viewBox="0 0 24 24"
    {...props}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 3h4a1 1 0 011 1v3h-2c-1.1 0-2 .9-2 2v2h4l-1 4h-3v8h-4v-8H8v-4h3V9c0-2.2 1.8-4 4-4z"
      fill="#1877F2"
    />
  </svg>
);

const openEyeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    stroke="#a8b0bf"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M1 8s3-5 7-5 7 5 7 5-3 5-7 5-7-5-7-5z" />
    <circle cx="8" cy="8" r="2.5" />
  </svg>
);

const closeEyeIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    stroke="#a8b0bf"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M13 13a8 8 0 0 1-5 2C3 15 1 8 1 8a14.5 14.5 0 0 1 3.5-4.5" />
    <path d="M1 1l14 14" />
    <path d="M6.5 6.5a2.5 2.5 0 0 0 3 3" />
    <path d="M15 8s-2-5-7-5a6.5 6.5 0 0 0-2.5.5" />
  </svg>
);

const loginBackBtn = (props: IconProps) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 34 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.8 30.8C24.532 30.8 30.8 24.532 30.8 16.8C30.8 9.068 24.532 2.8 16.8 2.8C9.068 2.8 2.8 9.068 2.8 16.8C2.8 24.532 9.068 30.8 16.8 30.8Z"
      fill="white"
      stroke="currentColor"
      strokeWidth="2.1"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.567 21.7428L13.6391 16.8149L18.567 11.887"
      stroke="currentColor"
      strokeWidth="2.1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ytBtnIcon = (props: IconProps) => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.80594 6.94972C1.89079 5.64346 2.941 4.61974 4.24842 4.55497C6.14163 4.46118 8.84759 4.34805 10.8864 4.34805C12.9253 4.34805 15.6312 4.46118 17.5245 4.55497C18.8319 4.61974 19.8821 5.64346 19.9669 6.94972C20.0482 8.20122 20.1283 9.74114 20.1283 10.9494C20.1283 12.1577 20.0482 13.6976 19.9669 14.9491C19.8821 16.2554 18.8319 17.2791 17.5245 17.3439C15.6312 17.4377 12.9253 17.5508 10.8864 17.5508C8.84759 17.5508 6.14163 17.4377 4.24842 17.3439C2.941 17.2791 1.89079 16.2554 1.80594 14.9491C1.72465 13.6976 1.64453 12.1577 1.64453 10.9494C1.64453 9.74114 1.72465 8.20122 1.80594 6.94972Z"
      fill="#FC0D1B"
    />
    <path
      d="M8.90625 8.30887V13.59L14.1873 10.9494L8.90625 8.30887Z"
      fill="white"
    />
  </svg>
);

const viewEyeIcon = (props: IconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.3866 7.99995C10.3866 9.31995 9.31995 10.3866 7.99995 10.3866C6.67995 10.3866 5.61328 9.31995 5.61328 7.99995C5.61328 6.67995 6.67995 5.61328 7.99995 5.61328C9.31995 5.61328 10.3866 6.67995 10.3866 7.99995Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.9999 13.5138C10.3532 13.5138 12.5466 12.1271 14.0732 9.72713C14.6732 8.78713 14.6732 7.20713 14.0732 6.26713C12.5466 3.86713 10.3532 2.48047 7.9999 2.48047C5.64656 2.48047 3.45323 3.86713 1.92656 6.26713C1.32656 7.20713 1.32656 8.78713 1.92656 9.72713C3.45323 12.1271 5.64656 13.5138 7.9999 13.5138Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const viewEyeIconColored = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      fill="#7A7A7A"
    />
    <path
      d="M23.2047 11.745C22.3226 9.46324 20.7912 7.48996 18.7998 6.06906C16.8084 4.64817 14.4443 3.84193 11.9997 3.75C9.55507 3.84193 7.19097 4.64817 5.19958 6.06906C3.20819 7.48996 1.6768 9.46324 0.794681 11.745C0.735106 11.9098 0.735106 12.0902 0.794681 12.255C1.6768 14.5368 3.20819 16.51 5.19958 17.9309C7.19097 19.3518 9.55507 20.1581 11.9997 20.25C14.4443 20.1581 16.8084 19.3518 18.7998 17.9309C20.7912 16.51 22.3226 14.5368 23.2047 12.255C23.2643 12.0902 23.2643 11.9098 23.2047 11.745ZM11.9997 16.875C11.0355 16.875 10.093 16.5891 9.29128 16.0534C8.48959 15.5177 7.86475 14.7564 7.49577 13.8656C7.12679 12.9748 7.03025 11.9946 7.21835 11.0489C7.40646 10.1033 7.87075 9.23464 8.55254 8.55285C9.23432 7.87107 10.103 7.40677 11.0486 7.21867C11.9943 7.03057 12.9745 7.12711 13.8653 7.49609C14.7561 7.86506 15.5174 8.48991 16.0531 9.2916C16.5888 10.0933 16.8747 11.0358 16.8747 12C16.8727 13.2923 16.3584 14.5311 15.4446 15.445C14.5308 16.3588 13.292 16.873 11.9997 16.875Z"
      fill="#7A7A7A"
    />
  </svg>
);

const durationIcon = (props: IconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.6654 7.99998C14.6654 11.68 11.6787 14.6666 7.9987 14.6666C4.3187 14.6666 1.33203 11.68 1.33203 7.99998C1.33203 4.31998 4.3187 1.33331 7.9987 1.33331C11.6787 1.33331 14.6654 4.31998 14.6654 7.99998Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.4739 10.12L8.40724 8.88665C8.04724 8.67332 7.75391 8.15999 7.75391 7.73999V5.00665"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const feedBackFilledStar = () => (
  <svg
    width="18px"
    height="18px"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    stroke="#FFC500"
    strokeWidth="2"
    fill="#FFC500"
  >
    <path d="M12 2L14.94 8.64L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L9.06 8.64L12 2Z" />
  </svg>
);

const feedBackFilledStarV2 = (props: IconProps) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="2"
    fill="currentColor"
    {...props}
  >
    <path d="M12 2L14.94 8.64L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L9.06 8.64L12 2Z" />
  </svg>
);

const ratingStarIcon = (props: IconProps) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    stroke="currentColor"
    strokeWidth="2"
    fill="currentColor"
    {...props}
  >
    <path d="M12 2L14.94 8.64L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L9.06 8.64L12 2Z" />
  </svg>
);

const buttonLoaderSecondary = ({ className, ...props }: IconProps) => (
  <svg
    className={`animate-spin h-5 w-5 text-black/40 ${className ?? "-"}`}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <circle
      className="opacity-25"
      cx="12"
      cy="12"
      r="10"
      stroke="currentColor"
      strokeWidth="4"
    />
    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
  </svg>
);

const filterBtnIcon = (props: IconProps) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.14909 1.22461H10.8491C11.4908 1.22461 12.0158 1.74961 12.0158 2.39128V3.67461C12.0158 4.14128 11.7241 4.72461 11.4324 5.01628L8.92409 7.23294C8.57409 7.52461 8.34075 8.10794 8.34075 8.57461V11.0829C8.34075 11.4329 8.10742 11.8996 7.81576 12.0746L6.99909 12.5996C6.24076 13.0663 5.19075 12.5413 5.19075 11.6079V8.51628C5.19075 8.10794 4.95742 7.58294 4.72409 7.29128L2.50742 4.95794C2.21576 4.66628 1.98242 4.14128 1.98242 3.79128V2.44961C1.98242 1.74961 2.50742 1.22461 3.14909 1.22461Z"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const searchIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="11.0996"
      cy="10.6001"
      r="6"
      stroke="currentColor"
      strokeWidth="1.2"
    />
    <path
      d="M15.5 15L19.7426 19.2426"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const searchIcon2 = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g opacity="0.6">
      <path
        d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.9984 20.9984L16.6484 16.6484"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

const facebookIcon = () => (
  <svg
    width="24"
    height="24"
    className="w-5 h-5 sm:w-6 sm:h-6"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12178_12105)">
      <path
        d="M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 17.9895 4.3882 22.954 10.125 23.8542V15.4688H7.07812V12H10.125V9.35625C10.125 6.34875 11.9166 4.6875 14.6576 4.6875C15.9701 4.6875 17.3438 4.92188 17.3438 4.92188V7.875H15.8306C14.34 7.875 13.875 8.80008 13.875 9.75V12H17.2031L16.6711 15.4688H13.875V23.8542C19.6118 22.954 24 17.9895 24 12Z"
        fill="#98A2B3"
      />
    </g>
    <defs>
      <clipPath id="clip0_12178_12105">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const facebookIconColored = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_5017_43394)">
      <path
        d="M24 12C24 5.37264 18.6274 0 12 0C5.37264 0 0 5.37264 0 12C0 17.6275 3.87456 22.3498 9.10128 23.6467V15.6672H6.62688V12H9.10128V10.4198C9.10128 6.33552 10.9498 4.4424 14.9597 4.4424C15.72 4.4424 17.0318 4.59168 17.5685 4.74048V8.06448C17.2853 8.03472 16.7933 8.01984 16.1822 8.01984C14.2147 8.01984 13.4544 8.76528 13.4544 10.703V12H17.3741L16.7006 15.6672H13.4544V23.9122C19.3963 23.1946 24.0005 18.1354 24.0005 12H24Z"
        fill="#0866FF"
      />
      <path
        d="M16.6988 15.6672L17.3722 12H13.4525V10.703C13.4525 8.76526 14.2128 8.01982 16.1804 8.01982C16.7914 8.01982 17.2834 8.0347 17.5666 8.06446V4.74046C17.03 4.59118 15.7181 4.44238 14.9578 4.44238C10.9479 4.44238 9.0994 6.3355 9.0994 10.4198V12H6.625V15.6672H9.0994V23.6467C10.0277 23.8771 10.9988 24 11.9981 24C12.4901 24 12.9754 23.9697 13.452 23.9121V15.6672H16.6983H16.6988Z"
        fill="white"
      />
    </g>
    <defs>
      <clipPath id="clip0_5017_43394">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const linkedinIcon = () => (
  <svg
    width="24"
    height="24"
    className="w-5 h-5 sm:w-6 sm:h-6"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_12178_12106)">
      <path
        d="M22.2234 0H1.77187C0.792187 0 0 0.773438 0 1.72969V22.2656C0 23.2219 0.792187 24 1.77187 24H22.2234C23.2031 24 24 23.2219 24 22.2703V1.72969C24 0.773438 23.2031 0 22.2234 0ZM7.12031 20.4516H3.55781V8.99531H7.12031V20.4516ZM5.33906 7.43438C4.19531 7.43438 3.27188 6.51094 3.27188 5.37187C3.27188 4.23281 4.19531 3.30937 5.33906 3.30937C6.47813 3.30937 7.40156 4.23281 7.40156 5.37187C7.40156 6.50625 6.47813 7.43438 5.33906 7.43438ZM20.4516 20.4516H16.8937V14.8828C16.8937 13.5562 16.8703 11.8453 15.0422 11.8453C13.1906 11.8453 12.9094 13.2937 12.9094 14.7891V20.4516H9.35625V8.99531H12.7687V10.5609H12.8156C13.2891 9.66094 14.4516 8.70938 16.1813 8.70938C19.7859 8.70938 20.4516 11.0813 20.4516 14.1656V20.4516Z"
        fill="#98A2B3"
      />
    </g>
    <defs>
      <clipPath id="clip0_12178_12106">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const linkedinIconColored = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.2283 0H1.77167C1.30179 0 0.851161 0.186657 0.518909 0.518909C0.186657 0.851161 0 1.30179 0 1.77167V22.2283C0 22.6982 0.186657 23.1488 0.518909 23.4811C0.851161 23.8133 1.30179 24 1.77167 24H22.2283C22.6982 24 23.1488 23.8133 23.4811 23.4811C23.8133 23.1488 24 22.6982 24 22.2283V1.77167C24 1.30179 23.8133 0.851161 23.4811 0.518909C23.1488 0.186657 22.6982 0 22.2283 0ZM7.15333 20.445H3.545V8.98333H7.15333V20.445ZM5.34667 7.395C4.93736 7.3927 4.53792 7.2692 4.19873 7.04009C3.85955 6.81098 3.59584 6.48653 3.44088 6.10769C3.28591 5.72885 3.24665 5.31259 3.32803 4.91145C3.40941 4.51032 3.6078 4.14228 3.89816 3.85378C4.18851 3.56529 4.55782 3.36927 4.95947 3.29046C5.36112 3.21165 5.77711 3.25359 6.15495 3.41099C6.53279 3.56838 6.85554 3.83417 7.08247 4.17481C7.30939 4.51546 7.43032 4.91569 7.43 5.325C7.43386 5.59903 7.38251 5.87104 7.27901 6.1248C7.17551 6.37857 7.02198 6.6089 6.82757 6.80207C6.63316 6.99523 6.40185 7.14728 6.14742 7.24915C5.893 7.35102 5.62067 7.40062 5.34667 7.395ZM20.4533 20.455H16.8467V14.1933C16.8467 12.3467 16.0617 11.7767 15.0483 11.7767C13.9783 11.7767 12.9283 12.5833 12.9283 14.24V20.455H9.32V8.99167H12.79V10.58H12.8367C13.185 9.875 14.405 8.67 16.2667 8.67C18.28 8.67 20.455 9.865 20.455 13.365L20.4533 20.455Z"
      fill="#0A66C2"
    />
  </svg>
);

const twitterIcon = () => (
  <svg
    width="24"
    height="24"
    className="w-5 h-5 sm:w-6 sm:h-6"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.55016 21.7497C16.6045 21.7497 21.5583 14.2465 21.5583 7.74162C21.5583 7.53068 21.5536 7.31505 21.5442 7.10412C22.5079 6.40722 23.3395 5.54401 24 4.55505C23.1025 4.95436 22.1496 5.21514 21.1739 5.32849C22.2013 4.71266 22.9705 3.74523 23.3391 2.60552C22.3726 3.17831 21.3156 3.58237 20.2134 3.80037C19.4708 3.01132 18.489 2.48887 17.4197 2.31381C16.3504 2.13874 15.2532 2.32081 14.2977 2.83185C13.3423 3.3429 12.5818 4.15446 12.1338 5.14107C11.6859 6.12767 11.5754 7.23437 11.8195 8.29005C9.86249 8.19185 7.94794 7.68346 6.19998 6.79785C4.45203 5.91225 2.90969 4.66919 1.67297 3.14927C1.0444 4.233 0.852057 5.5154 1.13503 6.73585C1.418 7.95629 2.15506 9.0232 3.19641 9.71974C2.41463 9.69492 1.64998 9.48444 0.965625 9.10568V9.16662C0.964925 10.3039 1.3581 11.4063 2.07831 12.2865C2.79852 13.1667 3.80132 13.7703 4.91625 13.9947C4.19206 14.1929 3.43198 14.2218 2.69484 14.0791C3.00945 15.0572 3.62157 15.9126 4.44577 16.5261C5.26997 17.1395 6.26512 17.4804 7.29234 17.501C5.54842 18.8709 3.39417 19.6139 1.17656 19.6104C0.783287 19.6098 0.390399 19.5857 0 19.5382C2.25286 20.9835 4.87353 21.7511 7.55016 21.7497Z"
      fill="#98A2B3"
    />
  </svg>
);

const twitterIconColored = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.3263 1.9043H21.6998L14.3297 10.3278L23 21.7903H16.2112L10.894 14.8383L4.80995 21.7903H1.43443L9.31743 12.7804L1 1.9043H7.96111L12.7674 8.25863L18.3263 1.9043ZM17.1423 19.7711H19.0116L6.94539 3.81743H4.93946L17.1423 19.7711Z"
      fill="black"
    />
  </svg>
);

const downloadPdfIconColored = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13 8.99347H18.5L13 3.49347V8.99347ZM6 1.99347H14L20 7.99347V19.9935C20 20.5239 19.7893 21.0326 19.4142 21.4077C19.0391 21.7828 18.5304 21.9935 18 21.9935H6C5.46957 21.9935 4.96086 21.7828 4.58579 21.4077C4.21071 21.0326 4 20.5239 4 19.9935V3.99347C4 3.46304 4.21071 2.95433 4.58579 2.57926C4.96086 2.20418 5.46957 1.99347 6 1.99347ZM10.93 12.4335C11.34 13.3335 11.86 14.0735 12.46 14.5835L12.87 14.9035C12 15.0635 10.8 15.3435 9.53 15.8335L9.42 15.8735L9.92 14.8335C10.37 13.9635 10.7 13.1735 10.93 12.4335ZM17.41 16.2435C17.59 16.0635 17.68 15.8335 17.69 15.5835C17.72 15.3835 17.67 15.1935 17.57 15.0335C17.28 14.5635 16.53 14.3435 15.29 14.3435L14 14.4135L13.13 13.8335C12.5 13.3135 11.93 12.4035 11.53 11.2735L11.57 11.1335C11.9 9.80347 12.21 8.19347 11.55 7.53347C11.4693 7.45508 11.3738 7.3935 11.2691 7.3523C11.1644 7.3111 11.0525 7.2911 10.94 7.29347H10.7C10.33 7.29347 10 7.68347 9.91 8.06347C9.54 9.39347 9.76 10.1235 10.13 11.3335V11.3435C9.88 12.2235 9.56 13.2435 9.05 14.2735L8.09 16.0735L7.2 16.5635C6 17.3135 5.43 18.1535 5.32 18.6835C5.28 18.8735 5.3 19.0435 5.37 19.2235L5.4 19.2735L5.88 19.5835L6.32 19.6935C7.13 19.6935 8.05 18.7435 9.29 16.6235L9.47 16.5535C10.5 16.2235 11.78 15.9935 13.5 15.8035C14.53 16.3135 15.74 16.5435 16.5 16.5435C16.94 16.5435 17.24 16.4335 17.41 16.2435ZM17 15.5335L17.09 15.6435C17.08 15.7435 17.05 15.7535 17 15.7735H16.96L16.77 15.7935C16.31 15.7935 15.6 15.6035 14.87 15.2835C14.96 15.1835 15 15.1835 15.1 15.1835C16.5 15.1835 16.9 15.4335 17 15.5335ZM7.83 16.9935C7.18 18.1835 6.59 18.8435 6.14 18.9935C6.19 18.6135 6.64 17.9535 7.35 17.3035L7.83 16.9935ZM10.85 10.0835C10.62 9.18347 10.61 8.45347 10.78 8.03347L10.85 7.91347L11 7.96347C11.17 8.20347 11.19 8.52347 11.09 9.06347L11.06 9.22347L10.9 10.0435L10.85 10.0835Z"
      fill="#EF5350"
    />
  </svg>
);

const savedBlogIconColored = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.67091 20.879C5.55795 20.9545 5.42658 20.998 5.29084 21.0047C5.15511 21.0114 5.0201 20.981 4.90026 20.917C4.78041 20.8529 4.68023 20.7574 4.61042 20.6408C4.54061 20.5242 4.5038 20.3909 4.50391 20.255V6.01846C4.5039 5.22385 4.81915 4.46169 5.38046 3.89926C5.94178 3.33682 6.7033 3.02005 7.49791 3.01846L16.4979 3.00196C16.8919 3.00117 17.2821 3.07799 17.6464 3.22802C18.0107 3.37806 18.3419 3.59838 18.621 3.87639C18.9001 4.15441 19.1218 4.48469 19.2733 4.84836C19.4247 5.21204 19.5031 5.60199 19.5039 5.99596V20.255C19.504 20.3909 19.4672 20.5242 19.3974 20.6408C19.3276 20.7574 19.2274 20.8529 19.1076 20.917C18.9877 20.981 18.8527 21.0114 18.717 21.0047C18.5812 20.998 18.4499 20.9545 18.3369 20.879L12.0039 16.649L5.67091 20.879Z"
      fill="url(#paint0_linear_4881_14615)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_4881_14615"
        x1="4.50391"
        y1="4.52896"
        x2="13.9539"
        y2="17.8715"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#F97DBD" />
        <stop offset="1" stopColor="#D7257D" />
      </linearGradient>
    </defs>
  </svg>
);

const copyLinkIconColored = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.2342 10.2242C11.1413 9.31709 12.3624 8.79339 13.6448 8.76137C14.9272 8.72936 16.1729 9.19148 17.1242 10.0522L17.3052 10.2242L20.1332 13.0532C21.0542 13.9758 21.5785 15.2217 21.5942 16.5253C21.6099 17.8289 21.1158 19.0871 20.2172 20.0317C19.3187 20.9763 18.0867 21.5326 16.784 21.582C15.4812 21.6314 14.2107 21.17 13.2432 20.2962L13.0632 20.1242L10.9412 18.0022C10.7618 17.8222 10.6577 17.5807 10.65 17.3268C10.6422 17.0728 10.7314 16.8254 10.8994 16.6349C11.0675 16.4443 11.3017 16.3249 11.5547 16.3008C11.8076 16.2767 12.0602 16.3497 12.2612 16.5052L12.3552 16.5882L14.4772 18.7102C15.0273 19.2634 15.7712 19.5807 16.5513 19.5945C17.3314 19.6084 18.0862 19.3178 18.6556 18.7845C19.225 18.2511 19.5642 17.5169 19.6013 16.7376C19.6383 15.9583 19.3704 15.1952 18.8542 14.6102L18.7192 14.4672L15.8912 11.6392C15.6126 11.3605 15.2819 11.1395 14.9178 10.9887C14.5538 10.8379 14.1637 10.7603 13.7697 10.7603C13.3757 10.7603 12.9855 10.8379 12.6215 10.9887C12.2575 11.1395 11.9268 11.3605 11.6482 11.6392C11.4605 11.8267 11.2061 11.932 10.9408 11.9319C10.6756 11.9318 10.4212 11.8263 10.2337 11.6387C10.0462 11.451 9.94089 11.1966 9.94098 10.9313C9.94107 10.666 10.0465 10.4117 10.2342 10.2242ZM3.87018 3.86016C4.77731 2.95309 5.99838 2.42939 7.28081 2.39737C8.56324 2.36536 9.80892 2.82748 10.7602 3.68816L10.9412 3.86016L13.0622 5.98316C13.2415 6.16311 13.3457 6.40459 13.3534 6.65854C13.3612 6.91249 13.272 7.15987 13.1039 7.35044C12.9359 7.541 12.7016 7.66046 12.4487 7.68456C12.1958 7.70865 11.9432 7.63557 11.7422 7.48016L11.6482 7.39716L9.52718 5.27616C8.97615 4.72872 8.23427 4.41633 7.45762 4.40473C6.68096 4.39313 5.93008 4.68321 5.36294 5.21394C4.79581 5.74468 4.45663 6.4747 4.41676 7.25041C4.37689 8.02613 4.63944 8.78708 5.14918 9.37316L5.28418 9.51716L8.11318 12.3462C8.67577 12.9086 9.43869 13.2245 10.2342 13.2245C11.0297 13.2245 11.7926 12.9086 12.3552 12.3462C12.448 12.2532 12.5583 12.1795 12.6796 12.1292C12.8009 12.0789 12.931 12.053 13.0623 12.053C13.1937 12.0529 13.3237 12.0787 13.4451 12.129C13.5665 12.1792 13.6768 12.2528 13.7697 12.3457C13.8626 12.4385 13.9363 12.5487 13.9866 12.6701C14.0369 12.7914 14.0628 12.9215 14.0629 13.0528C14.0629 13.1842 14.0371 13.3142 13.9869 13.4356C13.9367 13.557 13.863 13.6672 13.7702 13.7602C12.8631 14.6672 11.642 15.1909 10.3596 15.2229C9.07712 15.255 7.83144 14.7928 6.88018 13.9322L6.69818 13.7602L3.87018 10.9312C2.93283 9.99352 2.40625 8.72198 2.40625 7.39616C2.40625 6.07034 2.93283 4.7978 3.87018 3.86016Z"
      fill="#1E1E1E"
    />
  </svg>
);

const youtubeIcon = (props: IconProps) => (
  <svg
    width="28"
    height="24"
    className="w-6 h-5 sm:w-7 sm:h-6"
    {...props}
    viewBox="0 0 28 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3 0C1.34315 0 0 1.34315 0 3V17C0 18.6569 1.34315 20 3 20H25C26.6569 20 28 18.6569 28 17V3C28 1.34315 26.6569 0 25 0H3ZM17.362 9.15661C18.0582 9.53789 18.0539 10.5393 17.3546 10.9148L11.8843 13.8513C11.2164 14.2098 10.4081 13.724 10.4113 12.9661L10.4361 7.04714C10.4393 6.28919 11.2517 5.81017 11.9165 6.17426L17.362 9.15661Z"
      fill="#98A2B3"
    />
  </svg>
);

const instagramIcon = () => (
  <svg
    width="24"
    height="24"
    className="w-5 h-5 sm:w-6 sm:h-6"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="3.92857" fill="#98A2B3" />
    <circle
      cx="12"
      cy="12"
      r="5"
      fill="#98A2B3"
      stroke="#1D2939"
      strokeWidth="3"
    />
    <circle cx="18.875" cy="4.20801" r="1.375" fill="#1D2939" />
  </svg>
);

const whatsappIconV3 = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_5779_24039)">
      <path
        d="M12 0.265625C18.3515 0.265625 23.5 5.41417 23.5 11.7656C23.5 18.1171 18.3515 23.2656 12 23.2656C9.96768 23.2691 7.97108 22.7313 6.21551 21.7074L0.504618 23.2656L2.05942 17.5524C1.03472 15.7963 0.496456 13.7988 0.500018 11.7656C0.500018 5.41417 5.64857 0.265625 12 0.265625ZM8.08081 6.36062L7.85081 6.36982C7.70211 6.38007 7.55681 6.41912 7.42301 6.48482C7.29832 6.55556 7.18446 6.64386 7.08491 6.74702C6.94691 6.87697 6.86871 6.98967 6.78476 7.09892C6.3594 7.65196 6.13038 8.33093 6.13386 9.02862C6.13616 9.59212 6.28336 10.1407 6.51336 10.6536C6.98371 11.6909 7.75766 12.7891 8.77886 13.8069C9.02496 14.0518 9.26646 14.2979 9.52636 14.5268C10.7953 15.6439 12.3074 16.4495 13.9424 16.8797L14.5956 16.9797C14.8083 16.9912 15.0211 16.9751 15.235 16.9648C15.5698 16.9471 15.8968 16.8564 16.1929 16.6991C16.3434 16.6213 16.4903 16.5369 16.6334 16.4461C16.6334 16.4461 16.682 16.4131 16.7771 16.3426C16.9324 16.2276 17.0278 16.146 17.1566 16.0114C17.2532 15.9117 17.3337 15.796 17.3981 15.6641C17.4878 15.4767 17.5775 15.119 17.6143 14.8212C17.6419 14.5935 17.6339 14.4693 17.6304 14.3922C17.6258 14.2692 17.5235 14.1415 17.4119 14.0875L16.7426 13.7873C16.7426 13.7873 15.7421 13.3515 15.1303 13.0732C15.0663 13.0453 14.9977 13.0293 14.9279 13.026C14.8492 13.0178 14.7697 13.0266 14.6947 13.0518C14.6197 13.077 14.551 13.118 14.4932 13.1721C14.4875 13.1698 14.4104 13.2353 13.579 14.2427C13.5312 14.3068 13.4655 14.3553 13.3901 14.3819C13.3148 14.4086 13.2332 14.4121 13.1558 14.3922C13.0808 14.3722 13.0074 14.3469 12.9361 14.3163C12.7935 14.2565 12.7441 14.2335 12.6463 14.1921C11.9861 13.9045 11.3749 13.5153 10.8351 13.0387C10.6902 12.9122 10.5556 12.7742 10.4176 12.6408C9.96521 12.2075 9.57092 11.7173 9.24461 11.1826L9.17676 11.0733C9.12876 10.9995 9.08941 10.9204 9.05946 10.8376C9.01576 10.6685 9.12961 10.5328 9.12961 10.5328C9.12961 10.5328 9.40906 10.2269 9.53901 10.0613C9.66551 9.90032 9.77246 9.74392 9.84146 9.63237C9.97716 9.41387 10.0197 9.18962 9.94841 9.01597C9.62641 8.22937 9.29368 7.44699 8.95021 6.66882C8.88236 6.51472 8.68111 6.40432 8.49826 6.38247C8.43616 6.3748 8.37406 6.36867 8.31196 6.36407C8.15755 6.35521 8.00272 6.35675 7.84851 6.36867L8.08081 6.36062Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_5779_24039">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const whatsappIconV4 = (props: IconProps) => (
  <svg
    width="30"
    height="30"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.202 16.9762C19.9348 16.8424 18.6211 16.1962 18.3761 16.1071C18.1312 16.018 17.9531 15.9734 17.775 16.2408C17.5968 16.5082 17.0848 17.1099 16.9289 17.2882C16.7731 17.4664 16.6172 17.4887 16.35 17.355C16.0828 17.2213 15.2219 16.9392 14.2013 16.0292C13.407 15.3209 12.8707 14.4461 12.7148 14.1787C12.5589 13.9113 12.6982 13.7667 12.832 13.6336C12.9522 13.514 13.0992 13.3216 13.2328 13.1656C13.3664 13.0096 13.4109 12.8982 13.5 12.72C13.589 12.5417 13.5445 12.3857 13.4777 12.252C13.4109 12.1183 12.8765 10.8035 12.6539 10.2687C12.437 9.74785 12.2167 9.81834 12.0527 9.81014C11.897 9.8024 11.7187 9.80076 11.5406 9.80076C11.3624 9.80076 11.073 9.86762 10.828 10.135C10.5831 10.4024 9.89287 11.0487 9.89287 12.3634C9.89287 13.6781 10.8503 14.9483 10.9839 15.1266C11.1175 15.3049 12.8681 18.003 15.5485 19.16C16.186 19.4352 16.6837 19.5995 17.0717 19.7227C17.7118 19.9259 18.2943 19.8973 18.7547 19.8285C19.268 19.7518 20.3356 19.1823 20.5583 18.5584C20.7809 17.9344 20.7809 17.3996 20.7141 17.2882C20.6473 17.1767 20.4692 17.1099 20.202 16.9762ZM15.3266 23.6308H15.323C13.7281 23.6302 12.1638 23.2019 10.7991 22.3923L10.4746 22.1997L7.11055 23.0819L8.0085 19.8031L7.79709 19.467C6.9074 18.0522 6.43754 16.4171 6.43818 14.7382C6.44012 9.83914 10.4274 5.85336 15.3301 5.85336C17.7042 5.8543 19.9358 6.77979 21.6139 8.45926C23.292 10.1387 24.2157 12.3712 24.2148 14.7454C24.2128 19.6448 20.2256 23.6308 15.3266 23.6308ZM22.8911 7.18303C20.8722 5.16236 18.1872 4.04902 15.3265 4.04785C9.43227 4.04785 4.63502 8.84322 4.63268 14.7375C4.63191 16.6217 5.12428 18.4609 6.06008 20.082L4.54297 25.6217L10.2119 24.1352C11.7738 24.9869 13.5324 25.4356 15.3222 25.4364H15.3266C21.2203 25.4364 26.0179 20.6404 26.0203 14.7461C26.0214 11.8896 24.9102 9.20369 22.8911 7.18303Z"
      fill="currentColor"
    />
  </svg>
);

const headerSearchIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="10.4253"
      cy="10.4258"
      r="6.75"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M15.375 15.375L20.148 20.148"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const headerSearchIcon2 = (props: IconProps) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 45 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      y="0.5"
      width="45"
      height="45"
      rx="22.5"
      fill="currentColor"
      fillOpacity="0.15"
    />
    <circle
      cx="20.9251"
      cy="21.425"
      r="6.75"
      stroke="currentColor"
      strokeWidth="1.875"
    />
    <path
      d="M25.875 26.375L30.648 31.148"
      stroke="currentColor"
      strokeWidth="1.875"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const headerCartIcon = (props: IconProps) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 45 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 23C0 10.5736 10.0736 0.5 22.5 0.5C34.9264 0.5 45 10.5736 45 23C45 35.4264 34.9264 45.5 22.5 45.5C10.0736 45.5 0 35.4264 0 23Z"
      fill="currentColor"
      fillOpacity="0.15"
    />
    <path
      d="M17.7426 32.4551C17.9886 32.4551 18.2246 32.5497 18.3985 32.718C18.5724 32.8863 18.6702 33.1146 18.6702 33.3526C18.6702 33.5906 18.5724 33.8188 18.3985 33.9871C18.2246 34.1555 17.9886 34.25 17.7426 34.25C17.4967 34.25 17.2607 34.1555 17.0868 33.9871C16.9128 33.8188 16.8151 33.5906 16.8151 33.3526C16.8151 33.1146 16.9128 32.8863 17.0868 32.718C17.2607 32.5497 17.4967 32.4551 17.7426 32.4551ZM24.2353 32.4551C24.4813 32.4551 24.7172 32.5497 24.8911 32.718C25.0651 32.8863 25.1628 33.1146 25.1628 33.3526C25.1628 33.5906 25.0651 33.8188 24.8911 33.9871C24.7172 34.1555 24.4813 34.25 24.2353 34.25C23.9893 34.25 23.7534 34.1555 23.5794 33.9871C23.4055 33.8188 23.3078 33.5906 23.3078 33.3526C23.3078 33.1146 23.4055 32.8863 23.5794 32.718C23.7534 32.5497 23.9893 32.4551 24.2353 32.4551ZM11.4355 17.109C11.571 16.9342 11.7678 16.8132 11.9889 16.7688C12.2101 16.7243 12.4404 16.7595 12.6366 16.8676L12.734 16.9305L14.3182 18.0792C14.5878 18.2749 14.7972 18.538 14.9239 18.8402L14.9796 18.9937H26.8945C27.146 18.9936 27.3948 19.043 27.6259 19.1389C27.857 19.2347 28.0656 19.3751 28.2389 19.5513C28.4122 19.7276 28.5467 19.9361 28.6342 20.1642C28.7216 20.3923 28.7603 20.6353 28.7477 20.8783L28.7356 21.0111L28.3117 24.2912C28.1845 25.2783 27.7219 26.1965 26.9966 26.9015C26.2713 27.6066 25.3245 28.0584 24.3049 28.1861L24.0952 28.2067L17.3123 28.7541L17.5534 29.7628H25.6266C25.863 29.7631 26.0904 29.8507 26.2623 30.0077C26.4342 30.1647 26.5376 30.3793 26.5515 30.6077C26.5653 30.836 26.4885 31.0609 26.3368 31.2363C26.1851 31.4117 25.9698 31.5244 25.7351 31.5514L25.6266 31.5577H17.5534C17.1598 31.5578 16.7763 31.4367 16.4585 31.2119C16.1407 30.9872 15.905 30.6705 15.7856 30.3076L15.7457 30.1667L13.2043 19.5142L11.621 18.3654C11.4242 18.2226 11.2941 18.01 11.2593 17.7744C11.2245 17.5388 11.2879 17.2995 11.4355 17.109Z"
      fill="currentColor"
    />
  </svg>
);

const headerProfileIcon = (props: IconProps) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 45 46"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0 23C0 10.5736 10.0736 0.5 22.5 0.5C34.9264 0.5 45 10.5736 45 23C45 35.4264 34.9264 45.5 22.5 45.5C10.0736 45.5 0 35.4264 0 23Z"
      fill="currentColor"
      fillOpacity="0.15"
    />
    <path
      d="M34 23.25C34 17.0512 28.9487 12 22.75 12C16.5512 12 11.5 17.0512 11.5 23.25C11.5 26.5125 12.9062 29.4487 15.1337 31.5075C15.1337 31.5187 15.1337 31.5188 15.1225 31.53C15.235 31.6425 15.37 31.7325 15.4825 31.8337C15.55 31.89 15.6062 31.9463 15.6737 31.9913C15.8763 32.16 16.1013 32.3175 16.315 32.475C16.3938 32.5312 16.4612 32.5763 16.54 32.6325C16.7537 32.7787 16.9787 32.9138 17.215 33.0375C17.2937 33.0825 17.3838 33.1388 17.4625 33.1838C17.6875 33.3075 17.9237 33.42 18.1712 33.5212C18.2613 33.5662 18.3513 33.6112 18.4412 33.645C18.6888 33.7463 18.9362 33.8363 19.1838 33.915C19.2737 33.9487 19.3637 33.9825 19.4537 34.005C19.7238 34.0837 19.9937 34.1513 20.2638 34.2188C20.3425 34.2412 20.4213 34.2638 20.5113 34.275C20.8263 34.3425 21.1412 34.3875 21.4675 34.4212C21.5125 34.4212 21.5575 34.4325 21.6025 34.4438C21.985 34.4775 22.3675 34.5 22.75 34.5C23.1325 34.5 23.515 34.4775 23.8863 34.4438C23.9313 34.4438 23.9762 34.4325 24.0212 34.4212C24.3475 34.3875 24.6625 34.3425 24.9775 34.275C25.0562 34.2638 25.135 34.23 25.225 34.2188C25.495 34.1513 25.7762 34.095 26.035 34.005C26.125 33.9712 26.215 33.9375 26.305 33.915C26.5525 33.825 26.8112 33.7463 27.0475 33.645C27.1375 33.6112 27.2275 33.5662 27.3175 33.5212C27.5537 33.42 27.79 33.3075 28.0263 33.1838C28.1163 33.1388 28.195 33.0825 28.2738 33.0375C28.4988 32.9025 28.7238 32.7787 28.9487 32.6325C29.0275 32.5875 29.095 32.5312 29.1737 32.475C29.3987 32.3175 29.6125 32.16 29.815 31.9913C29.8825 31.935 29.9388 31.8787 30.0063 31.8337C30.13 31.7325 30.2537 31.6313 30.3663 31.53C30.3663 31.5188 30.3663 31.5187 30.355 31.5075C32.5938 29.4487 34 26.5125 34 23.25ZM28.3075 28.8412C25.2588 26.7937 20.2638 26.7937 17.1925 28.8412C16.6975 29.1675 16.2925 29.55 15.955 29.9662C14.245 28.2337 13.1875 25.86 13.1875 23.25C13.1875 17.9738 17.4738 13.6875 22.75 13.6875C28.0263 13.6875 32.3125 17.9738 32.3125 23.25C32.3125 25.86 31.255 28.2337 29.545 29.9662C29.2188 29.55 28.8025 29.1675 28.3075 28.8412Z"
      fill="currentColor"
    />
    <path
      d="M22.75 17.5459C20.4213 17.5459 18.5312 19.4359 18.5312 21.7646C18.5312 24.0484 20.32 25.9046 22.6937 25.9721C22.7275 25.9721 22.7725 25.9721 22.795 25.9721C22.8175 25.9721 22.8512 25.9721 22.8737 25.9721C22.885 25.9721 22.8963 25.9721 22.8963 25.9721C25.1688 25.8934 26.9575 24.0484 26.9688 21.7646C26.9688 19.4359 25.0788 17.5459 22.75 17.5459Z"
      fill="currentColor"
    />
  </svg>
);

const headerDrawerIcon = ({ isOpen = false, ...props }: IconProps) => (
  <svg
    width="39"
    height="39"
    viewBox="0 0 39 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.109375 19.5C0.109375 9.00659 8.61596 0.5 19.1094 0.5C29.6028 0.5 38.1094 9.00659 38.1094 19.5C38.1094 29.9934 29.6028 38.5 19.1094 38.5C8.61596 38.5 0.109375 29.9934 0.109375 19.5Z"
      fill="currentColor"
      fillOpacity="0.15"
    />
    <line
      x1="12.1094"
      y1="14.5"
      x2="26.1094"
      y2="14.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      className={`transition-all duration-300 ease-in-out origin-center ${isOpen ? "translate-y-[3.8px] -translate-x-1 rotate-45" : "translate-y-0 rotate-0"}`}
    />
    <line
      x1="12.1094"
      y1="19.5"
      x2="26.1094"
      y2="19.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      className={`transition-all duration-350 ease-in-out origin-top ${isOpen ? "opacity-0" : "opacity-100"}`}
    />
    <line
      x1="12.1094"
      y1="24.5"
      x2="26.1094"
      y2="24.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      className={`transition-all duration-300 ease-in-out origin-center ${isOpen ? "translate-y-[-3.8px] -translate-x-1 -rotate-45" : "translate-y-0 rotate-0"}`}
    />
  </svg>
);

const popupCloseIcon = ({ stroke = "#626262", ...props }: IconProps) => (
  <svg
    className="group-hover:scale-125 transition-transform rotate-45 w-4 h-4"
    viewBox="0 0 23 24"
    fill="none"
    {...props}
  >
    <path
      d="M1.78516 12.2559L21.7847 12.1144"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`stroke-[${stroke}]`}
    />
    <path
      d="M11.8555 2.18555L11.714 22.185"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`stroke-[${stroke}]`}
    />
  </svg>
);

const crossIcon = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20 20L4 4.00003M20 4L4.00002 20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const expandableIcon = ({ isOpen = false, ...props }: IconProps) => (
  <svg width={16} height={16} viewBox="0 0 23 24" fill="none" {...props}>
    <path
      d="M1.78516 12.2559L21.7847 12.1144"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.8555 2.18555L11.714 22.185"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      className={`transition duration-350 easeLinear origin-center ${!isOpen ? "rotate-0" : "rotate-90"}`}
    />
  </svg>
);

const commentProfileIcon = () => (
  <div className="avatar">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#999"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="12" cy="7" r="4" />
      <path d="M5.5 21c0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5" />
    </svg>
  </div>
);

const whatsAppIcon = () => (
  <svg
    width="54"
    height="53"
    viewBox="0 0 54 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="w-14 h-14 sm:w-12 sm:h-12"
  >
    <g filter="url(#filter0_d_6454_29763)">
      <g clipPath="url(#clip0_6454_29763)">
        <rect x="5" width="44" height="44" rx="22" fill="white" />
        <path
          d="M5 22C5 34.1503 14.8497 44 27 44C39.1503 44 49 34.1503 49 22C49 9.84974 39.1503 0 27 0C14.8497 0 5 9.84974 5 22Z"
          fill="#25D366"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M34.7 14.1625C32.6375 12.1 29.8875 11 27 11C20.95 11 16 15.95 16 22C16 23.925 16.55 25.85 17.5125 27.5L16 33L21.775 31.4875C23.425 32.3125 25.2125 32.8625 27 32.8625C33.05 32.8625 38 27.9125 38 21.8625C38 18.975 36.7625 16.225 34.7 14.1625ZM27 31.075C25.35 31.075 23.7 30.6625 22.325 29.8375L22.05 29.7L18.6125 30.6625L19.575 27.3625L19.3 26.95C18.3375 25.4375 17.925 23.7875 17.925 22.1375C17.925 17.1875 22.05 13.0625 27 13.0625C29.475 13.0625 31.675 14.025 33.4625 15.675C35.25 17.4625 36.075 19.6625 36.075 22.1375C36.075 26.95 32.0875 31.075 27 31.075ZM31.95 24.2C31.675 24.0625 30.3 23.375 30.025 23.375C29.75 23.2375 29.6125 23.2375 29.475 23.5125C29.3375 23.7875 28.7875 24.3375 28.65 24.6125C28.5125 24.75 28.375 24.75 28.1 24.75C27.825 24.6125 27 24.3375 25.9 23.375C25.075 22.6875 24.525 21.725 24.3875 21.45C24.25 21.175 24.3875 21.0375 24.525 20.9C24.6625 20.7625 24.8 20.625 24.9375 20.4875C25.075 20.35 25.075 20.2125 25.2125 20.075C25.35 19.9375 25.2125 19.8 25.2125 19.6625C25.2125 19.525 24.6625 18.15 24.3875 17.6C24.25 17.1875 23.975 17.1875 23.8375 17.1875C23.7 17.1875 23.5625 17.1875 23.2875 17.1875C23.15 17.1875 22.875 17.1875 22.6 17.4625C22.325 17.7375 21.6375 18.425 21.6375 19.8C21.6375 21.175 22.6 22.4125 22.7375 22.6875C22.875 22.825 24.6625 25.7125 27.4125 26.8125C29.75 27.775 30.1625 27.5 30.7125 27.5C31.2625 27.5 32.3625 26.8125 32.5 26.2625C32.775 25.575 32.775 25.025 32.6375 25.025C32.5 24.3375 32.225 24.3375 31.95 24.2Z"
          fill="white"
        />
      </g>
      <rect
        x="5.55"
        y="0.55"
        width="42.9"
        height="42.9"
        rx="21.45"
        stroke="#1A51AA"
        strokeOpacity="0.5"
        strokeWidth="1.1"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_6454_29763"
        x="-19.09"
        y="-24.09"
        width="92.18"
        height="92.18"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4.4" />
        <feGaussianBlur stdDeviation="2.2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.101961 0 0 0 0 0.317647 0 0 0 0 0.666667 0 0 0 0.2 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_6454_29763"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_6454_29763"
          result="shape"
        />
      </filter>
      <clipPath id="clip0_6454_29763">
        <rect x="5" width="44" height="44" rx="22" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const unSavedFundIcon = (props: IconProps) => (
  <svg
    width="44"
    height="43"
    viewBox="0 0 44 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="22"
      cy="21.5"
      r="20.75"
      fill="white"
      stroke="#E9E9EB"
      strokeWidth="1.5"
    />
    <path
      d="M26.7285 13.0586H18.1596C16.2663 13.0586 14.7285 14.6053 14.7285 16.4897V29.0142C14.7285 30.6142 15.8752 31.2897 17.2796 30.5164L21.6174 28.1075C22.0796 27.8497 22.8263 27.8497 23.2796 28.1075L27.6174 30.5164C29.0219 31.2986 30.1685 30.623 30.1685 29.0142V16.4897C30.1596 14.6053 28.6219 13.0586 26.7285 13.0586Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const savedFundIcon = (props: IconProps) => (
  <svg
    width="44"
    height="43"
    viewBox="0 0 44 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="22"
      cy="21.5"
      r="20.75"
      fill="white"
      stroke="#E9E9EB"
      strokeWidth="1.5"
    />
    <path
      d="M26.7285 13.0586H18.1596C16.2663 13.0586 14.7285 14.6053 14.7285 16.4897V29.0142C14.7285 30.6142 15.8752 31.2897 17.2796 30.5164L21.6174 28.1075C22.0796 27.8497 22.8263 27.8497 23.2796 28.1075L27.6174 30.5164C29.0219 31.2986 30.1685 30.623 30.1685 29.0142V16.4897C30.1596 14.6053 28.6219 13.0586 26.7285 13.0586Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const infoIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 22.1641C17.5 22.1641 22 17.6641 22 12.1641C22 6.66406 17.5 2.16406 12 2.16406C6.5 2.16406 2 6.66406 2 12.1641C2 17.6641 6.5 22.1641 12 22.1641Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 8.16406V13.1641"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9946 16.1641H12.0036"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const sharedFundIcon = (props: IconProps) => (
  <svg
    width="44"
    height="43"
    viewBox="0 0 44 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="22"
      cy="21.5"
      r="20.75"
      fill="white"
      stroke="#E9E9EB"
      strokeWidth="1.5"
    />
    <path
      d="M26.7497 18.3958C28.2224 18.3958 29.4163 17.2019 29.4163 15.7292C29.4163 14.2564 28.2224 13.0625 26.7497 13.0625C25.2769 13.0625 24.083 14.2564 24.083 15.7292C24.083 17.2019 25.2769 18.3958 26.7497 18.3958Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.0827 24.6146C17.5554 24.6146 18.7493 23.4207 18.7493 21.9479C18.7493 20.4752 17.5554 19.2812 16.0827 19.2812C14.6099 19.2812 13.416 20.4752 13.416 21.9479C13.416 23.4207 14.6099 24.6146 16.0827 24.6146Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26.7497 30.8333C28.2224 30.8333 29.4163 29.6394 29.4163 28.1667C29.4163 26.6939 28.2224 25.5 26.7497 25.5C25.2769 25.5 24.083 26.6939 24.083 28.1667C24.083 29.6394 25.2769 30.8333 26.7497 30.8333Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.3848 23.2891L24.4559 26.8268"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.447 17.0703L18.3848 20.6081"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const sharedFundIconV2 = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    fill="none"
    stroke="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z"
    />
  </svg>
);

const calendarIcon = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 1.5V3.75"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 1.5V3.75"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.625 6.82031H15.375"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.75 6.375V12.75C15.75 15 14.625 16.5 12 16.5H6C3.375 16.5 2.25 15 2.25 12.75V6.375C2.25 4.125 3.375 2.625 6 2.625H12C14.625 2.625 15.75 4.125 15.75 6.375Z"
      stroke="currentColor"
      strokeWidth="1.125"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7713 10.2812H11.778"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.7713 12.5312H11.778"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.99686 10.2812H9.00359"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.99686 12.5312H9.00359"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.22049 10.2812H6.22723"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.22049 12.5312H6.22723"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const addPlusIcon = (props: IconProps) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.99984 18.4714C14.5832 18.4714 18.3332 14.7214 18.3332 10.138C18.3332 5.55469 14.5832 1.80469 9.99984 1.80469C5.4165 1.80469 1.6665 5.55469 1.6665 10.138C1.6665 14.7214 5.4165 18.4714 9.99984 18.4714Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.6665 10.1406H13.3332"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 13.4714V6.80469"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const logoIcon = (props: IconProps) => (
  <svg
    width="33"
    height="28"
    viewBox="0 0 33 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.25852 15.4084C4.25852 15.4084 0.630027 20.1655 2.53067 21.7512C2.53067 21.7512 3.22181 22.1036 4.77688 21.9274C9.78766 21.2227 22.2282 11.8846 26.5478 8.0084L25.8567 6.07031L32.5953 7.12745L30.3491 13.9989L28.9668 12.0608C28.9668 12.0608 16.1807 22.6322 5.98638 25.0988C5.98638 25.0988 -6.10861 27.5655 4.08574 15.4084H4.25852Z"
      fill="white"
    />
    <path
      opacity="0.6"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.11816 11.1797H10.4745V18.5797C8.91944 19.6368 7.0188 20.3416 5.11816 21.0463V11.1797Z"
      fill="white"
    />
    <path
      opacity="0.6"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.1986 6.07031H17.555V13.9989L12.1986 17.6989V6.07031Z"
      fill="white"
    />
    <path
      opacity="0.6"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.2808 0.960938H24.6371V8.53712L19.2808 12.7657V0.960938Z"
      fill="white"
    />
    <path
      opacity="0.6"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24.4803 27.0402H19.124V19.9926L24.4803 16.4688V27.0402Z"
      fill="white"
    />
    <path
      opacity="0.6"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.555 27.0338H12.1986V23.6862L17.555 20.8672V27.0338Z"
      fill="white"
    />
    <path
      opacity="0.6"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.4745 27.0413H5.11816V25.9841C6.32766 25.9841 8.91944 25.1032 10.4745 24.3984V27.0413Z"
      fill="white"
    />
  </svg>
);

const logoIconV1 = (props: IconProps) => (
  <svg
    width="18"
    height="14"
    viewBox="0 0 18 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.33736 7.71453C2.33736 7.71453 0.345746 10.2719 1.38897 11.1244C1.38897 11.1244 1.76833 11.3139 2.62188 11.2191C5.3722 10.8403 12.2007 5.8201 14.5717 3.73626L14.1923 2.69434L17.891 3.26265L16.6581 6.95678L15.8994 5.91482C15.8994 5.91482 8.88125 11.598 3.28575 12.9241C3.28575 12.9241 -3.35297 14.2502 2.24252 7.71453H2.33736Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.91016 5.49609H5.82013V9.45447C4.9753 10.02 3.94272 10.3969 2.91016 10.7739V5.49609Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.78906 2.69434H9.69904V6.95376L6.78906 8.94157V2.69434Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.6719 0H13.5819V4.07855L10.6719 6.35494V0Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.4725 13.9997H10.5625V10.1939L13.4725 8.29102V13.9997Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.69904 14.0002H6.78906V12.1875L9.69904 10.6611V14.0002Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.82013 13.9989H2.91016V13.4388C3.56725 13.4388 4.9753 12.9721 5.82013 12.5986V13.9989Z"
      fill="white"
    />
  </svg>
);

const googleMeetIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.0547 9.98584L12.6145 11.6597L14.7121 12.9181L15.077 9.9964L14.7121 7.14062L12.5743 8.24605L11.0547 9.98584Z"
      fill="#00832D"
    />
    <path
      d="M2 12.6484V15.138C2 15.7065 2.4915 16.1681 3.09713 16.1681H5.749L6.29812 14.2869L5.749 12.6484L3.92963 12.1328L2 12.6484Z"
      fill="#0066DA"
    />
    <path
      d="M5.749 3.8125L2 7.33221L3.92975 7.84652L5.749 7.33221L6.28813 5.71594L5.749 3.8125Z"
      fill="#E94235"
    />
    <path d="M2 12.6499H5.74894V7.32812H2V12.6499Z" fill="#2684FC" />
    <path
      d="M17.1059 5.2978L14.7109 7.14239V12.9198L17.1158 14.7715C17.4758 15.0363 18.0024 14.795 18.0024 14.3654V5.69575C18.0024 5.26136 17.4632 5.02125 17.1058 5.29786"
      fill="#00AC47"
    />
    <path
      d="M11.0524 9.99219V12.6525H5.75V16.1722H13.6127C14.2184 16.1722 14.7098 15.7107 14.7098 15.1422V12.9244L11.0524 9.99219Z"
      fill="#00AC47"
    />
    <path
      d="M13.6127 3.8125H5.75V7.33221H11.0524V9.99253L14.7099 7.14726V4.84258C14.7099 4.274 14.2184 3.81256 13.6127 3.81256"
      fill="#FFBA00"
    />
  </svg>
);

const bottomNaveHomeIcon = (props: IconProps) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.71387 2.62395C11.598 1.07251 14.3073 1.07251 16.1914 2.62395L21.5205 7.01263C22.7096 7.99188 23.3974 9.45608 23.3975 10.9999V19.331C23.3975 22.1691 21.1141 24.4821 18.2822 24.4824H7.62305C4.79103 24.4824 2.50684 22.1693 2.50684 19.331V10.9999C2.50686 9.45598 3.19554 7.99188 4.38477 7.01263L9.71387 2.62395ZM10.8281 18.5224C10.3575 18.5224 9.97563 18.9043 9.97559 19.3749C9.97559 19.8456 10.3574 20.2275 10.8281 20.2275H15.0918L15.1787 20.2226C15.6085 20.179 15.9443 19.8162 15.9443 19.3749C15.9443 18.9337 15.6085 18.5709 15.1787 18.5273L15.0918 18.5224H10.8281Z"
      fill="currentColor"
    />
  </svg>
);

const bottomNaveExploreIcon = (props: IconProps) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.4868 23.4141H11.3125"
      stroke="currentColor"
      strokeWidth="1.70455"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5438 11.8373L4.43394 15.5691C4.35626 15.6623 4.30099 15.7721 4.27238 15.89C4.24377 16.008 4.24258 16.1309 4.2689 16.2493L5.49527 21.768C5.5245 21.8995 5.58676 22.0215 5.67616 22.1223C5.76557 22.2232 5.87918 22.2996 6.00628 22.3443C6.13339 22.3891 6.2698 22.4008 6.40267 22.3782C6.53553 22.3557 6.66047 22.2997 6.7657 22.2155L9.73938 19.8366M18.2239 11.7656L21.3935 15.5691C21.4712 15.6623 21.5264 15.7721 21.555 15.89C21.5836 16.008 21.5848 16.1309 21.5585 16.2493L20.3321 21.768C20.3029 21.8995 20.2407 22.0215 20.1513 22.1223C20.0618 22.2232 19.9482 22.2996 19.8211 22.3443C19.694 22.3891 19.5576 22.4008 19.4247 22.3782C19.2919 22.3557 19.1669 22.2997 19.0617 22.2155L16.088 19.8366"
      stroke="currentColor"
      strokeWidth="1.70455"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0579 1.74021C13.3832 1.76924 13.6935 1.89524 13.9486 2.10252C14.9369 2.90548 17.0825 4.90423 18.2689 7.98924C19.4722 11.1186 19.6528 15.2773 16.8314 20.2656C16.6802 20.5326 16.3969 20.6979 16.0902 20.6982H9.74153C9.43708 20.6982 9.15551 20.5351 9.00325 20.2715C6.12132 15.2787 6.29493 11.1146 7.51204 7.98045C8.71122 4.89287 10.8864 2.89391 11.8841 2.0947C12.1771 1.86004 12.5419 1.7322 12.9173 1.73338L13.0579 1.74021ZM12.8997 8.73435C12.0233 8.73435 11.313 9.44482 11.3128 10.3213C11.3128 11.1978 12.0232 11.9092 12.8997 11.9092C13.7762 11.9091 14.4866 11.1978 14.4866 10.3213C14.4865 9.44487 13.7761 8.73443 12.8997 8.73435Z"
      fill="currentColor"
    />
  </svg>
);

const bottomNaveDashboardIcon = (props: IconProps) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 30 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.56501 17.1572C4.56501 17.1572 1.43414 21.1336 3.07412 22.4591C3.07412 22.4591 3.67048 22.7537 5.01228 22.6064C9.33587 22.0173 20.0703 14.2117 23.7975 10.9716L23.2012 9.35156L29.0156 10.2352L27.0775 15.979L25.8848 14.3589C25.8848 14.3589 14.8522 23.1955 6.0559 25.2574C6.0559 25.2574 -4.38033 27.3192 4.41593 17.1572H4.56501Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.30469 13.6094H9.92645V19.795C8.58465 20.6786 6.94467 21.2677 5.30469 21.8568V13.6094Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.4297 9.35156H16.0515V15.979L11.4297 19.0718V9.35156Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5469 5.07031H22.1686V11.4032L17.5469 14.9378V5.07031Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.9968 26.8756H17.375V20.9846L21.9968 18.0391V26.8756Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.0515 26.8734H11.4297V24.0752L16.0515 21.7188V26.8734Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.92645 26.8732H5.30469V25.9895C6.34831 25.9895 8.58465 25.2532 9.92645 24.6641V26.8732Z"
      fill="currentColor"
    />
  </svg>
);

const bottomNavePremiumIcon = (props: IconProps) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.2529 1.56152C19.4764 1.56169 24.5215 6.6075 24.5215 12.8311C24.5213 19.0545 19.4763 24.0994 13.2529 24.0996C7.02935 24.0996 1.98357 19.0546 1.9834 12.8311C1.9834 6.6074 7.02924 1.56152 13.2529 1.56152ZM13.876 7.93457C13.564 7.51436 12.9238 7.52347 12.624 7.95215L11.0547 10.1992C10.8573 10.4817 10.491 10.598 10.1631 10.4824L8.02637 9.72949C7.46099 9.53075 6.89322 10.0194 7.01758 10.5977L8.26562 16.4014C8.34093 16.7503 8.65415 17 9.0166 17H17.6084C17.9768 17 18.2933 16.7419 18.3623 16.3857L19.4854 10.5928C19.5975 10.0142 19.0245 9.53746 18.4639 9.74316L16.458 10.4785C16.1359 10.5967 15.7733 10.4899 15.5703 10.2168L13.876 7.93457Z"
      fill="currentColor"
    />
  </svg>
);

const bottomNaveProfileIcon = (props: IconProps) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M12.9999 2.58331C10.2708 2.58331 8.052 4.80206 8.052 7.53123C8.052 10.2083 10.1458 12.375 12.8749 12.4687C12.9583 12.4583 13.0416 12.4583 13.1041 12.4687C13.1249 12.4687 13.1353 12.4687 13.1562 12.4687C13.1666 12.4687 13.1666 12.4687 13.177 12.4687C15.8437 12.375 17.9374 10.2083 17.9478 7.53123C17.9478 4.80206 15.7291 2.58331 12.9999 2.58331Z"
      fill="currentColor"
    />
    <path
      d="M18.2917 15.2396C15.3855 13.3021 10.6459 13.3021 7.71883 15.2396C6.39591 16.125 5.66675 17.3229 5.66675 18.6041C5.66675 19.8854 6.39591 21.0729 7.70841 21.9479C9.16675 22.9271 11.0834 23.4166 13.0001 23.4166C14.9167 23.4166 16.8334 22.9271 18.2917 21.9479C19.6042 21.0625 20.3334 19.875 20.3334 18.5833C20.323 17.3021 19.6042 16.1146 18.2917 15.2396Z"
      fill="currentColor"
    />
  </svg>
);

const toastDefaultIcon = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.0001 1.66666C5.40841 1.66666 1.66675 5.40832 1.66675 9.99999C1.66675 14.5917 5.40841 18.3333 10.0001 18.3333C14.5917 18.3333 18.3334 14.5917 18.3334 9.99999C18.3334 5.40832 14.5917 1.66666 10.0001 1.66666ZM9.37508 6.66666C9.37508 6.32499 9.65841 6.04166 10.0001 6.04166C10.3417 6.04166 10.6251 6.32499 10.6251 6.66666V10.8333C10.6251 11.175 10.3417 11.4583 10.0001 11.4583C9.65841 11.4583 9.37508 11.175 9.37508 10.8333V6.66666ZM10.7667 13.65C10.7251 13.7583 10.6667 13.8417 10.5917 13.925C10.5084 14 10.4167 14.0583 10.3167 14.1C10.2167 14.1417 10.1084 14.1667 10.0001 14.1667C9.89175 14.1667 9.78341 14.1417 9.68341 14.1C9.58341 14.0583 9.49175 14 9.40841 13.925C9.33341 13.8417 9.27508 13.7583 9.23341 13.65C9.19175 13.55 9.16675 13.4417 9.16675 13.3333C9.16675 13.225 9.19175 13.1167 9.23341 13.0167C9.27508 12.9167 9.33341 12.825 9.40841 12.7417C9.49175 12.6667 9.58341 12.6083 9.68341 12.5667C9.88341 12.4833 10.1167 12.4833 10.3167 12.5667C10.4167 12.6083 10.5084 12.6667 10.5917 12.7417C10.6667 12.825 10.7251 12.9167 10.7667 13.0167C10.8084 13.1167 10.8334 13.225 10.8334 13.3333C10.8334 13.4417 10.8084 13.55 10.7667 13.65Z"
      fill="#3F3F46"
    />
  </svg>
);

const toastSuccessIcon = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 1.25C12.3206 1.25 14.5462 2.17187 16.1872 3.81282C17.8281 5.45376 18.75 7.67936 18.75 10C18.75 12.3206 17.8281 14.5462 16.1872 16.1872C14.5462 17.8281 12.3206 18.75 10 18.75C7.67936 18.75 5.45376 17.8281 3.81282 16.1872C2.17187 14.5462 1.25 12.3206 1.25 10C1.25 7.67936 2.17187 5.45376 3.81282 3.81282C5.45376 2.17187 7.67936 1.25 10 1.25ZM8.91 11.7262L6.96625 9.78125C6.89657 9.71157 6.81384 9.65629 6.7228 9.61858C6.63175 9.58087 6.53417 9.56146 6.43563 9.56146C6.33708 9.56146 6.2395 9.58087 6.14845 9.61858C6.05741 9.65629 5.97468 9.71157 5.905 9.78125C5.76427 9.92198 5.68521 10.1129 5.68521 10.3119C5.68521 10.5109 5.76427 10.7018 5.905 10.8425L8.38 13.3175C8.44948 13.3875 8.53214 13.4431 8.62322 13.4811C8.71429 13.519 8.81197 13.5385 8.91062 13.5385C9.00928 13.5385 9.10696 13.519 9.19803 13.4811C9.28911 13.4431 9.37177 13.3875 9.44125 13.3175L14.5662 8.19125C14.6369 8.12186 14.693 8.03917 14.7315 7.94796C14.77 7.85674 14.7901 7.75881 14.7906 7.65981C14.791 7.5608 14.7719 7.46269 14.7342 7.37112C14.6966 7.27956 14.6412 7.19635 14.5712 7.1263C14.5012 7.05625 14.4181 7.00075 14.3266 6.963C14.2351 6.92524 14.137 6.90598 14.038 6.90632C13.939 6.90667 13.841 6.92661 13.7497 6.965C13.6585 7.00339 13.5757 7.05947 13.5063 7.13L8.91 11.7262Z"
      fill="#0E793C"
    />
  </svg>
);

const toastPendingIcon = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 1C9.21143 1 7.89372 1.29813 6.65372 1.63C5.38515 1.9675 4.10629 2.36687 3.35429 2.60875C3.03988 2.71096 2.76114 2.8984 2.55008 3.14954C2.33903 3.40068 2.20422 3.70533 2.16115 4.0285C1.48001 9.06513 3.06058 12.7979 4.97829 15.2673C5.79182 16.3233 6.76143 17.2535 7.85486 18.0269C8.296 18.334 8.70514 18.5691 9.05257 18.73C9.37257 18.8785 9.71657 19 10 19C10.2834 19 10.6263 18.8785 10.9474 18.73C11.3667 18.5304 11.7675 18.2951 12.1451 18.0269C13.2386 17.2535 14.2082 16.3233 15.0217 15.2673C16.9394 12.7979 18.52 9.06513 17.8389 4.0285C17.796 3.70513 17.6613 3.40024 17.4502 3.14888C17.2391 2.89753 16.9603 2.70992 16.6457 2.60763C15.554 2.25551 14.4539 1.92917 13.3463 1.62888C12.1063 1.29925 10.7886 1 10 1ZM9.37143 10.5647L8.97143 6.61937C8.95621 6.47745 8.97147 6.33395 9.01623 6.19821C9.06099 6.06246 9.13423 5.93749 9.23122 5.83141C9.32821 5.72533 9.44677 5.64051 9.57921 5.58244C9.71165 5.52438 9.85502 5.49437 10 5.49437C10.145 5.49437 10.2883 5.52438 10.4208 5.58244C10.5532 5.64051 10.6718 5.72533 10.7688 5.83141C10.8658 5.93749 10.939 6.06246 10.9838 6.19821C11.0285 6.33395 11.0438 6.47745 11.0286 6.61937L10.6286 10.5647C10.6151 10.7197 10.5431 10.8641 10.4267 10.9693C10.3103 11.0746 10.158 11.1329 10 11.1329C9.84197 11.1329 9.6897 11.0746 9.57331 10.9693C9.45691 10.8641 9.38487 10.7197 9.37143 10.5647ZM10.0023 14.5C9.69918 14.5 9.40849 14.3815 9.19416 14.1705C8.97984 13.9595 8.85943 13.6734 8.85943 13.375C8.85943 13.0766 8.97984 12.7905 9.19416 12.5795C9.40849 12.3685 9.69918 12.25 10.0023 12.25C10.3054 12.25 10.5961 12.3685 10.8104 12.5795C11.0247 12.7905 11.1451 13.0766 11.1451 13.375C11.1451 13.6734 11.0247 13.9595 10.8104 14.1705C10.5961 14.3815 10.3054 14.5 10.0023 14.5Z"
      fill="#986A1F"
    />
  </svg>
);

const toastFailedIcon = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.0001 1.45834C9.61376 1.45828 9.23427 1.56034 8.90009 1.75418L3.39176 4.92084L3.39009 4.92251C3.05595 5.11679 2.77865 5.39536 2.58591 5.73039C2.39317 6.06542 2.29174 6.44516 2.29176 6.83168V13.1675C2.29075 13.5543 2.39176 13.9346 2.58459 14.2699C2.77742 14.6052 3.05526 14.8838 3.39009 15.0775L3.39259 15.0792L8.89926 18.245H8.90092C9.23499 18.4388 9.61432 18.5408 10.0005 18.5408C10.3867 18.5408 10.766 18.4388 11.1001 18.245H11.1009L16.6076 15.0783H16.6101C16.9446 14.8839 17.2221 14.6049 17.4149 14.2694C17.6076 13.9339 17.7089 13.5536 17.7084 13.1667V6.83334C17.7086 6.44669 17.6072 6.06677 17.4145 5.73158C17.2217 5.3964 16.9444 5.11769 16.6101 4.92334L11.1018 1.75668L11.1001 1.75501C10.766 1.56088 10.3865 1.45853 10.0001 1.45834ZM10.0001 5.73084C10.1658 5.73084 10.3248 5.79669 10.442 5.9139C10.5592 6.03111 10.6251 6.19008 10.6251 6.35584V10.9392C10.6251 11.1049 10.5592 11.2639 10.442 11.3811C10.3248 11.4983 10.1658 11.5642 10.0001 11.5642C9.83433 11.5642 9.67536 11.4983 9.55815 11.3811C9.44094 11.2639 9.37509 11.1049 9.37509 10.9392V6.35584C9.37509 6.19008 9.44094 6.03111 9.55815 5.9139C9.67536 5.79669 9.83433 5.73084 10.0001 5.73084ZM10.6251 13.2275V13.6442C10.6251 13.8099 10.5592 13.9689 10.442 14.0861C10.3248 14.2033 10.1658 14.2692 10.0001 14.2692C9.83433 14.2692 9.67536 14.2033 9.55815 14.0861C9.44094 13.9689 9.37509 13.8099 9.37509 13.6442V13.2275C9.37509 13.0618 9.44094 12.9028 9.55815 12.7856C9.67536 12.6684 9.83433 12.6025 10.0001 12.6025C10.1658 12.6025 10.3248 12.6684 10.442 12.7856C10.5592 12.9028 10.6251 13.0618 10.6251 13.2275Z"
      fill="#C20E4D"
    />
  </svg>
);

const errorWarningIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12 9V14"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.0001 21.41H5.94005C2.47005 21.41 1.02005 18.93 2.70005 15.9L5.82006 10.28L8.76006 5.00003C10.5401 1.79003 13.4601 1.79003 15.2401 5.00003L18.1801 10.29L21.3001 15.91C22.9801 18.94 21.5201 21.42 18.0601 21.42H12.0001V21.41Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9945 17H12.0035"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const errorWarningFilledIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.134 15.2641L14.8007 5.66406C14.084 4.3724 13.0924 3.66406 12.0007 3.66406C10.909 3.66406 9.91738 4.3724 9.20071 5.66406L3.86738 15.2641C3.19238 16.4891 3.11738 17.6641 3.65905 18.5891C4.20071 19.5141 5.26738 20.0224 6.66738 20.0224H17.334C18.734 20.0224 19.8007 19.5141 20.3424 18.5891C20.884 17.6641 20.809 16.4807 20.134 15.2641ZM11.3757 9.4974C11.3757 9.15573 11.659 8.8724 12.0007 8.8724C12.3424 8.8724 12.6257 9.15573 12.6257 9.4974V13.6641C12.6257 14.0057 12.3424 14.2891 12.0007 14.2891C11.659 14.2891 11.3757 14.0057 11.3757 13.6641V9.4974ZM12.5924 16.7557C12.5507 16.7891 12.509 16.8224 12.4674 16.8557C12.4174 16.8891 12.3674 16.9141 12.3174 16.9307C12.2674 16.9557 12.2174 16.9724 12.159 16.9807C12.109 16.9891 12.0507 16.9974 12.0007 16.9974C11.9507 16.9974 11.8924 16.9891 11.834 16.9807C11.784 16.9724 11.734 16.9557 11.684 16.9307C11.634 16.9141 11.584 16.8891 11.534 16.8557C11.4924 16.8224 11.4507 16.7891 11.409 16.7557C11.259 16.5974 11.1674 16.3807 11.1674 16.1641C11.1674 15.9474 11.259 15.7307 11.409 15.5724C11.4507 15.5391 11.4924 15.5057 11.534 15.4724C11.584 15.4391 11.634 15.4141 11.684 15.3974C11.734 15.3724 11.784 15.3557 11.834 15.3474C11.9424 15.3224 12.059 15.3224 12.159 15.3474C12.2174 15.3557 12.2674 15.3724 12.3174 15.3974C12.3674 15.4141 12.4174 15.4391 12.4674 15.4724C12.509 15.5057 12.5507 15.5391 12.5924 15.5724C12.7424 15.7307 12.834 15.9474 12.834 16.1641C12.834 16.3807 12.7424 16.5974 12.5924 16.7557Z"
      fill="currentColor"
    />
  </svg>
);

const whatsappIconV2 = (props: IconProps) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.99741 2.46875C14.5999 2.46875 18.3307 6.19958 18.3307 10.8021C18.3307 15.4046 14.5999 19.1354 9.99741 19.1354C8.5247 19.138 7.07789 18.7482 5.80574 18.0063L1.66741 19.1354L2.79408 14.9954C2.05154 13.7229 1.66149 12.2754 1.66408 10.8021C1.66408 6.19958 5.39491 2.46875 9.99741 2.46875ZM7.15741 6.88542L6.99074 6.89208C6.88298 6.89951 6.7777 6.92781 6.68074 6.97542C6.59039 7.02668 6.50788 7.09066 6.43574 7.16542C6.33574 7.25958 6.27908 7.34125 6.21824 7.42042C5.91001 7.82117 5.74405 8.31318 5.74658 8.81875C5.74824 9.22708 5.85491 9.62458 6.02157 9.99625C6.36241 10.7479 6.92324 11.5437 7.66324 12.2812C7.84158 12.4587 8.01658 12.6371 8.20491 12.8029C9.12443 13.6124 10.2201 14.1962 11.4049 14.5079L11.8782 14.5804C12.0324 14.5887 12.1866 14.5771 12.3416 14.5696C12.5842 14.5568 12.8212 14.4911 13.0357 14.3771C13.1448 14.3207 13.2513 14.2595 13.3549 14.1937C13.3549 14.1937 13.3902 14.1699 13.4591 14.1187C13.5716 14.0354 13.6407 13.9762 13.7341 13.8787C13.8041 13.8065 13.8624 13.7226 13.9091 13.6271C13.9741 13.4913 14.0391 13.2321 14.0657 13.0162C14.0857 12.8512 14.0799 12.7613 14.0774 12.7054C14.0741 12.6163 13.9999 12.5237 13.9191 12.4846L13.4341 12.2671C13.4341 12.2671 12.7091 11.9513 12.2657 11.7496C12.2193 11.7294 12.1696 11.7178 12.1191 11.7154C12.0621 11.7095 12.0044 11.7158 11.9501 11.7341C11.8957 11.7523 11.8459 11.7821 11.8041 11.8212C11.7999 11.8196 11.7441 11.8671 11.1416 12.5971C11.107 12.6436 11.0594 12.6787 11.0047 12.698C10.9501 12.7173 10.891 12.7199 10.8349 12.7054C10.7806 12.6909 10.7274 12.6726 10.6757 12.6504C10.5724 12.6071 10.5366 12.5904 10.4657 12.5604C9.9873 12.352 9.54444 12.07 9.15324 11.7246C9.04824 11.6329 8.95074 11.5329 8.85074 11.4362C8.52292 11.1223 8.2372 10.7671 8.00074 10.3796L7.95157 10.3004C7.91679 10.2469 7.88827 10.1896 7.86658 10.1296C7.83491 10.0071 7.91741 9.90875 7.91741 9.90875C7.91741 9.90875 8.11991 9.68708 8.21408 9.56708C8.30574 9.45042 8.38324 9.33708 8.43324 9.25625C8.53158 9.09792 8.56241 8.93542 8.51074 8.80958C8.27741 8.23958 8.0363 7.67264 7.78741 7.10875C7.73824 6.99708 7.59241 6.91708 7.45991 6.90125C7.41491 6.89569 7.36991 6.89125 7.32491 6.88792C7.21302 6.8815 7.10082 6.88261 6.98908 6.89125L7.15741 6.88542Z"
      fill="currentColor"
    />
  </svg>
);

const callIconV2 = (props: IconProps) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.2696 19.152C14.5071 19.152 13.436 18.8762 11.8321 17.9801C9.88171 16.8864 8.37312 15.8766 6.43327 13.9418C4.56296 12.0727 3.6528 10.8625 2.37898 8.54456C0.939914 5.92737 1.18523 4.5555 1.45945 3.96917C1.78601 3.26839 2.26804 2.84925 2.89109 2.43323C3.24497 2.20137 3.61947 2.00261 4.00984 1.83948C4.0489 1.82268 4.08523 1.80667 4.11765 1.79222C4.31101 1.70511 4.60398 1.57347 4.97507 1.71409C5.22273 1.80706 5.44382 1.99729 5.78991 2.33909C6.49968 3.03909 7.4696 4.59807 7.82741 5.3637C8.06765 5.87972 8.22663 6.22034 8.22702 6.60237C8.22702 7.04964 8.00202 7.39456 7.72898 7.76682C7.6778 7.83675 7.62702 7.90354 7.5778 7.96839C7.28054 8.35901 7.2153 8.4719 7.25827 8.67347C7.34538 9.07854 7.99499 10.2844 9.06257 11.3496C10.1301 12.4149 11.3012 13.0235 11.7079 13.1102C11.918 13.1551 12.0333 13.0871 12.4364 12.7793C12.4942 12.7352 12.5536 12.6895 12.6157 12.6438C13.0321 12.334 13.361 12.1149 13.7977 12.1149H13.8001C14.1801 12.1149 14.5055 12.2797 15.0446 12.5516C15.7477 12.9063 17.3536 13.8637 18.0579 14.5742C18.4005 14.9196 18.5915 15.1399 18.6848 15.3871C18.8255 15.7594 18.693 16.0512 18.6067 16.2465C18.5923 16.2789 18.5762 16.3145 18.5594 16.3539C18.395 16.7436 18.1951 17.1173 17.9622 17.4703C17.5469 18.0914 17.1262 18.5723 16.4239 18.8992C16.0633 19.0699 15.6685 19.1563 15.2696 19.152Z"
      fill="currentColor"
    />
  </svg>
);

const queryIconV2 = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_8956_22675)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.98143 2.14362C9.38424 2.13283 8.79078 2.23992 8.23502 2.45875C7.67926 2.67758 7.17211 3.00386 6.74259 3.41892C6.31308 3.83397 5.96962 4.32965 5.73189 4.87759C5.49416 5.42553 5.36681 6.01498 5.35714 6.61219V12.8579C5.35714 13.2368 5.20663 13.6001 4.93872 13.8681C4.67081 14.136 4.30745 14.2865 3.92857 14.2865H2.14286C1.57454 14.2865 1.02949 14.0607 0.627628 13.6588C0.225765 13.257 0 12.7119 0 12.1436L0 9.28647C0 8.71815 0.225765 8.17311 0.627628 7.77124C1.02949 7.36938 1.57454 7.14362 2.14286 7.14362H3.21429V6.58647C3.22732 5.70846 3.41319 4.84162 3.76128 4.03545C4.10936 3.22929 4.61285 2.49959 5.24298 1.88803C5.87311 1.27647 6.61755 0.795029 7.43376 0.471209C8.24998 0.147388 9.12199 -0.0124718 10 0.00075902C10.878 -0.0124718 11.75 0.147388 12.5662 0.471209C13.3825 0.795029 14.1269 1.27647 14.757 1.88803C15.3872 2.49959 15.8906 3.22929 16.2387 4.03545C16.5868 4.84162 16.7727 5.70846 16.7857 6.58647V7.14362H17.8571C18.4255 7.14362 18.9705 7.36938 19.3724 7.77124C19.7742 8.17311 20 8.71815 20 9.28647V12.1436C20 12.7119 19.7742 13.257 19.3724 13.6588C18.9705 14.0607 18.4255 14.2865 17.8571 14.2865H16.7857V15.0008C16.7859 15.9661 16.4306 16.8978 15.7877 17.6179C15.1448 18.338 14.2592 18.7962 13.3 18.905C13.1137 19.2376 12.8421 19.5145 12.5131 19.7071C12.1842 19.8997 11.8098 20.0011 11.4286 20.0008H9.28571C8.71739 20.0008 8.17235 19.775 7.77049 19.3731C7.36862 18.9713 7.14286 18.4262 7.14286 17.8579C7.14286 17.2896 7.36862 16.7445 7.77049 16.3427C8.17235 15.9408 8.71739 15.715 9.28571 15.715H11.4286C12.2029 15.715 12.8814 16.125 13.2571 16.7408C13.6509 16.6503 14.0023 16.4289 14.254 16.1129C14.5057 15.7968 14.6428 15.4048 14.6429 15.0008V6.61076C14.6331 6.01047 14.5044 5.41808 14.2642 4.86783C14.0241 4.31759 13.6773 3.82039 13.2438 3.405C12.8104 2.98961 12.2989 2.66425 11.7389 2.44774C11.1789 2.23123 10.5816 2.12787 9.98143 2.14362Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_8956_22675">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const emailIconV2 = (props: IconProps) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.166 3.51953H5.83268C3.33268 3.51953 1.66602 4.76953 1.66602 7.6862V13.5195C1.66602 16.4362 3.33268 17.6862 5.83268 17.6862H14.166C16.666 17.6862 18.3327 16.4362 18.3327 13.5195V7.6862C18.3327 4.76953 16.666 3.51953 14.166 3.51953ZM14.5577 8.59453L11.9493 10.6779C11.3993 11.1195 10.6993 11.3362 9.99935 11.3362C9.29935 11.3362 8.59102 11.1195 8.04935 10.6779L5.44102 8.59453C5.17435 8.37786 5.13268 7.97786 5.34102 7.7112C5.55768 7.44453 5.94935 7.39453 6.21602 7.6112L8.82435 9.69453C9.45768 10.2029 10.5327 10.2029 11.166 9.69453L13.7743 7.6112C14.041 7.39453 14.441 7.4362 14.6493 7.7112C14.866 7.97786 14.8243 8.37786 14.5577 8.59453Z"
      fill="currentColor"
    />
  </svg>
);

const emailIconV3 = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.4"
      d="M17 20.5H7C4 20.5 2 19 2 15.5V8.5C2 5 4 3.5 7 3.5H17C20 3.5 22 5 22 8.5V15.5C22 19 20 20.5 17 20.5Z"
      fill="currentColor"
    />
    <path
      d="M12.0008 12.87C11.1608 12.87 10.3108 12.61 9.66076 12.08L6.53075 9.57997C6.21075 9.31997 6.15076 8.84997 6.41076 8.52997C6.67076 8.20997 7.14076 8.14997 7.46076 8.40997L10.5908 10.91C11.3508 11.52 12.6407 11.52 13.4007 10.91L16.5308 8.40997C16.8508 8.14997 17.3308 8.19997 17.5808 8.52997C17.8408 8.84997 17.7908 9.32997 17.4608 9.57997L14.3308 12.08C13.6908 12.61 12.8408 12.87 12.0008 12.87Z"
      fill="#292D32"
    />
  </svg>
);

const emailIconV4 = (props: IconProps) => (
  <svg
    fill="none"
    viewBox="0 0 24 24"
    stroke="currentColor"
    strokeWidth={2}
    {...props}
  >
    <path
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
    />
  </svg>
);

const supportIconV1 = (props: IconProps) => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 44 44"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g data-figma-bg-blur-radius="24.09">
      <rect width="44" height="44" rx="22" fill="white" />
      <rect
        x="0.55"
        y="0.55"
        width="42.9"
        height="42.9"
        rx="21.45"
        stroke="currentColor"
        strokeOpacity="0.5"
        strokeWidth="1.1"
      />
      <path
        d="M21.8781 25.1321V24.0304C21.8781 22.4417 22.8594 21.6006 23.8406 20.9231C24.7984 20.269 25.7562 19.428 25.7562 17.886C25.7562 15.7367 24.0274 14.0078 21.8781 14.0078C19.7288 14.0078 18 15.7367 18 17.886"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.8607 30.1134H21.8818"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="bgblur_0_9396_70765_clip_path" transform="translate(0 0)">
        <rect width="44" height="44" rx="22" />
      </clipPath>
    </defs>
  </svg>
);

const supportIconV2 = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_7339_20261)">
      <path
        d="M10.0013 18.3229C14.6037 18.3229 18.3346 14.592 18.3346 9.98958C18.3346 5.38721 14.6037 1.65625 10.0013 1.65625C5.39893 1.65625 1.66797 5.38721 1.66797 9.98958C1.66797 14.592 5.39893 18.3229 10.0013 18.3229Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.57422 7.49852C7.77014 6.94158 8.15685 6.47194 8.66585 6.1728C9.17485 5.87365 9.7733 5.7643 10.3552 5.86411C10.9371 5.96393 11.4649 6.26646 11.8451 6.71813C12.2253 7.1698 12.4334 7.74146 12.4326 8.33185C12.4326 9.99852 9.93255 10.8319 9.93255 10.8319"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 14.1562H10.0084"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7339_20261">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const userProfileIconV1 = (props: IconProps) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.99837 8.49967C9.83932 8.49967 11.3317 7.00729 11.3317 5.16634C11.3317 3.32539 9.83932 1.83301 7.99837 1.83301C6.15742 1.83301 4.66504 3.32539 4.66504 5.16634C4.66504 7.00729 6.15742 8.49967 7.99837 8.49967Z"
      stroke="#444444"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.7248 15.1667C13.7248 12.5867 11.1581 10.5 7.99815 10.5C4.83815 10.5 2.27148 12.5867 2.27148 15.1667"
      stroke="#444444"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const cardIconV1 = (props: IconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.99805 6.66699H14.6647"
      stroke="#444444"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.69755 13.6665H4.29089C1.92423 13.6665 1.32422 13.0798 1.32422 10.7398V5.25985C1.32422 3.13985 1.81757 2.45985 3.67757 2.35318C3.86424 2.34651 4.07089 2.33984 4.29089 2.33984H11.6976C14.0642 2.33984 14.6642 2.92651 14.6642 5.26651V8.20651"
      stroke="#444444"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.99805 10.667H6.66471"
      stroke="#444444"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6644 11.9997C14.6644 12.4997 14.5244 12.973 14.2777 13.373C13.8177 14.1463 12.9711 14.6663 11.9977 14.6663C11.0244 14.6663 10.1777 14.1463 9.71773 13.373C9.47107 12.973 9.33105 12.4997 9.33105 11.9997C9.33105 10.5263 10.5244 9.33301 11.9977 9.33301C13.4711 9.33301 14.6644 10.5263 14.6644 11.9997Z"
      stroke="#444444"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.958 12L11.618 12.66L13.038 11.3467"
      stroke="#444444"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const phoneIconV1 = (props: IconProps) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.2523 13.1018C15.2523 13.3641 15.194 13.6337 15.0701 13.896C14.9462 14.1584 14.7859 14.4061 14.5746 14.6393C14.2175 15.0328 13.824 15.317 13.3795 15.4992C12.9423 15.6814 12.4687 15.7761 11.9586 15.7761C11.2153 15.7761 10.421 15.6012 9.58301 15.2441C8.74501 14.8871 7.90701 14.4061 7.07629 13.8013C6.23829 13.1892 5.44401 12.5115 4.68617 11.761C3.93561 11.0031 3.25792 10.2088 2.6531 9.37813C2.05557 8.54741 1.57463 7.7167 1.22486 6.89327C0.875083 6.06256 0.700195 5.26828 0.700195 4.51043C0.700195 4.01492 0.787639 3.54127 0.962526 3.10405C1.13741 2.65954 1.41432 2.25147 1.80053 1.88712C2.26689 1.42804 2.77698 1.20215 3.31622 1.20215C3.52025 1.20215 3.72429 1.24587 3.90646 1.33331C4.09592 1.42076 4.26352 1.55192 4.39469 1.74138L6.08527 4.12422C6.21643 4.3064 6.31116 4.474 6.37674 4.63431C6.44233 4.78734 6.47876 4.94036 6.47876 5.07882C6.47876 5.2537 6.42775 5.42859 6.32574 5.59619C6.23101 5.76379 6.09255 5.93868 5.91767 6.11357L5.36386 6.68924C5.2837 6.76939 5.24726 6.86412 5.24726 6.98072C5.24726 7.03901 5.25455 7.09002 5.26913 7.14832C5.29099 7.20661 5.31285 7.25033 5.32742 7.29405C5.45859 7.53452 5.68448 7.84786 6.00511 8.22679C6.33302 8.60571 6.6828 8.99192 7.06172 9.37813C7.45522 9.76434 7.83414 10.1214 8.22035 10.4493C8.59927 10.7699 8.91261 10.9885 9.16037 11.1197C9.1968 11.1343 9.24052 11.1561 9.29153 11.178C9.34983 11.1999 9.40812 11.2072 9.47371 11.2072C9.59759 11.2072 9.69232 11.1634 9.77247 11.0833L10.3263 10.5368C10.5085 10.3546 10.6833 10.2161 10.8509 10.1287C11.0185 10.0267 11.1861 9.97566 11.3683 9.97566C11.5068 9.97566 11.6525 10.0048 11.8128 10.0704C11.9731 10.136 12.1407 10.2307 12.3229 10.3546L14.7349 12.067C14.9244 12.1982 15.0555 12.3512 15.1357 12.5334C15.2086 12.7156 15.2523 12.8977 15.2523 13.1018Z"
      stroke="#444444"
      strokeMiterlimit="10"
    />
    <path
      d="M12.7233 6.30239C12.7233 5.86517 12.3808 5.19477 11.8707 4.64825C11.4043 4.14545 10.785 3.75195 10.1729 3.75195"
      stroke="#444444"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.2737 6.30303C15.2737 3.48297 12.9929 1.20215 10.1729 1.20215"
      stroke="#444444"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const emailIconV1 = (props: IconProps) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.597656"
      y="3.5"
      width="14.8"
      height="10"
      rx="1"
      stroke="#444444"
    />
    <path
      d="M14.998 4L8.57929 8.58483C8.23159 8.83319 7.76451 8.83319 7.41681 8.58483L0.998047 4"
      stroke="#444444"
    />
  </svg>
);

const lockIconV1 = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 16C2 13.1716 2 11.7574 2.87868 10.8787C3.75736 10 5.17157 10 8 10H16C18.8284 10 20.2426 10 21.1213 10.8787C22 11.7574 22 13.1716 22 16C22 18.8284 22 20.2426 21.1213 21.1213C20.2426 22 18.8284 22 16 22H8C5.17157 22 3.75736 22 2.87868 21.1213C2 20.2426 2 18.8284 2 16Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      d="M6 10V8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8V10"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path
      d="M8 16H8.009M11.991 16H12M15.991 16H16"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const lockIconV2 = (props: IconProps) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M31.6667 18.333H8.33333C6.49238 18.333 5 19.8254 5 21.6663V33.333C5 35.174 6.49238 36.6663 8.33333 36.6663H31.6667C33.5076 36.6663 35 35.174 35 33.333V21.6663C35 19.8254 33.5076 18.333 31.6667 18.333Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.668 18.333V11.6663C11.668 9.4562 12.5459 7.33659 14.1087 5.77378C15.6715 4.21098 17.7912 3.33301 20.0013 3.33301C22.2114 3.33301 24.3311 4.21098 25.8939 5.77378C27.4567 7.33659 28.3346 9.4562 28.3346 11.6663V18.333"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const lockIconV3 = (props: IconProps) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M31.6667 18.333H8.33333C6.49238 18.333 5 19.8254 5 21.6663V33.333C5 35.174 6.49238 36.6663 8.33333 36.6663H31.6667C33.5076 36.6663 35 35.174 35 33.333V21.6663C35 19.8254 33.5076 18.333 31.6667 18.333Z"
      fill="currentColor"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.668 18.333V11.6663C11.668 9.4562 12.5459 7.33659 14.1087 5.77378C15.6715 4.21098 17.7912 3.33301 20.0013 3.33301C22.2114 3.33301 24.3311 4.21098 25.8939 5.77378C27.4567 7.33659 28.3346 9.4562 28.3346 11.6663V18.333"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const lockIconV4 = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25261 7.4974V5.41406C6.25261 4.4195 6.6477 3.46567 7.35096 2.76241C8.05422 2.05915 9.00805 1.66406 10.0026 1.66406C10.9972 1.66406 11.951 2.05915 12.6543 2.76241C13.3575 3.46567 13.7526 4.4195 13.7526 5.41406V7.4974H15.8359C16.0568 7.4974 16.2686 7.58508 16.4249 7.74118C16.5812 7.89728 16.6691 8.10903 16.6693 8.3299V17.4974C16.6696 17.6069 16.6483 17.7154 16.6065 17.8167C16.5648 17.9179 16.5034 18.0099 16.4259 18.0874C16.3485 18.1648 16.2565 18.2262 16.1552 18.268C16.054 18.3097 15.9455 18.3311 15.8359 18.3307H4.16927C3.94841 18.3307 3.73657 18.243 3.58031 18.0869C3.42406 17.9308 3.33616 17.7191 3.33594 17.4982V8.33073C3.33561 8.2212 3.35694 8.11269 3.3987 8.01144C3.44046 7.91018 3.50183 7.81819 3.57928 7.74074C3.65673 7.66329 3.74873 7.60192 3.84998 7.56016C3.95124 7.51839 4.05975 7.49707 4.16927 7.4974H6.25261ZM7.50261 7.4974H12.5026V5.41406C12.5026 4.75102 12.2392 4.11514 11.7704 3.6463C11.3015 3.17745 10.6656 2.91406 10.0026 2.91406C9.33957 2.91406 8.70368 3.17745 8.23484 3.6463C7.766 4.11514 7.50261 4.75102 7.50261 5.41406V7.4974ZM9.50261 13.2266V14.9974H10.5026V13.2266C10.7658 13.1117 10.9814 12.9097 11.1132 12.6545C11.245 12.3994 11.2849 12.1066 11.2262 11.8255C11.1676 11.5444 11.0139 11.2921 10.791 11.1109C10.5682 10.9298 10.2898 10.8309 10.0026 10.8309C9.71543 10.8309 9.43702 10.9298 9.21417 11.1109C8.99133 11.2921 8.83765 11.5444 8.77898 11.8255C8.7203 12.1066 8.76021 12.3994 8.892 12.6545C9.02379 12.9097 9.23941 13.1117 9.50261 13.2266Z"
      fill="currentColor"
    />
  </svg>
);

const doubleArrow = (props: IconProps) => (
  <svg
    width="66"
    height="66"
    viewBox="0 0 66 66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M47.1608 38.0078L38.8008 46.3678"
      stroke="white"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.8359 38.0078H47.1609"
      stroke="white"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.8359 27.9928L27.1959 19.6328"
      stroke="white"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M47.1609 27.9922H18.8359"
      stroke="white"
      strokeWidth="3"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const refreshIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.5 12C17.5 15.04 15.04 17.5 12 17.5C8.96 17.5 7.10999 14.44 7.10999 14.44M7.10999 14.44H9.59M7.10999 14.44V17.19M6.5 12C6.5 8.96 8.94 6.5 12 6.5C15.67 6.5 17.5 9.56 17.5 9.56M17.5 9.56V6.81M17.5 9.56H15.06"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const rightSignIcon = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.26062 16.5431C6.91062 16.5431 6.57813 16.4031 6.33313 16.1581L1.38062 11.2056C0.873125 10.6981 0.873125 9.85812 1.38062 9.35062C1.88812 8.84312 2.72812 8.84312 3.23562 9.35062L7.26062 13.3756L16.2556 4.38062C16.7631 3.87313 17.6031 3.87313 18.1106 4.38062C18.6181 4.88812 18.6181 5.72812 18.1106 6.23562L8.18812 16.1581C7.94312 16.4031 7.61062 16.5431 7.26062 16.5431Z"
      fill="currentColor"
    />
  </svg>
);

const sipTabIcon = (props: IconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.1662 2.37325V1.33325C11.1662 1.05992 10.9395 0.833252 10.6662 0.833252C10.3928 0.833252 10.1662 1.05992 10.1662 1.33325V2.33325H5.83283V1.33325C5.83283 1.05992 5.60617 0.833252 5.33284 0.833252C5.0595 0.833252 4.83284 1.05992 4.83284 1.33325V2.37325C3.03284 2.53992 2.1595 3.61325 2.02617 5.20659C2.01284 5.39992 2.17284 5.55992 2.3595 5.55992H13.6395C13.8328 5.55992 13.9928 5.39325 13.9728 5.20659C13.8395 3.61325 12.9662 2.53992 11.1662 2.37325Z"
      fill="currentColor"
    />
    <path
      d="M12.6667 10C11.1933 10 10 11.1933 10 12.6667C10 13.1667 10.14 13.64 10.3867 14.04C10.8467 14.8133 11.6933 15.3333 12.6667 15.3333C13.64 15.3333 14.4867 14.8133 14.9467 14.04C15.1933 13.64 15.3333 13.1667 15.3333 12.6667C15.3333 11.1933 14.14 10 12.6667 10ZM14.0467 12.38L12.6267 13.6933C12.5333 13.78 12.4067 13.8267 12.2867 13.8267C12.16 13.8267 12.0333 13.78 11.9333 13.68L11.2733 13.02C11.08 12.8267 11.08 12.5067 11.2733 12.3133C11.4667 12.12 11.7867 12.12 11.98 12.3133L12.3 12.6333L13.3667 11.6467C13.5667 11.46 13.8867 11.4733 14.0733 11.6733C14.26 11.8733 14.2467 12.1867 14.0467 12.38Z"
      fill="currentColor"
    />
    <path
      d="M13.3333 6.56006H2.66667C2.3 6.56006 2 6.86006 2 7.22673V11.3334C2 13.3334 3 14.6667 5.33333 14.6667H8.62C9.08 14.6667 9.4 14.2201 9.25333 13.7867C9.12 13.4001 9.00667 12.9734 9.00667 12.6667C9.00667 10.6467 10.6533 9.00006 12.6733 9.00006C12.8667 9.00006 13.06 9.01339 13.2467 9.04673C13.6467 9.10673 14.0067 8.79339 14.0067 8.39339V7.23339C14 6.86006 13.7 6.56006 13.3333 6.56006ZM6.14 12.1401C6.01333 12.2601 5.84 12.3334 5.66667 12.3334C5.49333 12.3334 5.32 12.2601 5.19333 12.1401C5.07333 12.0134 5 11.8401 5 11.6667C5 11.4934 5.07333 11.3201 5.19333 11.1934C5.26 11.1334 5.32667 11.0867 5.41333 11.0534C5.66 10.9467 5.95333 11.0067 6.14 11.1934C6.26 11.3201 6.33333 11.4934 6.33333 11.6667C6.33333 11.8401 6.26 12.0134 6.14 12.1401ZM6.14 9.80673C6.10667 9.83339 6.07333 9.86006 6.04 9.88673C6 9.91339 5.96 9.93339 5.92 9.94673C5.88 9.96673 5.84 9.98006 5.8 9.98672C5.75333 9.99339 5.70667 10.0001 5.66667 10.0001C5.49333 10.0001 5.32 9.92673 5.19333 9.80673C5.07333 9.68006 5 9.50673 5 9.33339C5 9.16006 5.07333 8.98673 5.19333 8.86006C5.34667 8.70673 5.58 8.63339 5.8 8.68006C5.84 8.68673 5.88 8.70006 5.92 8.72006C5.96 8.73339 6 8.75339 6.04 8.78006C6.07333 8.80673 6.10667 8.83339 6.14 8.86006C6.26 8.98673 6.33333 9.16006 6.33333 9.33339C6.33333 9.50673 6.26 9.68006 6.14 9.80673ZM8.47333 9.80673C8.34667 9.92673 8.17333 10.0001 8 10.0001C7.82667 10.0001 7.65333 9.92673 7.52667 9.80673C7.40667 9.68006 7.33333 9.50673 7.33333 9.33339C7.33333 9.16006 7.40667 8.98673 7.52667 8.86006C7.78 8.61339 8.22667 8.61339 8.47333 8.86006C8.59333 8.98673 8.66667 9.16006 8.66667 9.33339C8.66667 9.50673 8.59333 9.68006 8.47333 9.80673Z"
      fill="currentColor"
    />
  </svg>
);

const mysipIcon = (props: IconProps) => (
  <svg
    width="26"
    height="20"
    viewBox="0 0 26 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.32245 10.9768C3.32245 10.9768 0.491463 14.612 1.97437 15.8239C1.97437 15.8239 2.5136 16.0932 3.72689 15.9584C7.63636 15.42 17.3427 8.28396 20.713 5.32187L20.1737 3.84082L25.4313 4.64866L23.6788 9.8997L22.6003 8.4186C22.6003 8.4186 12.6243 16.4971 4.67055 18.382C4.67055 18.382 -4.76611 20.267 3.18765 10.9768H3.32245Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.13867 7.81348H8.27508V13.4401C7.07419 14.244 5.60642 14.7798 4.13867 15.3157V7.81348Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.66406 3.84082H13.8005V9.89542L9.66406 12.721V3.84082Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.1641 0L19.3005 0V5.79749L15.1641 9.03329V0Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.152 19.9184H15.0156V14.5086L19.152 11.8037V19.9184Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.8005 19.9074H9.66406V17.3308L13.8005 15.1611V19.9074Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.27508 19.9113H4.13867V19.1151C5.0727 19.1151 7.07419 18.4517 8.27508 17.9209V19.9113Z"
      fill="currentColor"
    />
  </svg>
);

const callIconV3 = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.6846 8.95573C14.3263 8.95573 14.043 8.66406 14.043 8.31406C14.043 8.00573 13.7346 7.36406 13.218 6.80573C12.7096 6.26406 12.1513 5.9474 11.6846 5.9474C11.3263 5.9474 11.043 5.65573 11.043 5.30573C11.043 4.95573 11.3346 4.66406 11.6846 4.66406C12.518 4.66406 13.393 5.11406 14.1596 5.9224C14.8763 6.68073 15.3346 7.6224 15.3346 8.30573C15.3346 8.66406 15.043 8.95573 14.6846 8.95573Z"
      fill="currentColor"
    />
    <path
      d="M17.6924 8.95573C17.3341 8.95573 17.0508 8.66406 17.0508 8.31406C17.0508 5.35573 14.6424 2.95573 11.6924 2.95573C11.3341 2.95573 11.0508 2.66406 11.0508 2.31406C11.0508 1.96406 11.3341 1.66406 11.6841 1.66406C15.3508 1.66406 18.3341 4.6474 18.3341 8.31406C18.3341 8.66406 18.0424 8.95573 17.6924 8.95573Z"
      fill="currentColor"
    />
    <path
      d="M9.20964 12.4557L7.66797 13.9974C7.34297 14.3224 6.8263 14.3224 6.49297 14.0057C6.4013 13.9141 6.30964 13.8307 6.21797 13.7391C5.35964 12.8724 4.58464 11.9641 3.89297 11.0141C3.20964 10.0641 2.65964 9.11406 2.25964 8.1724C1.86797 7.2224 1.66797 6.31406 1.66797 5.4474C1.66797 4.88073 1.76797 4.33906 1.96797 3.83906C2.16797 3.33073 2.48464 2.86406 2.9263 2.4474C3.45964 1.9224 4.04297 1.66406 4.65964 1.66406C4.89297 1.66406 5.1263 1.71406 5.33464 1.81406C5.5513 1.91406 5.74297 2.06406 5.89297 2.28073L7.8263 5.00573C7.9763 5.21406 8.08464 5.40573 8.15964 5.58906C8.23464 5.76406 8.2763 5.93906 8.2763 6.0974C8.2763 6.2974 8.21797 6.4974 8.1013 6.68906C7.99297 6.88073 7.83464 7.08073 7.63463 7.28073L7.0013 7.93906C6.90964 8.03073 6.86797 8.13906 6.86797 8.2724C6.86797 8.33906 6.8763 8.3974 6.89297 8.46406C6.91797 8.53073 6.94297 8.58073 6.95964 8.63073C7.10964 8.90573 7.36797 9.26406 7.73463 9.6974C8.10963 10.1307 8.50963 10.5724 8.94297 11.0141C9.0263 11.0974 9.11797 11.1807 9.2013 11.2641C9.53464 11.5891 9.54297 12.1224 9.20964 12.4557Z"
      fill="currentColor"
    />
    <path
      d="M18.3083 15.2781C18.3083 15.5115 18.2667 15.7531 18.1833 15.9865C18.1583 16.0531 18.1333 16.1198 18.1 16.1865C17.9583 16.4865 17.775 16.7698 17.5333 17.0365C17.125 17.4865 16.675 17.8115 16.1667 18.0198C16.1583 18.0198 16.15 18.0281 16.1417 18.0281C15.65 18.2281 15.1167 18.3365 14.5417 18.3365C13.6917 18.3365 12.7833 18.1365 11.825 17.7281C10.8667 17.3198 9.90833 16.7698 8.95833 16.0781C8.63333 15.8365 8.30833 15.5948 8 15.3365L10.725 12.6115C10.9583 12.7865 11.1667 12.9198 11.3417 13.0115C11.3833 13.0281 11.4333 13.0531 11.4917 13.0781C11.5583 13.1031 11.625 13.1115 11.7 13.1115C11.8417 13.1115 11.95 13.0615 12.0417 12.9698L12.675 12.3448C12.8833 12.1365 13.0833 11.9781 13.275 11.8781C13.4667 11.7615 13.6583 11.7031 13.8667 11.7031C14.025 11.7031 14.1917 11.7365 14.375 11.8115C14.5583 11.8865 14.75 11.9948 14.9583 12.1365L17.7167 14.0948C17.9333 14.2448 18.0833 14.4198 18.175 14.6281C18.2583 14.8365 18.3083 15.0448 18.3083 15.2781Z"
      fill="currentColor"
    />
  </svg>
);

const indianflagIcon = (props: IconProps) => (
  <svg
    width="27"
    height="27"
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_315_692)">
      <path
        d="M0 19.5266C0 20.2938 0.30479 21.0296 0.847319 21.5722C1.38985 22.1147 2.12568 22.4195 2.89293 22.4195H23.1434C23.9107 22.4195 24.6465 22.1147 25.189 21.5722C25.7316 21.0296 26.0364 20.2938 26.0364 19.5266V15.9104H0V19.5266Z"
        fill="#138808"
      />
      <path
        d="M26.0364 10.126V6.50987C26.0364 5.74262 25.7316 5.00679 25.189 4.46426C24.6465 3.92173 23.9107 3.61694 23.1434 3.61694H2.89293C2.12568 3.61694 1.38985 3.92173 0.847319 4.46426C0.30479 5.00679 0 5.74262 0 6.50987L0 10.126H26.0364Z"
        fill="#FF9933"
      />
      <path d="M0 9.8844H26.0364V16.1527H0V9.8844Z" fill="#F7F7F7" />
      <path
        d="M13.0189 15.9118C14.6166 15.9118 15.9118 14.6166 15.9118 13.0189C15.9118 11.4212 14.6166 10.126 13.0189 10.126C11.4212 10.126 10.126 11.4212 10.126 13.0189C10.126 14.6166 11.4212 15.9118 13.0189 15.9118Z"
        fill="#000080"
      />
      <path
        d="M13.0182 15.4591C14.3663 15.4591 15.4591 14.3663 15.4591 13.0182C15.4591 11.6701 14.3663 10.5773 13.0182 10.5773C11.6701 10.5773 10.5773 11.6701 10.5773 13.0182C10.5773 14.3663 11.6701 15.4591 13.0182 15.4591Z"
        fill="#F7F7F7"
      />
      <path
        d="M13.0911 12.1148L13.0188 12.5849L12.9464 12.1148L13.0188 10.7045L13.0911 12.1148ZM12.4199 10.7833L12.715 12.164L12.9066 12.5993L12.8546 12.1271L12.4199 10.7833ZM11.8616 11.0147L12.5038 12.2717L12.8018 12.6427L12.6297 12.1994L11.8616 11.0147ZM11.3821 11.3821L12.3281 12.4308L12.7121 12.7122L12.4308 12.3281L11.3821 11.3821ZM11.0147 11.8616L12.1993 12.6297L12.6427 12.8018L12.2717 12.5039L11.0147 11.8616ZM10.7832 12.42L12.127 12.8546L12.5993 12.9067L12.1639 12.7151L10.7832 12.42ZM10.7044 13.0188L12.1147 13.0911L12.5848 13.0188L12.1147 12.9465L10.7044 13.0188ZM10.7832 13.6176L12.1639 13.3226L12.5993 13.1309L12.127 13.183L10.7832 13.6176ZM11.0147 14.176L12.2717 13.5338L12.6427 13.2358L12.1993 13.4079L11.0147 14.176ZM11.3821 14.6555L12.4308 13.7095L12.7121 13.3255L12.3281 13.6068L11.3821 14.6555ZM11.8616 15.0229L12.6297 13.8382L12.8018 13.3949L12.5038 13.7659L11.8616 15.0229ZM12.4199 15.2543L12.8546 13.9106L12.9066 13.4383L12.715 13.8737L12.4199 15.2543ZM13.0188 15.3332L13.0911 13.9229L13.0188 13.4528L12.9464 13.9229L13.0188 15.3332ZM13.6176 15.2543L13.3225 13.8737L13.1309 13.4383L13.1829 13.9106L13.6176 15.2543ZM14.1759 15.0229L13.5337 13.7659L13.2357 13.3949L13.4078 13.8382L14.1759 15.0229ZM14.6554 14.6555L13.7094 13.6068L13.3254 13.3255L13.6067 13.7095L14.6554 14.6555ZM15.0228 14.176L13.8382 13.4079L13.3948 13.2358L13.7658 13.5338L15.0228 14.176ZM15.2543 13.6176L13.9105 13.183L13.4382 13.1309L13.8736 13.3226L15.2543 13.6176ZM15.3331 13.0188L13.9228 12.9465L13.4527 13.0188L13.9228 13.0911L15.3331 13.0188ZM15.2543 12.42L13.8736 12.7151L13.4382 12.9067L13.9105 12.8546L15.2543 12.42ZM15.0228 11.8616L13.7658 12.5039L13.3948 12.8018L13.8382 12.6297L15.0228 11.8616ZM14.6554 11.3821L13.6067 12.3281L13.3254 12.7122L13.7094 12.4308L14.6554 11.3821ZM14.1759 11.0147L13.4078 12.1994L13.2357 12.6427L13.5337 12.2717L14.1759 11.0147ZM13.6176 10.7833L13.1829 12.1271L13.1309 12.5993L13.3225 12.164L13.6176 10.7833Z"
        fill="#6666B3"
      />
      <path
        d="M12.6988 10.7458C12.7787 10.7458 12.8434 10.6811 12.8434 10.6012C12.8434 10.5213 12.7787 10.4565 12.6988 10.4565C12.6189 10.4565 12.5541 10.5213 12.5541 10.6012C12.5541 10.6811 12.6189 10.7458 12.6988 10.7458Z"
        fill="#000080"
      />
      <path
        d="M12.0822 10.9111C12.1621 10.9111 12.2269 10.8464 12.2269 10.7665C12.2269 10.6866 12.1621 10.6218 12.0822 10.6218C12.0023 10.6218 11.9376 10.6866 11.9376 10.7665C11.9376 10.8464 12.0023 10.9111 12.0822 10.9111Z"
        fill="#000080"
      />
      <path
        d="M11.5356 11.229C11.6155 11.229 11.6802 11.1642 11.6802 11.0843C11.6802 11.0045 11.6155 10.9397 11.5356 10.9397C11.4557 10.9397 11.3909 11.0045 11.3909 11.0843C11.3909 11.1642 11.4557 11.229 11.5356 11.229Z"
        fill="#000080"
      />
      <path
        d="M11.0843 11.6803C11.1642 11.6803 11.2289 11.6155 11.2289 11.5356C11.2289 11.4558 11.1642 11.391 11.0843 11.391C11.0044 11.391 10.9396 11.4558 10.9396 11.5356C10.9396 11.6155 11.0044 11.6803 11.0843 11.6803Z"
        fill="#000080"
      />
      <path
        d="M10.7664 12.2269C10.8463 12.2269 10.9111 12.1622 10.9111 12.0823C10.9111 12.0024 10.8463 11.9376 10.7664 11.9376C10.6865 11.9376 10.6218 12.0024 10.6218 12.0823C10.6218 12.1622 10.6865 12.2269 10.7664 12.2269Z"
        fill="#000080"
      />
      <path
        d="M10.6011 12.8435C10.681 12.8435 10.7458 12.7787 10.7458 12.6988C10.7458 12.619 10.681 12.5542 10.6011 12.5542C10.5212 12.5542 10.4565 12.619 10.4565 12.6988C10.4565 12.7787 10.5212 12.8435 10.6011 12.8435Z"
        fill="#000080"
      />
      <path
        d="M10.6011 13.4791C10.681 13.4791 10.7458 13.4144 10.7458 13.3345C10.7458 13.2546 10.681 13.1898 10.6011 13.1898C10.5212 13.1898 10.4565 13.2546 10.4565 13.3345C10.4565 13.4144 10.5212 13.4791 10.6011 13.4791Z"
        fill="#000080"
      />
      <path
        d="M10.7664 14.0957C10.8463 14.0957 10.9111 14.0309 10.9111 13.951C10.9111 13.8712 10.8463 13.8064 10.7664 13.8064C10.6865 13.8064 10.6218 13.8712 10.6218 13.951C10.6218 14.0309 10.6865 14.0957 10.7664 14.0957Z"
        fill="#000080"
      />
      <path
        d="M11.0843 14.6424C11.1642 14.6424 11.2289 14.5777 11.2289 14.4978C11.2289 14.4179 11.1642 14.3531 11.0843 14.3531C11.0044 14.3531 10.9396 14.4179 10.9396 14.4978C10.9396 14.5777 11.0044 14.6424 11.0843 14.6424Z"
        fill="#000080"
      />
      <path
        d="M11.5356 15.1001C11.6155 15.1001 11.6802 15.0353 11.6802 14.9554C11.6802 14.8756 11.6155 14.8108 11.5356 14.8108C11.4557 14.8108 11.3909 14.8756 11.3909 14.9554C11.3909 15.0353 11.4557 15.1001 11.5356 15.1001Z"
        fill="#000080"
      />
      <path
        d="M12.0822 15.4178C12.1621 15.4178 12.2269 15.3531 12.2269 15.2732C12.2269 15.1933 12.1621 15.1285 12.0822 15.1285C12.0023 15.1285 11.9376 15.1933 11.9376 15.2732C11.9376 15.3531 12.0023 15.4178 12.0822 15.4178Z"
        fill="#000080"
      />
      <path
        d="M12.6988 15.5831C12.7787 15.5831 12.8434 15.5184 12.8434 15.4385C12.8434 15.3586 12.7787 15.2938 12.6988 15.2938C12.6189 15.2938 12.5541 15.3586 12.5541 15.4385C12.5541 15.5184 12.6189 15.5831 12.6988 15.5831Z"
        fill="#000080"
      />
      <path
        d="M13.3345 15.5831C13.4144 15.5831 13.4791 15.5184 13.4791 15.4385C13.4791 15.3586 13.4144 15.2938 13.3345 15.2938C13.2546 15.2938 13.1898 15.3586 13.1898 15.4385C13.1898 15.5184 13.2546 15.5831 13.3345 15.5831Z"
        fill="#000080"
      />
      <path
        d="M13.951 15.4178C14.0309 15.4178 14.0957 15.3531 14.0957 15.2732C14.0957 15.1933 14.0309 15.1285 13.951 15.1285C13.8712 15.1285 13.8064 15.1933 13.8064 15.2732C13.8064 15.3531 13.8712 15.4178 13.951 15.4178Z"
        fill="#000080"
      />
      <path
        d="M14.5041 15.1001C14.584 15.1001 14.6487 15.0353 14.6487 14.9554C14.6487 14.8756 14.584 14.8108 14.5041 14.8108C14.4242 14.8108 14.3594 14.8756 14.3594 14.9554C14.3594 15.0353 14.4242 15.1001 14.5041 15.1001Z"
        fill="#000080"
      />
      <path
        d="M14.949 14.6424C15.0289 14.6424 15.0937 14.5777 15.0937 14.4978C15.0937 14.4179 15.0289 14.3531 14.949 14.3531C14.8691 14.3531 14.8044 14.4179 14.8044 14.4978C14.8044 14.5777 14.8691 14.6424 14.949 14.6424Z"
        fill="#000080"
      />
      <path
        d="M15.2668 14.0957C15.3467 14.0957 15.4115 14.0309 15.4115 13.951C15.4115 13.8712 15.3467 13.8064 15.2668 13.8064C15.187 13.8064 15.1222 13.8712 15.1222 13.951C15.1222 14.0309 15.187 14.0957 15.2668 14.0957Z"
        fill="#000080"
      />
      <path
        d="M15.4321 13.4791C15.512 13.4791 15.5768 13.4144 15.5768 13.3345C15.5768 13.2546 15.512 13.1898 15.4321 13.1898C15.3522 13.1898 15.2875 13.2546 15.2875 13.3345C15.2875 13.4144 15.3522 13.4791 15.4321 13.4791Z"
        fill="#000080"
      />
      <path
        d="M15.4321 12.8435C15.512 12.8435 15.5768 12.7787 15.5768 12.6988C15.5768 12.619 15.512 12.5542 15.4321 12.5542C15.3522 12.5542 15.2875 12.619 15.2875 12.6988C15.2875 12.7787 15.3522 12.8435 15.4321 12.8435Z"
        fill="#000080"
      />
      <path
        d="M15.2668 12.2269C15.3467 12.2269 15.4115 12.1622 15.4115 12.0823C15.4115 12.0024 15.3467 11.9376 15.2668 11.9376C15.187 11.9376 15.1222 12.0024 15.1222 12.0823C15.1222 12.1622 15.187 12.2269 15.2668 12.2269Z"
        fill="#000080"
      />
      <path
        d="M14.949 11.6803C15.0289 11.6803 15.0937 11.6155 15.0937 11.5356C15.0937 11.4558 15.0289 11.391 14.949 11.391C14.8691 11.391 14.8044 11.4558 14.8044 11.5356C14.8044 11.6155 14.8691 11.6803 14.949 11.6803Z"
        fill="#000080"
      />
      <path
        d="M14.5041 11.229C14.584 11.229 14.6487 11.1642 14.6487 11.0843C14.6487 11.0045 14.584 10.9397 14.5041 10.9397C14.4242 10.9397 14.3594 11.0045 14.3594 11.0843C14.3594 11.1642 14.4242 11.229 14.5041 11.229Z"
        fill="#000080"
      />
      <path
        d="M13.951 10.9111C14.0309 10.9111 14.0957 10.8464 14.0957 10.7665C14.0957 10.6866 14.0309 10.6218 13.951 10.6218C13.8712 10.6218 13.8064 10.6866 13.8064 10.7665C13.8064 10.8464 13.8712 10.9111 13.951 10.9111Z"
        fill="#000080"
      />
      <path
        d="M13.3345 10.7458C13.4144 10.7458 13.4791 10.6811 13.4791 10.6012C13.4791 10.5213 13.4144 10.4565 13.3345 10.4565C13.2546 10.4565 13.1898 10.5213 13.1898 10.6012C13.1898 10.6811 13.2546 10.7458 13.3345 10.7458Z"
        fill="#000080"
      />
      <path
        d="M13.0144 13.6717C13.3739 13.6717 13.6653 13.3803 13.6653 13.0208C13.6653 12.6613 13.3739 12.3699 13.0144 12.3699C12.6549 12.3699 12.3635 12.6613 12.3635 13.0208C12.3635 13.3803 12.6549 13.6717 13.0144 13.6717Z"
        fill="#000080"
      />
    </g>
    <defs>
      <clipPath id="clip0_315_692">
        <rect width="26.0364" height="26.0364" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const growthSVG = (props: IconProps) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" {...props}>
    <path
      d="M20.8419 7.57892L12.5893 15.0063L9.44543 10.7621L3.15771 16.421"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.0527 7.57892H20.8422V10.1052"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const heartLikeIcon = (props: IconProps) => (
  <svg
    width="27"
    height="26"
    viewBox="0 0 27 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="27" height="26" rx="13" fill="currentColor" />
    <path
      d="M16.9905 6C16.2797 6.00013 15.5818 6.19348 14.9684 6.56021C14.3549 6.92693 13.8481 7.45381 13.5 8.08675C13.1518 7.45366 12.6448 6.92668 12.0312 6.55995C11.4176 6.19321 10.7195 5.99995 10.0086 6C8.91974 6.06006 7.89551 6.54658 7.14893 7.35833C6.40235 8.17008 5.99089 9.24458 6.00015 10.3583C6.00015 16.0377 13.5 20 13.5 20C13.5 20 20.9998 16.0397 20.9998 10.3583C21.0091 9.24442 20.5975 8.16978 19.8507 7.35799C19.1039 6.54621 18.0794 6.05981 16.9905 6Z"
      fill="white"
    />
  </svg>
);

const deletIcon = (props: IconProps) => (
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="16" cy="16.7891" r="16" fill="currentColor" fillOpacity={0.2} />
    <path
      d="M23.5 11.776C20.725 11.501 17.9333 11.3594 15.15 11.3594C13.5 11.3594 11.85 11.4427 10.2 11.6094L8.5 11.776"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.0859 10.9281L13.2693 9.83646C13.4026 9.04479 13.5026 8.45312 14.9109 8.45312H17.0943C18.5026 8.45312 18.6109 9.07813 18.7359 9.84479L18.9193 10.9281"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.7057 14.4062L21.1641 22.7979C21.0724 24.1062 20.9974 25.1229 18.6724 25.1229H13.3224C10.9974 25.1229 10.9224 24.1062 10.8307 22.7979L10.2891 14.4062"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6094 20.5391H17.3844"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.9141 17.2031H18.0807"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const stripStarIcon = (props: IconProps) => (
  <svg
    width="23"
    height="23"
    viewBox="0 0 23 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.31684 2.79344C9.61419 1.85401 10.9436 1.85401 11.241 2.79344L13.1534 8.83535C13.2525 9.14848 13.4978 9.39377 13.811 9.49288L19.8532 11.4052C20.7927 11.7025 20.7927 13.0319 19.8532 13.3293L13.811 15.2416C13.4978 15.3407 13.2525 15.586 13.1534 15.8991L11.241 21.941C10.9436 22.8805 9.61419 22.8805 9.31684 21.941L7.40441 15.8991C7.30529 15.586 7.05998 15.3407 6.74684 15.2416L0.704607 13.3293C-0.234869 13.0319 -0.234869 11.7025 0.704608 11.4052L6.74684 9.49288C7.05998 9.39377 7.30529 9.14847 7.40441 8.83535L9.31684 2.79344Z"
      fill="#734ACA"
    />
    <path
      d="M16.5595 5.30851V0H17.4573V5.30851H16.5595ZM14.3633 3.10468V2.20384H19.6535V3.10468H14.3633Z"
      fill="#734ACA"
    />
    <path
      d="M20.8559 9.33957V6.25098H21.3783V9.33957H20.8559ZM19.5781 8.05733V7.53321H22.6561V8.05733H19.5781Z"
      fill="#734ACA"
    />
  </svg>
);

const stripCursorIcon = (props: IconProps) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_509_3006)">
      <path
        d="M26.781 12.113C27.8375 12.6056 27.8519 14.1035 26.8031 14.6166L26.8022 14.6162L2.19051 26.6209C1.24108 27.0842 0.234919 26.0969 0.681592 25.1382L5.6779 14.4236C5.89618 13.9553 6.00739 13.4442 6.0027 12.9275C5.99801 12.4108 5.87812 11.9015 5.65135 11.4373L1.28594 2.50013C0.805875 1.51728 1.82734 0.476872 2.81874 0.93917L26.781 12.113Z"
        fill="white"
        stroke="#D2ACFF"
        strokeWidth="1.26071"
      />
    </g>
    <defs>
      <clipPath id="clip0_509_3006">
        <rect width="28" height="28" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const editIcon = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.4925 4.55936L4.92588 11.126C4.67588 11.376 4.42588 11.8677 4.37588 12.226L4.01754 14.7344C3.88421 15.6427 4.52588 16.276 5.43421 16.151L7.94254 15.7927C8.29254 15.7427 8.78421 15.4927 9.04254 15.2427L15.6092 8.67602C16.7425 7.54269 17.2759 6.22602 15.6092 4.55936C13.9425 2.89269 12.6259 3.42602 11.4925 4.55936Z"
      stroke="#1A51AA"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5469 5.5C11.1052 7.49167 12.6635 9.05 14.6635 9.61667"
      stroke="#1A51AA"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const mysipLogoIconv1 = (props: IconProps) => (
  <svg
    width="24"
    height="20"
    viewBox="0 0 24 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.13446 10.6337C3.13446 10.6337 0.463651 14.1352 1.86264 15.3024C1.86264 15.3024 2.37137 15.5618 3.516 15.4321C7.20426 14.9134 16.3613 8.03994 19.5408 5.18681L19.0321 3.76025L23.9922 4.53838L22.3388 9.59618L21.3214 8.16962C21.3214 8.16962 11.91 15.9509 4.40627 17.7665C4.40627 17.7665 -4.49642 19.5821 3.00728 10.6337H3.13446Z"
      fill="#1A51AA"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.76562 7.52051H7.70824V12.9674C6.56361 13.7455 5.16462 14.2642 3.76562 14.783V7.52051Z"
      fill="#389B86"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.98438 3.76318H12.927V9.59911L8.98438 12.3225V3.76318Z"
      fill="#389B86"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.1953 0H18.1379V5.57656L14.1953 8.68905V0Z"
      fill="#389B86"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.0129 19.1936H14.0703V14.0061L18.0129 11.4124V19.1936Z"
      fill="#B4BACB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.927 19.1912H8.98438V16.7271L12.927 14.6521V19.1912Z"
      fill="#B4BACB"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.70824 19.1965H3.76562V18.4184C4.65589 18.4184 6.56361 17.77 7.70824 17.2512V19.1965Z"
      fill="#B4BACB"
    />
  </svg>
);

const rightShieldICon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M18.5408 4.12375L13.0408 2.06375C12.4708 1.85375 11.5408 1.85375 10.9708 2.06375L5.47078 4.12375C4.41078 4.52375 3.55078 5.76375 3.55078 6.89375V14.9937C3.55078 15.8038 4.08078 16.8738 4.73078 17.3538L10.2308 21.4637C11.2008 22.1937 12.7908 22.1937 13.7608 21.4637L19.2608 17.3538C19.9108 16.8638 20.4408 15.8038 20.4408 14.9937V6.89375C20.4508 5.76375 19.5908 4.52375 18.5408 4.12375ZM15.4808 9.72375L11.1808 14.0238C11.0308 14.1737 10.8408 14.2437 10.6508 14.2437C10.4608 14.2437 10.2708 14.1737 10.1208 14.0238L8.52078 12.4037C8.23078 12.1137 8.23078 11.6337 8.52078 11.3438C8.81078 11.0538 9.29078 11.0538 9.58078 11.3438L10.6608 12.4237L14.4308 8.65375C14.7208 8.36375 15.2008 8.36375 15.4908 8.65375C15.7808 8.94375 15.7808 9.43375 15.4808 9.72375Z"
      fill="#1A51AA"
    />
  </svg>
);

const pieChartICon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M21.6702 6.94942C21.0302 4.77942 19.2202 2.96942 17.0502 2.32942C15.4002 1.84942 14.2602 1.88942 13.4702 2.47942C12.5202 3.18942 12.4102 4.46942 12.4102 5.37942V7.86942C12.4102 10.3294 13.5302 11.5794 15.7302 11.5794H18.6002C19.5002 11.5794 20.7902 11.4694 21.5002 10.5194C22.1102 9.73942 22.1602 8.59942 21.6702 6.94942Z"
      fill="#1A51AA"
    />
    <path
      d="M18.9114 13.3611C18.6514 13.0611 18.2714 12.8911 17.8814 12.8911H14.3014C12.5414 12.8911 11.1114 11.4611 11.1114 9.70113V6.12113C11.1114 5.73113 10.9414 5.35113 10.6414 5.09113C10.3514 4.83113 9.95136 4.71113 9.57136 4.76113C7.22136 5.06113 5.06136 6.35113 3.65136 8.29113C2.23136 10.2411 1.71136 12.6211 2.16136 15.0011C2.81136 18.4411 5.56136 21.1911 9.01136 21.8411C9.56136 21.9511 10.1114 22.0011 10.6614 22.0011C12.4714 22.0011 14.2214 21.4411 15.7114 20.3511C17.6514 18.9411 18.9414 16.7811 19.2414 14.4311C19.2914 14.0411 19.1714 13.6511 18.9114 13.3611Z"
      fill="#1A51AA"
    />
  </svg>
);

const downloadIcon = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.5 12.5V15.8333C17.5 16.2754 17.3244 16.6993 17.0118 17.0118C16.6993 17.3244 16.2754 17.5 15.8333 17.5H4.16667C3.72464 17.5 3.30072 17.3244 2.98816 17.0118C2.67559 16.6993 2.5 16.2754 2.5 15.8333V12.5"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.83203 8.33594L9.9987 12.5026L14.1654 8.33594"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 12.5V2.5"
      stroke="currentColor"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const fileTextIcon = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.3333 1.66992H6.66667C3.75 1.66992 2.5 3.33659 2.5 5.83659V14.1699C2.5 16.6699 3.75 18.3366 6.66667 18.3366H13.3333C16.25 18.3366 17.5 16.6699 17.5 14.1699V5.83659C17.5 3.33659 16.25 1.66992 13.3333 1.66992ZM6.66667 10.2116H10C10.3417 10.2116 10.625 10.4949 10.625 10.8366C10.625 11.1783 10.3417 11.4616 10 11.4616H6.66667C6.325 11.4616 6.04167 11.1783 6.04167 10.8366C6.04167 10.4949 6.325 10.2116 6.66667 10.2116ZM13.3333 14.7949H6.66667C6.325 14.7949 6.04167 14.5116 6.04167 14.1699C6.04167 13.8283 6.325 13.5449 6.66667 13.5449H13.3333C13.675 13.5449 13.9583 13.8283 13.9583 14.1699C13.9583 14.5116 13.675 14.7949 13.3333 14.7949ZM15.4167 7.71159H13.75C12.4833 7.71159 11.4583 6.68659 11.4583 5.41992V3.75326C11.4583 3.41159 11.7417 3.12826 12.0833 3.12826C12.425 3.12826 12.7083 3.41159 12.7083 3.75326V5.41992C12.7083 5.99492 13.175 6.46159 13.75 6.46159H15.4167C15.7583 6.46159 16.0417 6.74492 16.0417 7.08659C16.0417 7.42826 15.7583 7.71159 15.4167 7.71159Z"
      fill="currentColor"
    />
  </svg>
);

const youtubeBellIcon = (props: IconProps) => (
  <svg
    width="20"
    height="21"
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.1163 12.7701L15.283 11.3868C15.108 11.0785 14.9496 10.4951 14.9496 10.1535V8.04515C14.9496 6.08682 13.7996 4.39515 12.1413 3.60348C11.708 2.83682 10.908 2.36182 9.99129 2.36182C9.08296 2.36182 8.26629 2.85348 7.83296 3.62848C6.20796 4.43682 5.08296 6.11182 5.08296 8.04515V10.1535C5.08296 10.4951 4.92463 11.0785 4.74963 11.3785L3.90796 12.7701C3.57463 13.3285 3.49963 13.9451 3.70796 14.5118C3.90796 15.0701 4.38296 15.5035 4.99963 15.7118C6.61629 16.2618 8.31629 16.5285 10.0163 16.5285C11.7163 16.5285 13.4163 16.2618 15.033 15.7201C15.6163 15.5285 16.0663 15.0868 16.283 14.5118C16.4996 13.9368 16.4413 13.3035 16.1163 12.7701Z"
      fill="currentColor"
    />
    <path
      d="M12.3568 17.3701C12.0068 18.3368 11.0818 19.0285 9.99844 19.0285C9.3401 19.0285 8.6901 18.7618 8.23177 18.2868C7.9651 18.0368 7.7651 17.7035 7.64844 17.3618C7.75677 17.3785 7.8651 17.3868 7.98177 17.4035C8.17344 17.4285 8.37344 17.4535 8.57344 17.4701C9.04844 17.5118 9.53177 17.5368 10.0151 17.5368C10.4901 17.5368 10.9651 17.5118 11.4318 17.4701C11.6068 17.4535 11.7818 17.4451 11.9484 17.4201C12.0818 17.4035 12.2151 17.3868 12.3568 17.3701Z"
      fill="currentColor"
    />
  </svg>
);

const mailIcon = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.082 8.49199H14.6737C12.6987 8.49199 11.0904 6.88366 11.0904 4.90866V2.50033C11.0904 2.04199 10.7154 1.66699 10.257 1.66699H6.7237C4.15703 1.66699 2.08203 3.33366 2.08203 6.30866V13.692C2.08203 16.667 4.15703 18.3337 6.7237 18.3337H13.2737C15.8404 18.3337 17.9154 16.667 17.9154 13.692V9.32532C17.9154 8.86699 17.5404 8.49199 17.082 8.49199ZM9.60703 11.2753C9.48203 11.4003 9.3237 11.4587 9.16536 11.4587C9.00703 11.4587 8.8487 11.4003 8.7237 11.2753L8.1237 10.6753V14.167C8.1237 14.5087 7.84036 14.792 7.4987 14.792C7.15703 14.792 6.8737 14.5087 6.8737 14.167V10.6753L6.2737 11.2753C6.03203 11.517 5.63203 11.517 5.39036 11.2753C5.1487 11.0337 5.1487 10.6337 5.39036 10.392L7.05703 8.72533C7.11537 8.67533 7.1737 8.63366 7.24036 8.60033C7.25703 8.59199 7.28203 8.58366 7.2987 8.57533C7.3487 8.55866 7.3987 8.55033 7.45703 8.54199C7.48203 8.54199 7.4987 8.54199 7.5237 8.54199C7.59036 8.54199 7.65703 8.55866 7.7237 8.58366C7.73203 8.58366 7.73203 8.58366 7.74036 8.58366C7.80703 8.60866 7.8737 8.65866 7.9237 8.70866C7.93203 8.71699 7.94036 8.71699 7.94036 8.72533L9.60703 10.392C9.8487 10.6337 9.8487 11.0337 9.60703 11.2753Z"
      fill="currentColor"
    />
    <path
      d="M14.526 7.34207C15.3177 7.3504 16.4177 7.3504 17.3594 7.3504C17.8344 7.3504 18.0844 6.79207 17.751 6.45873C16.551 5.2504 14.401 3.0754 13.1677 1.84207C12.826 1.5004 12.2344 1.73373 12.2344 2.20873V5.11707C12.2344 6.33373 13.2677 7.34207 14.526 7.34207Z"
      fill="currentColor"
    />
  </svg>
);

const addFileIcon = (props: IconProps) => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.582 3.16699H21.0138C26.1774 3.16699 28.7592 3.16699 30.5522 4.43023C31.0659 4.79217 31.5219 5.22141 31.9065 5.7049C33.2487 7.39239 33.2487 9.82231 33.2487 14.6821V18.7124C33.2487 23.4041 33.2487 25.75 32.5062 27.6236C31.3126 30.6356 28.7882 33.0114 25.588 34.1349C23.5973 34.8337 21.1048 34.8337 16.1199 34.8337C13.2714 34.8337 11.8471 34.8337 10.7096 34.4343C8.88087 33.7924 7.43839 32.4348 6.75631 30.7136C6.33203 29.643 6.33203 28.3025 6.33203 25.6215V19.0003"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M33.2513 19C33.2513 21.9148 30.8884 24.2778 27.9735 24.2778C26.9194 24.2778 25.6766 24.0931 24.6516 24.3677C23.741 24.6117 23.0297 25.323 22.7857 26.2337C22.511 27.2586 22.6957 28.5014 22.6957 29.5556C22.6957 32.4704 20.3328 34.8333 17.418 34.8333"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.4167 9.50033L4.75 9.50033M11.0833 3.16699V15.8337"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const pdfFileIconV2 = (props: IconProps) => (
  <svg
    width="38"
    height="38"
    viewBox="0 0 38 38"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.082 28.4997V24.5413M11.082 24.5413V22.1663C11.082 21.42 11.082 21.0468 11.3255 20.8149C11.569 20.583 11.9608 20.583 12.7445 20.583H13.8529C15.0006 20.583 15.931 21.4691 15.931 22.5622C15.931 23.6552 15.0006 24.5413 13.8529 24.5413H11.082ZM33.2487 20.583H31.1706C29.8644 20.583 29.2113 20.583 28.8055 20.9695C28.3997 21.3559 28.3997 21.9779 28.3997 23.2219V24.5413M28.3997 28.4997V24.5413M28.3997 24.5413H31.8633M24.9362 24.5413C24.9362 26.7275 23.0754 28.4997 20.7799 28.4997C20.262 28.4997 20.003 28.4997 19.8102 28.3936C19.3483 28.1397 19.3945 27.6256 19.3945 27.1802V21.9025C19.3945 21.4571 19.3483 20.943 19.8102 20.6891C20.003 20.583 20.262 20.583 20.7799 20.583C23.0754 20.583 24.9362 22.3552 24.9362 24.5413Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23.7513 34.833H16.9862C11.8226 34.833 9.24079 34.833 7.44783 33.5698C6.93412 33.2078 6.47805 32.7786 6.09349 32.2951C4.7513 30.6076 4.7513 28.1777 4.7513 23.3179V19.2876C4.7513 14.5959 4.7513 12.25 5.49378 10.3764C6.68742 7.36443 9.21177 4.98857 12.412 3.86515C14.4027 3.16634 16.8952 3.16634 21.8801 3.16634C24.7286 3.16634 26.1529 3.16634 27.2904 3.56566C29.1191 4.20762 30.5616 5.56524 31.2437 7.2864C31.668 8.35701 31.668 9.6975 31.668 12.3785V15.833"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.7487 19C4.7487 16.0852 7.11164 13.7222 10.0265 13.7222C11.0806 13.7222 12.3234 13.9069 13.3484 13.6323C14.259 13.3883 14.9703 12.677 15.2143 11.7663C15.489 10.7414 15.3043 9.4986 15.3043 8.44444C15.3043 5.52961 17.6672 3.16667 20.582 3.16667"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const plantIcon = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.33203 26.6641H22.6654"
      stroke="#00A542"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.332 26.6693C20.6654 23.3359 14.3987 18.1359 17.332 13.3359"
      stroke="#00A542"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.6654 12.5367C14.132 13.6034 15.0654 15.47 15.732 17.47C13.0654 18.0034 11.0654 18.0034 9.33203 17.07C7.73203 16.27 6.26536 14.5367 5.33203 11.47C9.06536 10.8034 11.1987 11.47 12.6654 12.5367Z"
      fill="#00A542"
      stroke="#00A542"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.7997 8.0026C17.7832 9.59135 17.2718 11.4508 17.333 13.3359C19.8664 13.2026 21.733 12.5359 23.0664 11.4693C24.3997 10.1359 25.1997 8.4026 25.333 5.33594C21.733 5.46927 19.9997 6.66927 18.7997 8.0026Z"
      fill="#00A542"
      stroke="#00A542"
      strokeWidth="2.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const scanIcon = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.00214 12.8307C4.5363 12.8307 4.16797 12.4624 4.16797 11.9966V9.49406C4.16797 6.55823 6.56214 4.16406 9.49797 4.16406H12.0005C12.4663 4.16406 12.8346 4.5324 12.8346 4.99823C12.8346 5.46406 12.4663 5.8324 12.0005 5.8324H9.49797C7.47214 5.8324 5.8363 7.47906 5.8363 9.49406V11.9966C5.8363 12.4624 5.45714 12.8307 5.00214 12.8307Z"
      fill="#004FCF"
    />
    <path
      d="M25.0005 12.8307C24.5455 12.8307 24.1663 12.4624 24.1663 11.9966V9.49406C24.1663 7.46823 22.5196 5.8324 20.5046 5.8324H18.0021C17.5363 5.8324 17.168 5.45323 17.168 4.99823C17.168 4.54323 17.5363 4.16406 18.0021 4.16406H20.5046C23.4405 4.16406 25.8346 6.55823 25.8346 9.49406V11.9966C25.8346 12.4624 25.4663 12.8307 25.0005 12.8307Z"
      fill="#004FCF"
    />
    <path
      d="M20.5041 25.831H18.9982C18.5432 25.831 18.1641 25.4627 18.1641 24.9969C18.1641 24.5419 18.5324 24.1627 18.9982 24.1627H20.5041C22.5299 24.1627 24.1657 22.516 24.1657 20.501V19.006C24.1657 18.551 24.5341 18.1719 24.9999 18.1719C25.4549 18.1719 25.8341 18.5402 25.8341 19.006V20.501C25.8341 23.4369 23.4399 25.831 20.5041 25.831Z"
      fill="#004FCF"
    />
    <path
      d="M12.0005 25.8307H9.49797C6.56214 25.8307 4.16797 23.4366 4.16797 20.5007V17.9982C4.16797 17.5324 4.5363 17.1641 5.00214 17.1641C5.46797 17.1641 5.8363 17.5324 5.8363 17.9982V20.5007C5.8363 22.5266 7.48297 24.1624 9.49797 24.1624H12.0005C12.4555 24.1624 12.8346 24.5307 12.8346 24.9966C12.8346 25.4624 12.4663 25.8307 12.0005 25.8307Z"
      fill="#004FCF"
    />
    <path
      d="M21.9988 14.1641H20.5255H9.47547H8.00214C7.5363 14.1641 7.16797 14.5432 7.16797 14.9982C7.16797 15.4532 7.5363 15.8324 8.00214 15.8324H9.47547H20.5255H21.9988C22.4646 15.8324 22.833 15.4532 22.833 14.9982C22.833 14.5432 22.4646 14.1641 21.9988 14.1641Z"
      fill="#004FCF"
    />
    <path
      d="M9.47656 17.1025V17.46C9.47656 19.2583 10.9282 20.71 12.7266 20.71H17.2766C19.0749 20.71 20.5266 19.2583 20.5266 17.46V17.1025C20.5266 16.9725 20.4291 16.875 20.2991 16.875H9.70406C9.57406 16.875 9.47656 16.9725 9.47656 17.1025Z"
      fill="#004FCF"
    />
    <path
      d="M9.47656 12.8966V12.5391C9.47656 10.7407 10.9282 9.28906 12.7266 9.28906H17.2766C19.0749 9.28906 20.5266 10.7407 20.5266 12.5391V12.8966C20.5266 13.0266 20.4291 13.1241 20.2991 13.1241H9.70406C9.57406 13.1241 9.47656 13.0266 9.47656 12.8966Z"
      fill="#004FCF"
    />
  </svg>
);

const diamondIcon = () => (
  <svg
    width="44"
    height="44"
    viewBox="0 0 30 30"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.59003 4H11.0733L9.43062 11.6589H2C2.05393 11.4114 2.14344 11.1687 2.26966 10.9395L5.34151 5.34855C5.56637 4.93926 5.89313 4.5987 6.28833 4.36174C6.68353 4.12477 7.13239 3.99993 7.59003 4ZM2.20884 13.4263C2.33048 13.6767 2.49228 13.9106 2.69309 14.1168L13.1376 24.8415L9.4989 13.4263H2.20884ZM11.3102 13.4263L14.9994 25L18.6886 13.4263H11.3102ZM20.5 13.4263L16.8607 24.8427L27.3063 14.1168C27.5072 13.9106 27.6695 13.6767 27.7912 13.4263H20.5ZM28 11.6589H20.5677L18.925 4H22.4094C22.867 3.99993 23.3165 4.12477 23.7117 4.36174C24.1069 4.5987 24.4336 4.93926 24.6585 5.34855L27.7298 10.9395C27.856 11.1693 27.9461 11.4108 28 11.6589ZM18.8051 11.6589H11.1932L12.8358 4H17.1625L18.8051 11.6589Z"
      fill="#E38C00"
    />
  </svg>
);

const disableIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z"
      fill="#002981"
    />
    <path
      d="M20 30C25.5228 30 30 25.5228 30 20C30 14.4772 25.5228 10 20 10C14.4772 10 10 14.4772 10 20C10 25.5228 14.4772 30 20 30Z"
      fill="white"
      fillOpacity="0.3"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.8984 12.9062L27.0984 27.1063"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const wrongIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z"
      fill="#002981"
    />
    <path
      d="M20 30C25.5228 30 30 25.5228 30 20C30 14.4772 25.5228 10 20 10C14.4772 10 10 14.4772 10 20C10 25.5228 14.4772 30 20 30Z"
      fill="white"
      fillOpacity="0.3"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23 17L17 23"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 17L23 23"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const portfolioRightIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z"
      fill="#002981"
    />
    <path
      d="M11.8492 16.623C11.7033 15.9656 11.7257 15.2819 11.9144 14.6354C12.1031 13.9889 12.452 13.4005 12.9287 12.9247C13.4054 12.449 13.9945 12.1014 14.6414 11.914C15.2883 11.7267 15.972 11.7057 16.6292 11.853C16.9909 11.2873 17.4892 10.8218 18.0782 10.4993C18.6671 10.1768 19.3278 10.0078 19.9992 10.0078C20.6707 10.0078 21.3313 10.1768 21.9203 10.4993C22.5092 10.8218 23.0075 11.2873 23.3692 11.853C24.0274 11.7051 24.7123 11.7259 25.3602 11.9137C26.0081 12.1015 26.598 12.4502 27.0751 12.9272C27.5521 13.4042 27.9007 13.9941 28.0885 14.642C28.2763 15.29 28.2972 15.9749 28.1492 16.633C28.7149 16.9947 29.1805 17.493 29.5029 18.082C29.8254 18.6709 29.9944 19.3316 29.9944 20.003C29.9944 20.6745 29.8254 21.3351 29.5029 21.9241C29.1805 22.513 28.7149 23.0113 28.1492 23.373C28.2966 24.0302 28.2756 24.7139 28.0882 25.3608C27.9009 26.0077 27.5532 26.5968 27.0775 27.0736C26.6018 27.5503 26.0134 27.8992 25.3669 28.0879C24.7204 28.2766 24.0367 28.299 23.3792 28.153C23.018 28.7209 22.5193 29.1884 21.9293 29.5123C21.3394 29.8363 20.6772 30.0061 20.0042 30.0061C19.3312 30.0061 18.669 29.8363 18.0791 29.5123C17.4891 29.1884 16.9905 28.7209 16.6292 28.153C15.972 28.3004 15.2883 28.2794 14.6414 28.092C13.9945 27.9047 13.4054 27.557 12.9287 27.0813C12.452 26.6056 12.1031 26.0172 11.9144 25.3707C11.7257 24.7242 11.7033 24.0405 11.8492 23.383C11.2792 23.0223 10.8096 22.5232 10.4843 21.9322C10.1589 21.3413 9.98828 20.6776 9.98828 20.003C9.98828 19.3284 10.1589 18.6648 10.4843 18.0738C10.8096 17.4829 11.2792 16.9838 11.8492 16.623Z"
      fill="white"
      fillOpacity="0.3"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 20L19 22L23 18"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const handHeartIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 10C0 4.47715 4.47715 0 10 0H30C35.5228 0 40 4.47715 40 10V30C40 35.5228 35.5228 40 30 40H10C4.47715 40 0 35.5228 0 30V10Z"
      fill="#002981"
    />
    <path
      d="M27 22C28.49 20.54 30 18.79 30 16.5C30 15.0413 29.4205 13.6424 28.3891 12.6109C27.3576 11.5795 25.9587 11 24.5 11C22.74 11 21.5 11.5 20 13C18.5 11.5 17.26 11 15.5 11C14.0413 11 12.6424 11.5795 11.6109 12.6109C10.5795 13.6424 10 15.0413 10 16.5C10 18.8 11.5 20.55 13 22L20 29L27 22Z"
      fill="white"
      fillOpacity="0.3"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.9996 13L17.0396 15.96C16.8364 16.1617 16.6752 16.4016 16.5651 16.6659C16.4551 16.9302 16.3984 17.2137 16.3984 17.5C16.3984 17.7863 16.4551 18.0698 16.5651 18.3341C16.6752 18.5984 16.8364 18.8383 17.0396 19.04C17.8596 19.86 19.1696 19.89 20.0396 19.11L22.1096 17.21C22.6285 16.7392 23.304 16.4784 24.0046 16.4784C24.7052 16.4784 25.3808 16.7392 25.8996 17.21L28.8596 19.87"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M26 23L24 21"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M23 26L21 24"
      stroke="white"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const shieldIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M20 13.0005C20 18.0005 16.5 20.5005 12.34 21.9505C12.1222 22.0243 11.8855 22.0207 11.67 21.9405C7.5 20.5005 4 18.0005 4 13.0005V6.00045C4 5.73523 4.10536 5.48088 4.29289 5.29334C4.48043 5.10581 4.73478 5.00045 5 5.00045C7 5.00045 9.5 3.80045 11.24 2.28045C11.4519 2.09945 11.7214 2 12 2C12.2786 2 12.5481 2.09945 12.76 2.28045C14.51 3.81045 17 5.00045 19 5.00045C19.2652 5.00045 19.5196 5.10581 19.7071 5.29334C19.8946 5.48088 20 5.73523 20 6.00045V13.0005Z"
      stroke="#E77F00"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 12L11 14L15 10"
      stroke="#E77F00"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const disableIcon2 = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke="#E77F00"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.90234 4.89844L19.1023 19.0984"
      stroke="#E77F00"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const playIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 24 24"
    fill="white"
    className="w-7 h-7 md:w-10 md:h-10"
  >
    <path d="M8 5v14l11-7z" />
  </svg>
);

// -------------- New --------------
const pulseIcon = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_7339_20240)">
      <path
        d="M18.3346 9.9974H16.268C15.9038 9.99662 15.5494 10.1152 15.2589 10.3349C14.9685 10.5546 14.758 10.8634 14.6596 11.2141L12.7013 18.1807C12.6887 18.224 12.6624 18.262 12.6263 18.2891C12.5902 18.3161 12.5464 18.3307 12.5013 18.3307C12.4562 18.3307 12.4124 18.3161 12.3763 18.2891C12.3402 18.262 12.3139 18.224 12.3013 18.1807L7.7013 1.81406C7.68868 1.77079 7.66236 1.73278 7.6263 1.70573C7.59024 1.67868 7.54638 1.66406 7.5013 1.66406C7.45622 1.66406 7.41236 1.67868 7.3763 1.70573C7.34024 1.73278 7.31392 1.77079 7.3013 1.81406L5.34297 8.78073C5.24502 9.13002 5.03579 9.43783 4.74702 9.65741C4.45826 9.87699 4.10574 9.99636 3.74297 9.9974H1.66797"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7339_20240">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const allocationIcon = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.832 18.3337V9.16699"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.832 5.83366V1.66699"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 18.3337V14.167"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 10.8337V1.66699"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16797 18.3337V9.16699"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16797 5.83366V1.66699"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.5 9.16699H5.83333"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.168 9.16699H17.5013"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.33203 10.833H11.6654"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const calenderIcon2 = () => (
  <svg
    width="22"
    height="22"
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.8869 3.16271V1.77604C14.8869 1.4116 14.5847 1.10938 14.2203 1.10938C13.8558 1.10938 13.5536 1.4116 13.5536 1.77604V3.10938H7.77581V1.77604C7.77581 1.4116 7.47359 1.10938 7.10914 1.10938C6.7447 1.10938 6.44248 1.4116 6.44248 1.77604V3.16271C4.04248 3.38493 2.87803 4.81604 2.70026 6.94049C2.68248 7.19826 2.89581 7.4116 3.1447 7.4116H18.1847C18.4425 7.4116 18.6558 7.18937 18.6291 6.94049C18.4514 4.81604 17.2869 3.38493 14.8869 3.16271Z"
      fill="#1A51AA"
    />
    <path
      d="M17.7791 8.75H3.55686C3.06797 8.75 2.66797 9.15 2.66797 9.63889V15.1144C2.66797 17.7811 4.0013 19.5589 7.11241 19.5589H14.2235C17.3346 19.5589 18.668 17.7811 18.668 15.1144V9.63889C18.668 9.15 18.268 8.75 17.7791 8.75ZM8.18797 16.19C8.14352 16.2256 8.09908 16.27 8.05464 16.2967C8.0013 16.3322 7.94797 16.3589 7.89464 16.3767C7.8413 16.4033 7.78797 16.4211 7.73464 16.43C7.67241 16.4389 7.61908 16.4478 7.55686 16.4478C7.4413 16.4478 7.32575 16.4211 7.21908 16.3767C7.10352 16.3322 7.01464 16.27 6.92575 16.19C6.76575 16.0211 6.66797 15.79 6.66797 15.5589C6.66797 15.3278 6.76575 15.0967 6.92575 14.9278C7.01464 14.8478 7.10352 14.7856 7.21908 14.7411C7.37908 14.67 7.55686 14.6522 7.73464 14.6878C7.78797 14.6967 7.8413 14.7144 7.89464 14.7411C7.94797 14.7589 8.0013 14.7856 8.05464 14.8211C8.09908 14.8567 8.14352 14.8922 8.18797 14.9278C8.34797 15.0967 8.44575 15.3278 8.44575 15.5589C8.44575 15.79 8.34797 16.0211 8.18797 16.19ZM8.18797 13.0789C8.01908 13.2389 7.78797 13.3367 7.55686 13.3367C7.32575 13.3367 7.09464 13.2389 6.92575 13.0789C6.76575 12.91 6.66797 12.6789 6.66797 12.4478C6.66797 12.2167 6.76575 11.9856 6.92575 11.8167C7.17464 11.5678 7.56575 11.4878 7.89464 11.63C8.01019 11.6744 8.10797 11.7367 8.18797 11.8167C8.34797 11.9856 8.44575 12.2167 8.44575 12.4478C8.44575 12.6789 8.34797 12.91 8.18797 13.0789ZM11.2991 16.19C11.1302 16.35 10.8991 16.4478 10.668 16.4478C10.4369 16.4478 10.2057 16.35 10.0369 16.19C9.87686 16.0211 9.77908 15.79 9.77908 15.5589C9.77908 15.3278 9.87686 15.0967 10.0369 14.9278C10.3657 14.5989 10.9702 14.5989 11.2991 14.9278C11.4591 15.0967 11.5569 15.3278 11.5569 15.5589C11.5569 15.79 11.4591 16.0211 11.2991 16.19ZM11.2991 13.0789C11.2546 13.1144 11.2102 13.15 11.1657 13.1856C11.1124 13.2211 11.0591 13.2478 11.0057 13.2656C10.9524 13.2922 10.8991 13.31 10.8457 13.3189C10.7835 13.3278 10.7302 13.3367 10.668 13.3367C10.4369 13.3367 10.2057 13.2389 10.0369 13.0789C9.87686 12.91 9.77908 12.6789 9.77908 12.4478C9.77908 12.2167 9.87686 11.9856 10.0369 11.8167C10.1169 11.7367 10.2146 11.6744 10.3302 11.63C10.6591 11.4878 11.0502 11.5678 11.2991 11.8167C11.4591 11.9856 11.5569 12.2167 11.5569 12.4478C11.5569 12.6789 11.4591 12.91 11.2991 13.0789ZM14.4102 16.19C14.2413 16.35 14.0102 16.4478 13.7791 16.4478C13.548 16.4478 13.3169 16.35 13.148 16.19C12.988 16.0211 12.8902 15.79 12.8902 15.5589C12.8902 15.3278 12.988 15.0967 13.148 14.9278C13.4769 14.5989 14.0813 14.5989 14.4102 14.9278C14.5702 15.0967 14.668 15.3278 14.668 15.5589C14.668 15.79 14.5702 16.0211 14.4102 16.19ZM14.4102 13.0789C14.3657 13.1144 14.3213 13.15 14.2769 13.1856C14.2235 13.2211 14.1702 13.2478 14.1169 13.2656C14.0635 13.2922 14.0102 13.31 13.9569 13.3189C13.8946 13.3278 13.8324 13.3367 13.7791 13.3367C13.548 13.3367 13.3169 13.2389 13.148 13.0789C12.988 12.91 12.8902 12.6789 12.8902 12.4478C12.8902 12.2167 12.988 11.9856 13.148 11.8167C13.2369 11.7367 13.3257 11.6744 13.4413 11.63C13.6013 11.5589 13.7791 11.5411 13.9569 11.5767C14.0102 11.5856 14.0635 11.6033 14.1169 11.63C14.1702 11.6478 14.2235 11.6744 14.2769 11.71C14.3213 11.7456 14.3657 11.7811 14.4102 11.8167C14.5702 11.9856 14.668 12.2167 14.668 12.4478C14.668 12.6789 14.5702 12.91 14.4102 13.0789Z"
      fill="#1A51AA"
    />
  </svg>
);

const clockIcon = (props: IconProps) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.8875 0C3.99049 0 0 3.99049 0 8.8875C0 13.7845 3.99049 17.775 8.8875 17.775C13.7845 17.775 17.775 13.7845 17.775 8.8875C17.775 3.99049 13.7845 0 8.8875 0ZM12.7536 12.0603C12.6291 12.2736 12.4069 12.3892 12.1759 12.3892C12.0603 12.3892 11.9448 12.3625 11.8381 12.2914L9.08302 10.6472C8.39869 10.2384 7.8921 9.34076 7.8921 8.54977V4.9059C7.8921 4.54151 8.19427 4.23934 8.55866 4.23934C8.92305 4.23934 9.22522 4.54151 9.22522 4.9059V8.54977C9.22522 8.86972 9.49185 9.34076 9.76736 9.50074L12.5225 11.1449C12.8424 11.3316 12.9491 11.7404 12.7536 12.0603Z"
      fill="#1A51AA"
    />
  </svg>
);

const ytBtnIconV2 = (props: IconProps) => (
  <svg
    width="57"
    height="39"
    viewBox="0 0 57 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M28.0857 38.7795C28.0857 38.7795 45.7007 38.7795 50.07 37.6162C52.5302 36.9569 54.3804 35.0567 55.0297 32.7105C56.2303 28.406 56.2303 19.351 56.2303 19.351C56.2303 19.351 56.2303 10.3541 55.0297 6.08839C54.3804 3.68406 52.5302 1.82263 50.07 1.18277C45.7007 -4.62399e-06 28.0857 0 28.0857 0C28.0857 0 10.51 -4.62399e-06 6.16034 1.18277C3.73951 1.82263 1.85007 3.68406 1.16121 6.08839C3.4898e-07 10.3541 0 19.351 0 19.351C0 19.351 3.4898e-07 28.406 1.16121 32.7105C1.85007 35.0567 3.73951 36.9569 6.16034 37.6162C10.51 38.7795 28.0857 38.7795 28.0857 38.7795Z"
      fill="#FF0033"
    />
    <path
      d="M36.8333 19.3928L22.291 11.1521V27.6334L36.8333 19.3928Z"
      fill="white"
    />
  </svg>
);

const crowdIcon = (props: IconProps) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M29.2177 12.9499C29.101 12.9333 28.9844 12.9333 28.8677 12.9499C26.2844 12.8666 24.2344 10.7499 24.2344 8.14992C24.2344 5.49992 26.3844 3.33325 29.051 3.33325C31.701 3.33325 33.8677 5.48325 33.8677 8.14992C33.851 10.7499 31.801 12.8666 29.2177 12.9499Z"
        fill="currentColor"
      />
      <path
        d="M34.6474 24.4999C32.7807 25.7499 30.1641 26.2166 27.7474 25.8999C28.3807 24.5333 28.7141 23.0166 28.7307 21.4166C28.7307 19.7499 28.3641 18.1666 27.6641 16.7833C30.1307 16.4499 32.7474 16.9166 34.6307 18.1666C37.2641 19.8999 37.2641 22.7499 34.6474 24.4999Z"
        fill="currentColor"
      />
      <path
        d="M10.7349 12.9499C10.8516 12.9333 10.9682 12.9333 11.0849 12.9499C13.6682 12.8666 15.7182 10.7499 15.7182 8.14992C15.7182 5.48325 13.5682 3.33325 10.9016 3.33325C8.25156 3.33325 6.10156 5.48325 6.10156 8.14992C6.10156 10.7499 8.15156 12.8666 10.7349 12.9499Z"
        fill="currentColor"
      />
      <path
        d="M10.9198 21.4167C10.9198 23.0333 11.2698 24.5667 11.9031 25.95C9.55312 26.2 7.10313 25.7 5.30313 24.5167C2.66979 22.7667 2.66979 19.9167 5.30313 18.1667C7.08646 16.9667 9.60312 16.4833 11.9698 16.75C11.2865 18.15 10.9198 19.7333 10.9198 21.4167Z"
        fill="currentColor"
      />
      <path
        d="M20.2 26.45C20.0667 26.4333 19.9167 26.4333 19.7667 26.45C16.7 26.35 14.25 23.8333 14.25 20.7333C14.2667 17.5667 16.8167 15 20 15C23.1667 15 25.7333 17.5667 25.7333 20.7333C25.7167 23.8333 23.2833 26.35 20.2 26.45Z"
        fill="currentColor"
      />
      <path
        d="M14.7859 29.8999C12.2693 31.5832 12.2693 34.3499 14.7859 36.0166C17.6526 37.9332 22.3526 37.9332 25.2193 36.0166C27.7359 34.3332 27.7359 31.5666 25.2193 29.8999C22.3693 27.9832 17.6693 27.9832 14.7859 29.8999Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

const fileIcon = (props: IconProps) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M21.132 33.2618C21.5899 33.3684 21.6319 33.9681 21.1859 34.1168L18.5525 34.9834C11.9359 37.1168 8.45252 35.3334 6.30252 28.7168L4.16919 22.1334C2.03586 15.5168 3.80252 12.0168 10.4192 9.88345L11.9699 9.36992C12.3727 9.2365 12.7578 9.63785 12.6299 10.0425C12.4599 10.5804 12.3032 11.1608 12.1525 11.7834L10.5192 18.7668C8.68585 26.6168 11.3692 30.9501 19.2192 32.8168L21.132 33.2618Z"
        fill="currentColor"
      />
      <path
        d="M28.6196 5.3501L25.8362 4.70009C20.2696 3.38343 16.9529 4.46676 15.0029 8.50009C14.5029 9.51676 14.1029 10.7501 13.7696 12.1668L12.1362 19.1501C10.5029 26.1168 12.6529 29.5501 19.6029 31.2001L22.4029 31.8668C23.3696 32.1001 24.2696 32.2501 25.1029 32.3168C30.3029 32.8168 33.0696 30.3834 34.4696 24.3668L36.1029 17.4001C37.7362 10.4334 35.6029 6.98343 28.6196 5.3501ZM25.4862 22.2168C25.3362 22.7834 24.8362 23.1501 24.2696 23.1501C24.1696 23.1501 24.0696 23.1334 23.9529 23.1168L19.1029 21.8834C18.4362 21.7168 18.0362 21.0334 18.2029 20.3668C18.3696 19.7001 19.0529 19.3001 19.7196 19.4668L24.5696 20.7001C25.2529 20.8668 25.6529 21.5501 25.4862 22.2168ZM30.3696 16.5834C30.2196 17.1501 29.7196 17.5168 29.1529 17.5168C29.0529 17.5168 28.9529 17.5001 28.8362 17.4834L20.7529 15.4334C20.0862 15.2668 19.6862 14.5834 19.8529 13.9168C20.0196 13.2501 20.7029 12.8501 21.3696 13.0168L29.4529 15.0668C30.1362 15.2168 30.5362 15.9001 30.3696 16.5834Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

const amcIcon = (props: IconProps) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M17.6693 6.91658C17.6693 7.23325 17.4026 7.49992 17.0859 7.49992H15.2026C11.6026 7.49992 8.66927 10.4333 8.66927 14.0332V29.4166C8.66927 29.7332 8.40261 29.9999 8.08594 29.9999H6.91927C4.93594 29.9999 3.33594 28.3999 3.33594 26.4166V6.91658C3.33594 4.93325 4.93594 3.33325 6.91927 3.33325H14.0859C16.0693 3.33325 17.6693 4.93325 17.6693 6.91658Z"
        fill="currentColor"
      />
      <path
        d="M36.6693 6.91658V26.4166C36.6693 28.3999 35.0693 29.9999 33.0859 29.9999H32.0359C31.7193 29.9999 31.4526 29.7332 31.4526 29.4166V14.0332C31.4526 10.4333 28.5193 7.49992 24.9193 7.49992H22.9193C22.6026 7.49992 22.3359 7.23325 22.3359 6.91658C22.3359 4.93325 23.9359 3.33325 25.9193 3.33325H33.0859C35.0693 3.33325 36.6693 4.93325 36.6693 6.91658Z"
        fill="currentColor"
      />
      <path
        d="M24.9141 10H15.1974C12.9641 10 11.1641 11.8 11.1641 14.0333V32.6333C11.1641 34.8667 12.9641 36.6667 15.1974 36.6667H17.9141C18.3807 36.6667 18.7474 36.3 18.7474 35.8333V31.6667C18.7474 30.9833 19.3141 30.4167 19.9974 30.4167C20.6807 30.4167 21.2474 30.9833 21.2474 31.6667V35.8333C21.2474 36.3 21.6141 36.6667 22.0807 36.6667H24.9307C27.1474 36.6667 28.9474 34.8667 28.9474 32.65V14.0333C28.9474 11.8 27.1474 10 24.9141 10ZM23.3307 24.5833H16.6641C15.9807 24.5833 15.4141 24.0167 15.4141 23.3333C15.4141 22.65 15.9807 22.0833 16.6641 22.0833H23.3307C24.0141 22.0833 24.5807 22.65 24.5807 23.3333C24.5807 24.0167 24.0141 24.5833 23.3307 24.5833ZM23.3307 19.5833H16.6641C15.9807 19.5833 15.4141 19.0167 15.4141 18.3333C15.4141 17.65 15.9807 17.0833 16.6641 17.0833H23.3307C24.0141 17.0833 24.5807 17.65 24.5807 18.3333C24.5807 19.0167 24.0141 19.5833 23.3307 19.5833Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

const rightCurlyBGIcon = (props: IconProps) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M35.9354 17.8999L33.6688 15.2666C33.2354 14.7666 32.8854 13.8333 32.8854 13.1666V10.3333C32.8854 8.5666 31.4354 7.1166 29.6687 7.1166H26.8354C26.1854 7.1166 25.2354 6.7666 24.7354 6.33327L22.1021 4.0666C20.9521 3.08327 19.0688 3.08327 17.9021 4.0666L15.2854 6.34993C14.7854 6.7666 13.8354 7.1166 13.1854 7.1166H10.3021C8.53542 7.1166 7.08542 8.5666 7.08542 10.3333V13.1833C7.08542 13.8333 6.73542 14.7666 6.31875 15.2666L4.06875 17.9166C3.10208 19.0666 3.10208 20.9333 4.06875 22.0833L6.31875 24.7333C6.73542 25.2333 7.08542 26.1666 7.08542 26.8166V29.6666C7.08542 31.4333 8.53542 32.8833 10.3021 32.8833H13.1854C13.8354 32.8833 14.7854 33.2333 15.2854 33.6666L17.9188 35.9333C19.0688 36.9166 20.9521 36.9166 22.1188 35.9333L24.7521 33.6666C25.2521 33.2333 26.1854 32.8833 26.8521 32.8833H29.6854C31.4521 32.8833 32.9021 31.4333 32.9021 29.6666V26.8333C32.9021 26.1833 33.2521 25.2333 33.6854 24.7333L35.9521 22.0999C36.9188 20.9499 36.9188 19.0499 35.9354 17.8999ZM26.9354 16.8499L18.8854 24.8999C18.6521 25.1333 18.3354 25.2666 18.0021 25.2666C17.6688 25.2666 17.3521 25.1333 17.1188 24.8999L13.0854 20.8666C12.6021 20.3833 12.6021 19.5833 13.0854 19.0999C13.5688 18.6166 14.3687 18.6166 14.8521 19.0999L18.0021 22.2499L25.1688 15.0833C25.6521 14.5999 26.4521 14.5999 26.9354 15.0833C27.4188 15.5666 27.4188 16.3666 26.9354 16.8499Z"
        fill="currentColor"
      />
    </g>
  </svg>
);

const dayIcon = (props: IconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.0013 12.3307C10.3945 12.3307 12.3346 10.3906 12.3346 7.9974C12.3346 5.60416 10.3945 3.66406 8.0013 3.66406C5.60807 3.66406 3.66797 5.60416 3.66797 7.9974C3.66797 10.3906 5.60807 12.3307 8.0013 12.3307Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.7587 12.7626L12.672 12.6759M12.672 3.32927L12.7587 3.2426L12.672 3.32927ZM3.2387 12.7626L3.32536 12.6759L3.2387 12.7626ZM7.9987 1.38927V1.33594V1.38927ZM7.9987 14.6693V14.6159V14.6693ZM1.38536 8.0026H1.33203H1.38536ZM14.6654 8.0026H14.612H14.6654ZM3.32536 3.32927L3.2387 3.2426L3.32536 3.32927Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const eveningIcon = (props: IconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.5996 9.30975C14.7796 10.4231 14.4663 11.6164 13.513 12.4564C12.853 13.0631 11.9863 13.3964 11.0863 13.3897H3.69297C0.579636 13.1631 0.572969 8.62975 3.69297 8.40308H3.7263C2.2663 4.31641 6.05964 1.91641 8.91964 2.83641"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.8399 8.67177C4.49323 8.49844 4.11323 8.4051 3.72656 8.39844"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.6471 5.66927C14.6471 6.4026 14.3071 7.0626 13.7671 7.48927C13.3738 7.80927 12.8605 8.0026 12.3138 8.0026C11.0271 8.0026 9.98047 6.95594 9.98047 5.66927C9.98047 5.02927 10.2405 4.44927 10.6671 4.02927V4.0226C11.0871 3.59594 11.6738 3.33594 12.3138 3.33594C13.6005 3.33594 14.6471 4.3826 14.6471 5.66927Z"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const rangeBarCustomIcon = (props: IconProps) => (
  <svg
    width="88"
    height="88"
    viewBox="0 0 88 88"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="44"
      cy="44"
      r="43"
      fill="#ffffff"
      stroke="var(--primary)"
      strokeWidth="2"
    />
    <path d="M37 32L22 44L37 56V32Z" fill="var(--primary)" />
    <path d="M51 32L66 44L51 56V32Z" fill="var(--primary)" />
  </svg>
);

const rangeBarCustomIconV2 = (props: IconProps) => (
  <svg
    width="88"
    height="88"
    viewBox="0 0 88 88"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle
      cx="44"
      cy="44"
      r="43"
      fill="#FFFFFF"
      stroke="#0047B8"
      strokeWidth="2"
    />
    <path d="M37 32L22 44L37 56V32Z" fill="#2352A4" />
    <path d="M51 32L66 44L51 56V32Z" fill="#2352A4" />
  </svg>
);

const limitedICon = (props: IconProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.9987 14.6693C11.6806 14.6693 14.6654 11.6845 14.6654 8.0026C14.6654 4.32071 11.6806 1.33594 7.9987 1.33594C4.3168 1.33594 1.33203 4.32071 1.33203 8.0026C1.33203 11.6845 4.3168 14.6693 7.9987 14.6693Z"
      stroke="#6A7282"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10.6667V8"
      stroke="#6A7282"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 5.33594H8.00667"
      stroke="#6A7282"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const doubleChevronIcon = (props: IconProps) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2.5 6.69995L6.03 10.22L9.56 6.69995"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      opacity="0.5"
      d="M2.5 1.69995L6.03 5.21995L9.56 1.69995"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const reuploadIcon = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.4068 4.23333C11.6818 4.01667 10.8818 3.875 9.99844 3.875C6.00677 3.875 2.77344 7.10833 2.77344 11.1C2.77344 15.1 6.00677 18.3333 9.99844 18.3333C13.9901 18.3333 17.2234 15.1 17.2234 11.1083C17.2234 9.625 16.7734 8.24167 16.0068 7.09167"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.4435 4.43366L11.0352 1.66699"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.4411 4.43359L10.6328 6.48359"
      stroke="white"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const bottomNaveSupportIcon = (props: IconProps) => (
  <svg
    width="26"
    height="26"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.2001 19.5996C15.4919 19.5996 15.7721 19.7156 15.9784 19.9219C16.1847 20.1282 16.3007 20.4085 16.3007 20.7002C16.3007 21.5752 15.9526 22.4144 15.3339 23.0332C14.715 23.6521 13.8752 24 12.9999 24C12.1246 24 11.2849 23.6521 10.6659 23.0332C10.0472 22.4144 9.6992 21.5752 9.69915 20.7002C9.69919 20.4308 9.79842 20.1701 9.97747 19.9688C10.1565 19.7676 10.4033 19.6389 10.6708 19.6074L10.7997 19.5996H15.2001ZM12.9999 6.40039C14.3852 6.4004 15.7355 6.83565 16.8593 7.64551C17.9832 8.45546 18.8236 9.59895 19.2617 10.9131C19.6997 12.2271 19.7137 13.6457 19.3007 14.9678C18.8876 16.29 18.0682 17.4491 16.9599 18.2803C16.8084 18.3939 16.6301 18.4666 16.4423 18.4912L16.3007 18.5H13.4208V15.6602C13.6435 15.6913 13.8686 15.7076 14.0937 15.71C14.4567 15.7265 14.8197 15.6744 15.1611 15.5557C15.5025 15.4368 15.8159 15.2541 16.082 15.0186C17.3993 13.7928 16.9185 11.4218 16.8974 11.3213C16.8868 11.27 16.8654 11.2213 16.8349 11.1777C16.8042 11.134 16.7647 11.0956 16.7187 11.0664C16.6727 11.0373 16.6206 11.0179 16.5663 11.0078C16.5122 10.9977 16.4564 10.9974 16.4023 11.0078C14.5931 11.3518 13.5248 12.9825 12.9999 14.0732C12.475 12.9825 11.4068 11.3516 9.59759 11.0078C9.54348 10.9974 9.48771 10.9977 9.43353 11.0078C9.37926 11.0179 9.32721 11.0382 9.28118 11.0674C9.23534 11.0965 9.19559 11.1342 9.16497 11.1777C9.13449 11.2212 9.11315 11.27 9.10247 11.3213C9.08143 11.4217 8.60068 13.7928 9.9179 15.0186C10.184 15.2541 10.4974 15.4368 10.8388 15.5557C11.1801 15.6744 11.5431 15.7265 11.9062 15.71C12.1313 15.7076 12.3563 15.6913 12.579 15.6602V18.5H9.69915C9.46124 18.4999 9.22933 18.423 9.039 18.2803C7.93077 17.4491 7.11221 16.2899 6.69915 14.9678C6.28614 13.6456 6.30016 12.2271 6.73822 10.9131C7.17631 9.59895 8.01668 8.45546 9.14056 7.64551C10.2644 6.83568 11.6147 6.40039 12.9999 6.40039ZM4.19915 11.9004C4.47946 11.9008 4.74923 12.0078 4.95306 12.2002C5.15688 12.3927 5.2794 12.6557 5.29583 12.9355C5.31226 13.2154 5.22092 13.4911 5.04095 13.7061C4.86107 13.9208 4.60626 14.0596 4.32806 14.0928L4.19915 14.0996H3.09857C2.81824 14.0992 2.5485 13.9922 2.34466 13.7998C2.14083 13.6073 2.01832 13.3443 2.00189 13.0645C1.98546 12.7846 2.0768 12.5089 2.25677 12.2939C2.43666 12.0792 2.69145 11.9404 2.96966 11.9072L3.09857 11.9004H4.19915ZM22.9013 11.9004C23.1816 11.9008 23.4514 12.0078 23.6552 12.2002C23.859 12.3926 23.9816 12.6557 23.998 12.9355C24.0144 13.2154 23.9231 13.4911 23.7431 13.7061C23.5631 13.921 23.3076 14.0597 23.0292 14.0928L22.9013 14.0996H21.8007C21.5204 14.0993 21.2507 13.9922 21.0468 13.7998C20.843 13.6073 20.7205 13.3443 20.704 13.0645C20.6876 12.7846 20.7789 12.5089 20.9589 12.2939C21.1388 12.0792 21.3936 11.9404 21.6718 11.9072L21.8007 11.9004H22.9013ZM5.89056 4.8623C6.15777 4.84561 6.42217 4.92673 6.63372 5.09082L6.73724 5.18262L7.50677 5.95215C7.70407 6.1501 7.81855 6.41597 7.82708 6.69531C7.83559 6.97461 7.73749 7.24646 7.55267 7.45605C7.36781 7.66568 7.11021 7.79772 6.83197 7.82422C6.55376 7.85068 6.2757 7.76956 6.05462 7.59863L5.95111 7.50781L5.18157 6.7373C4.97537 6.53103 4.85931 6.25161 4.85931 5.95996C4.85932 5.6683 4.97536 5.38889 5.18157 5.18262C5.37101 4.99322 5.6232 4.87911 5.89056 4.8623ZM20.0058 4.8623C20.2852 4.85377 20.5579 4.95188 20.7675 5.13672C20.9769 5.32153 21.1082 5.5794 21.1347 5.85742C21.1611 6.13553 21.081 6.41376 20.9101 6.63477L20.8183 6.7373L20.0488 7.50781C19.8508 7.70504 19.5849 7.81953 19.3056 7.82812C19.0262 7.83666 18.7535 7.73855 18.5439 7.55371C18.3343 7.36891 18.2032 7.11112 18.1767 6.83301C18.1502 6.55482 18.2304 6.27675 18.4013 6.05566L18.4931 5.95215L19.2626 5.18262C19.4606 4.98535 19.7264 4.87085 20.0058 4.8623ZM12.9999 2C13.2694 2.00005 13.5291 2.09932 13.7304 2.27832C13.9318 2.45736 14.0612 2.7041 14.0927 2.97168L14.0995 3.09961V4.2002C14.0992 4.48049 13.9922 4.75028 13.7997 4.9541C13.6073 5.15787 13.3442 5.28044 13.0644 5.29688C12.7845 5.31331 12.5089 5.22194 12.2939 5.04199C12.079 4.86213 11.9404 4.60733 11.9072 4.3291L11.8993 4.2002V3.09961C11.8995 2.80811 12.0155 2.52844 12.2216 2.32227C12.4279 2.11598 12.7082 2 12.9999 2Z"
      fill="currentColor"
    />
  </svg>
);

const minusWithBracketsIcon = (props: IconProps) => (
  <svg
    width="24"
    height="23"
    viewBox="0 0 24 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.341974 11.1364C0.341974 8.98864 0.620384 7.0142 1.1772 5.21307C1.7397 3.40625 2.54084 1.74432 3.58061 0.227272H5.35334C4.94425 0.789772 4.56072 1.48295 4.20277 2.30682C3.8505 3.125 3.54084 4.02557 3.27379 5.00852C3.00675 5.9858 2.79652 6.99716 2.64311 8.04261C2.49538 9.08807 2.42152 10.1193 2.42152 11.1364C2.42152 12.4886 2.5522 13.8608 2.81357 15.2528C3.07493 16.6449 3.4272 17.9375 3.87038 19.1307C4.31357 20.3239 4.80788 21.2955 5.35334 22.0455H3.58061C2.54084 20.5284 1.7397 18.8693 1.1772 17.0682C0.620384 15.2614 0.341974 13.2841 0.341974 11.1364ZM15.8214 10.0795V11.9545H8.18501V10.0795H15.8214ZM23.6559 11.1364C23.6559 13.2841 23.3746 15.2614 22.8121 17.0682C22.2553 18.8693 21.457 20.5284 20.4173 22.0455H18.6445C19.0536 21.483 19.4343 20.7898 19.7866 19.9659C20.1445 19.1477 20.457 18.25 20.7241 17.2727C20.9911 16.2898 21.1985 15.2756 21.3462 14.2301C21.4996 13.179 21.5763 12.1477 21.5763 11.1364C21.5763 9.78409 21.4457 8.41193 21.1843 7.01989C20.9229 5.62784 20.5707 4.33523 20.1275 3.14204C19.6843 1.94886 19.19 0.977272 18.6445 0.227272H20.4173C21.457 1.74432 22.2553 3.40625 22.8121 5.21307C23.3746 7.0142 23.6559 8.98864 23.6559 11.1364Z"
      fill="currentColor"
    />
  </svg>
);

const bookIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 16.7387V4.66872C22 3.46872 21.02 2.57872 19.83 2.67872H19.77C17.67 2.85872 14.48 3.92872 12.7 5.04872L12.53 5.15872C12.24 5.33872 11.76 5.33872 11.47 5.15872L11.22 5.00872C9.44 3.89872 6.26 2.83872 4.16 2.66872C2.97 2.56872 2 3.46872 2 4.65872V16.7387C2 17.6987 2.78 18.5987 3.74 18.7187L4.03 18.7587C6.2 19.0487 9.55 20.1487 11.47 21.1987L11.51 21.2187C11.78 21.3687 12.21 21.3687 12.47 21.2187C14.39 20.1587 17.75 19.0487 19.93 18.7587L20.26 18.7187C21.22 18.5987 22 17.6987 22 16.7387Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 5.49121V20.4912"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.75 8.49121H5.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 11.4912H5.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const calendarIconV2 = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8 2.00098V5.00098"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 2.00098V5.00098"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 3.50098C19.33 3.68098 21 4.95098 21 9.65098V15.831C21 19.951 20 22.011 15 22.011H9C4 22.011 3 19.951 3 15.831V9.65098C3 4.95098 4.67 3.69098 8 3.50098H16Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M20.75 17.5996H3.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 8.25C10.77 8.25 9.73 8.92 9.73 10.22C9.73 10.84 10.02 11.31 10.46 11.61C9.85 11.97 9.5 12.55 9.5 13.23C9.5 14.47 10.45 15.24 12 15.24C13.54 15.24 14.5 14.47 14.5 13.23C14.5 12.55 14.15 11.96 13.53 11.61C13.98 11.3 14.26 10.84 14.26 10.22C14.26 8.92 13.23 8.25 12 8.25ZM12 11.09C11.48 11.09 11.1 10.78 11.1 10.29C11.1 9.79 11.48 9.5 12 9.5C12.52 9.5 12.9 9.79 12.9 10.29C12.9 10.78 12.52 11.09 12 11.09ZM12 14C11.34 14 10.86 13.67 10.86 13.07C10.86 12.47 11.34 12.15 12 12.15C12.66 12.15 13.14 12.48 13.14 13.07C13.14 13.67 12.66 14 12 14Z"
      fill="currentColor"
    />
  </svg>
);

const vehicleIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15.51 2.83008H8.49C6 2.83008 5.45 4.07008 5.13 5.59008L4 11.0001H20L18.87 5.59008C18.55 4.07008 18 2.83008 15.51 2.83008Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.9888 19.82C22.0988 20.99 21.1588 22 19.9588 22H18.0788C16.9988 22 16.8488 21.54 16.6588 20.97L16.4588 20.37C16.1788 19.55 15.9988 19 14.5588 19H9.43876C7.99876 19 7.78876 19.62 7.53876 20.37L7.33876 20.97C7.14876 21.54 6.99876 22 5.91876 22H4.03876C2.83876 22 1.89876 20.99 2.00876 19.82L2.56876 13.73C2.70876 12.23 2.99876 11 5.61876 11H18.3788C20.9988 11 21.2888 12.23 21.4288 13.73L21.9888 19.82Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4 8H3"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21 8H20"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 3V5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.5 5H13.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6 15H9"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 15H18"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const devicesIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10 16.9503H6.21C2.84 16.9503 2 16.1103 2 12.7403V6.74027C2 3.37027 2.84 2.53027 6.21 2.53027H16.74C20.11 2.53027 20.95 3.37027 20.95 6.74027"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10 21.4702V16.9502"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2 12.9502H10"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.74219 21.4697H10.0022"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.0013 12.7998V18.5098C22.0013 20.8798 21.4113 21.4698 19.0413 21.4698H15.4913C13.1213 21.4698 12.5312 20.8798 12.5312 18.5098V12.7998C12.5312 10.4298 13.1213 9.83984 15.4913 9.83984H19.0413C21.4113 9.83984 22.0013 10.4298 22.0013 12.7998Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.2445 18.25H17.2535"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const doubleHeartsIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M19.86 8.0896C19.86 8.5096 19.83 8.9196 19.78 9.3096C19.32 9.1096 18.82 8.9996 18.29 8.9996C17.07 8.9996 15.99 9.58959 15.32 10.4896C14.64 9.58959 13.56 8.9996 12.34 8.9996C10.29 8.9996 8.63 10.6696 8.63 12.7396C8.63 15.4196 10.05 17.4696 11.63 18.8596C11.58 18.8896 11.53 18.8996 11.48 18.9196C11.18 19.0296 10.68 19.0296 10.38 18.9196C7.79 18.0296 2 14.3496 2 8.0896C2 5.3296 4.21999 3.09961 6.95999 3.09961C8.58999 3.09961 10.03 3.8796 10.93 5.0896C11.84 3.8796 13.28 3.09961 14.9 3.09961C17.64 3.09961 19.86 5.3296 19.86 8.0896Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.0028 12.74C22.0028 17.42 17.6728 20.18 15.7328 20.84C15.5028 20.92 15.1328 20.92 14.9028 20.84C14.0728 20.56 12.8028 19.89 11.6328 18.86C10.0528 17.47 8.63281 15.42 8.63281 12.74C8.63281 10.67 10.2928 9 12.3428 9C13.5628 9 14.6428 9.58999 15.3228 10.49C15.9928 9.58999 17.0728 9 18.2928 9C18.8228 9 19.3228 9.11 19.7828 9.31C21.0928 9.89 22.0028 11.2 22.0028 12.74Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const buildingIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1 22H23"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.7812 22.0098V17.5498"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19.8016 10.8896C18.5816 10.8896 17.6016 11.8697 17.6016 13.0897V15.3596C17.6016 16.5796 18.5816 17.5596 19.8016 17.5596C21.0216 17.5596 22.0016 16.5796 22.0016 15.3596V13.0897C22.0016 11.8697 21.0216 10.8896 19.8016 10.8896Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M2.10156 21.9998V6.02979C2.10156 4.01979 3.10161 3.00977 5.09161 3.00977H11.3216C13.3116 3.00977 14.3016 4.01979 14.3016 6.02979V21.9998"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.79688 8.25H10.7469"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.79688 12H10.7469"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.25 22V18.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const documentListIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.5 18V7C3.5 3 4.5 2 8.5 2H15.5C19.5 2 20.5 3 20.5 7V17C20.5 17.14 20.5 17.28 20.49 17.42"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.35 15H20.5V18.5C20.5 20.43 18.93 22 17 22H7C5.07 22 3.5 20.43 3.5 18.5V17.85C3.5 16.28 4.78 15 6.35 15Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 7H16"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 10.5H13"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const externalLinkIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13 11L21.2 2.8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M21.9992 6.8V2H17.1992"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15V13"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const locationIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M20.6211 8.45C19.5711 3.83 15.5411 1.75 12.0011 1.75C12.0011 1.75 12.0011 1.75 11.9911 1.75C8.46107 1.75 4.42107 3.82 3.37107 8.44C2.20107 13.6 5.36107 17.97 8.22107 20.72C9.28107 21.74 10.6411 22.25 12.0011 22.25C13.3611 22.25 14.7211 21.74 15.7711 20.72C18.6311 17.97 21.7911 13.61 20.6211 8.45ZM12.0011 13.46C10.2611 13.46 8.85107 12.05 8.85107 10.31C8.85107 8.57 10.2611 7.16 12.0011 7.16C13.7411 7.16 15.1511 8.57 15.1511 10.31C15.1511 12.05 13.7411 13.46 12.0011 13.46Z"
      fill="currentColor"
    />
  </svg>
);

const cirlcedRightIcon = (props: IconProps) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.1669 8.33351C18.5474 10.2013 18.2762 12.143 17.3984 13.835C16.5206 15.527 15.0893 16.8669 13.3431 17.6313C11.597 18.3957 9.64154 18.5383 7.80293 18.0355C5.96433 17.5326 4.35368 16.4147 3.23958 14.868C2.12548 13.3214 1.57529 11.4395 1.68074 9.53633C1.78619 7.63312 2.54092 5.82358 3.81906 4.40948C5.0972 2.99538 6.8215 2.0622 8.7044 1.76555C10.5873 1.4689 12.515 1.82672 14.166 2.77934M7.49967 9.16644L9.99967 11.6664L18.333 3.33311"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const messageIcon = (props: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M8.5 19H8C4 19 2 18 2 13V8C2 4 4 2 8 2H16C20 2 22 4 22 8V13C22 17 20 19 16 19H15.5C15.19 19 14.89 19.15 14.7 19.4L13.2 21.4C12.54 22.28 11.46 22.28 10.8 21.4L9.3 19.4C9.14 19.18 8.77 19 8.5 19Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15.9965 11H16.0054"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11.9955 11H12.0045"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.99451 11H8.00349"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const Icon = {
  clockIcon,
  messageIcon,
  locationIcon,
  externalLinkIcon,
  whatsappIconV4,
  downloadIcon,
  rightShieldICon,
  pieChartICon,
  mysipLogoIconv1,
  headerLogoIcon,
  rangeBarCustomIcon,
  rangeBarCustomIconV2,
  dayIcon,
  eveningIcon,
  headerDiwaliLogoIcon,
  mysipIcon,
  phoneIconV1,
  emailIconV1,
  lockIconV1,
  lockIconV2,
  lockIconV3,
  lockIconV4,
  headerNewLogoIcon,
  errorWarningIcon,
  errorWarningFilledIcon,
  mutualFundIcon,
  logoIcon,
  logoIconV1,
  doubleChevronIcon,
  blogIcon,
  calendarIcon,
  googleMeetIcon,
  savedFundIcon,
  unSavedFundIcon,
  sharedFundIcon,
  sharedFundIconV2,
  boxLeftSlidIcon,
  videoIcon,
  ytVideoIcon,
  ytVideoFilledIcon,
  closeSearchIcon,
  googleIcon,
  facebook,
  openEyeIcon,
  closeEyeIcon,
  loginBackBtn,
  ytBtnIcon,
  addPlusIcon,
  viewEyeIcon,
  leftRightArrowIcon,
  durationIcon,
  feedBackFilledStar,
  buttonLoaderSecondary,
  filterBtnIcon,
  searchIcon,
  searchIcon2,
  facebookIcon,
  linkedinIcon,
  twitterIcon,
  youtubeIcon,
  instagramIcon,
  headerSearchIcon,
  whatsappIconV3,
  headerSearchIcon2,
  headerCartIcon,
  headerProfileIcon,
  headerDrawerIcon,
  popupCloseIcon,
  facebookIconColored,
  linkedinIconColored,
  twitterIconColored,
  downloadPdfIconColored,
  savedBlogIconColored,
  copyLinkIconColored,
  viewEyeIconColored,
  commentProfileIcon,
  whatsAppIcon,
  dropdownDownArrow,
  rightArrow,
  infoIcon,
  upRightArrowIcon,
  expandableIcon,
  bottomNaveHomeIcon,
  bottomNaveExploreIcon,
  bottomNaveDashboardIcon,
  bottomNavePremiumIcon,
  bottomNaveProfileIcon,
  bottomNaveSupportIcon,
  toastDefaultIcon,
  toastSuccessIcon,
  toastPendingIcon,
  toastFailedIcon,
  whatsappIconV2,
  callIconV2,
  queryIconV2,
  emailIconV2,
  emailIconV3,
  supportIconV1,
  supportIconV2,
  userProfileIconV1,
  cardIconV1,
  doubleArrow,
  refreshIcon,
  rightSignIcon,
  sipTabIcon,
  callIconV3,
  indianflagIcon,
  growthSVG,
  crossIcon,
  ratingStarIcon,
  stripStarIcon,
  stripCursorIcon,
  editIcon,
  fileTextIcon,
  mailIcon,
  addFileIcon,
  pdfFileIconV2,
  plantIcon,
  scanIcon,
  diamondIcon,
  disableIcon,
  wrongIcon,
  portfolioRightIcon,
  handHeartIcon,
  shieldIcon,
  disableIcon2,
  playIcon,
  pulseIcon,
  allocationIcon,
  calenderIcon2,
  youtubeBellIcon,
  ytBtnIconV2,
  crowdIcon,
  fileIcon,
  amcIcon,
  rightCurlyBGIcon,
  limitedICon,
  feedBackFilledStarV2,
  reuploadIcon,
  heartLikeIcon,
  deletIcon,
  minusWithBracketsIcon,
  bookIcon,
  calendarIconV2,
  vehicleIcon,
  devicesIcon,
  doubleHeartsIcon,
  buildingIcon,
  documentListIcon,
  cirlcedRightIcon,
  emailIconV4,
};

export default Icon;
